!function(i){"use strict";"function"==typeof define&&define.amd?define(["jquery"],i):"undefined"!=typeof exports?module.exports=i(require("jquery")):i(jQuery)}(function(i){"use strict";var e=window.Slick||{};(e=function(){var e=0;return function(t,o){var s,n=this;n.defaults={accessibility:!0,adaptiveHeight:!1,appendArrows:i(t),appendDots:i(t),arrows:!0,asNavFor:null,prevArrow:'<button class="slick-prev" aria-label="Previous" type="button">Previous</button>',nextArrow:'<button class="slick-next" aria-label="Next" type="button">Next</button>',autoplay:!1,autoplaySpeed:3e3,centerMode:!1,centerPadding:"50px",cssEase:"ease",customPaging:function(e,t){return i('<button type="button" />').text(t+1)},dots:!1,dotsClass:"slick-dots",draggable:!0,easing:"linear",edgeFriction:.35,fade:!1,focusOnSelect:!1,focusOnChange:!1,infinite:!0,initialSlide:0,lazyLoad:"ondemand",mobileFirst:!1,pauseOnHover:!0,pauseOnFocus:!0,pauseOnDotsHover:!1,respondTo:"window",responsive:null,rows:1,rtl:!1,slide:"",slidesPerRow:1,slidesToShow:1,slidesToScroll:1,speed:500,swipe:!0,swipeToSlide:!1,touchMove:!0,touchThreshold:5,useCSS:!0,useTransform:!0,variableWidth:!1,vertical:!1,verticalSwiping:!1,waitForAnimate:!0,zIndex:1e3},n.initials={animating:!1,dragging:!1,autoPlayTimer:null,currentDirection:0,currentLeft:null,currentSlide:0,direction:1,$dots:null,listWidth:null,listHeight:null,loadIndex:0,$nextArrow:null,$prevArrow:null,scrolling:!1,slideCount:null,slideWidth:null,$slideTrack:null,$slides:null,sliding:!1,slideOffset:0,swipeLeft:null,swiping:!1,$list:null,touchObject:{},transformsEnabled:!1,unslicked:!1},i.extend(n,n.initials),n.activeBreakpoint=null,n.animType=null,n.animProp=null,n.breakpoints=[],n.breakpointSettings=[],n.cssTransitions=!1,n.focussed=!1,n.interrupted=!1,n.hidden="hidden",n.paused=!0,n.positionProp=null,n.respondTo=null,n.rowCount=1,n.shouldClick=!0,n.$slider=i(t),n.$slidesCache=null,n.transformType=null,n.transitionType=null,n.visibilityChange="visibilitychange",n.windowWidth=0,n.windowTimer=null,s=i(t).data("slick")||{},n.options=i.extend({},n.defaults,o,s),n.currentSlide=n.options.initialSlide,n.originalSettings=n.options,void 0!==document.mozHidden?(n.hidden="mozHidden",n.visibilityChange="mozvisibilitychange"):void 0!==document.webkitHidden&&(n.hidden="webkitHidden",n.visibilityChange="webkitvisibilitychange"),n.autoPlay=i.proxy(n.autoPlay,n),n.autoPlayClear=i.proxy(n.autoPlayClear,n),n.autoPlayIterator=i.proxy(n.autoPlayIterator,n),n.changeSlide=i.proxy(n.changeSlide,n),n.clickHandler=i.proxy(n.clickHandler,n),n.selectHandler=i.proxy(n.selectHandler,n),n.setPosition=i.proxy(n.setPosition,n),n.swipeHandler=i.proxy(n.swipeHandler,n),n.dragHandler=i.proxy(n.dragHandler,n),n.keyHandler=i.proxy(n.keyHandler,n),n.instanceUid=e++,n.htmlExpr=/^(?:\s*(<[\w\W]+>)[^>]*)$/,n.registerBreakpoints(),n.init(!0)}}()).prototype.activateADA=function(){this.$slideTrack.find(".slick-active").attr({"aria-hidden":"false"}).find("a, input, button, select").attr({tabindex:"0"})},e.prototype.addSlide=e.prototype.slickAdd=function(e,t,o){var s=this;if("boolean"==typeof t)o=t,t=null;else if(t<0||t>=s.slideCount)return!1;s.unload(),"number"==typeof t?0===t&&0===s.$slides.length?i(e).appendTo(s.$slideTrack):o?i(e).insertBefore(s.$slides.eq(t)):i(e).insertAfter(s.$slides.eq(t)):!0===o?i(e).prependTo(s.$slideTrack):i(e).appendTo(s.$slideTrack),s.$slides=s.$slideTrack.children(this.options.slide),s.$slideTrack.children(this.options.slide).detach(),s.$slideTrack.append(s.$slides),s.$slides.each(function(e,t){i(t).attr("data-slick-index",e)}),s.$slidesCache=s.$slides,s.reinit()},e.prototype.animateHeight=function(){var i=this;if(1===i.options.slidesToShow&&!0===i.options.adaptiveHeight&&!1===i.options.vertical){var e=i.$slides.eq(i.currentSlide).outerHeight(!0);i.$list.animate({height:e},i.options.speed)}},e.prototype.animateSlide=function(e,t){var o={},s=this;s.animateHeight(),!0===s.options.rtl&&!1===s.options.vertical&&(e=-e),!1===s.transformsEnabled?!1===s.options.vertical?s.$slideTrack.animate({left:e},s.options.speed,s.options.easing,t):s.$slideTrack.animate({top:e},s.options.speed,s.options.easing,t):!1===s.cssTransitions?(!0===s.options.rtl&&(s.currentLeft=-s.currentLeft),i({animStart:s.currentLeft}).animate({animStart:e},{duration:s.options.speed,easing:s.options.easing,step:function(i){i=Math.ceil(i),!1===s.options.vertical?(o[s.animType]="translate("+i+"px, 0px)",s.$slideTrack.css(o)):(o[s.animType]="translate(0px,"+i+"px)",s.$slideTrack.css(o))},complete:function(){t&&t.call()}})):(s.applyTransition(),e=Math.ceil(e),!1===s.options.vertical?o[s.animType]="translate3d("+e+"px, 0px, 0px)":o[s.animType]="translate3d(0px,"+e+"px, 0px)",s.$slideTrack.css(o),t&&setTimeout(function(){s.disableTransition(),t.call()},s.options.speed))},e.prototype.getNavTarget=function(){var e=this,t=e.options.asNavFor;return t&&null!==t&&(t=i(t).not(e.$slider)),t},e.prototype.asNavFor=function(e){var t=this.getNavTarget();null!==t&&"object"==typeof t&&t.each(function(){var t=i(this).slick("getSlick");t.unslicked||t.slideHandler(e,!0)})},e.prototype.applyTransition=function(i){var e=this,t={};!1===e.options.fade?t[e.transitionType]=e.transformType+" "+e.options.speed+"ms "+e.options.cssEase:t[e.transitionType]="opacity "+e.options.speed+"ms "+e.options.cssEase,!1===e.options.fade?e.$slideTrack.css(t):e.$slides.eq(i).css(t)},e.prototype.autoPlay=function(){var i=this;i.autoPlayClear(),i.slideCount>i.options.slidesToShow&&(i.autoPlayTimer=setInterval(i.autoPlayIterator,i.options.autoplaySpeed))},e.prototype.autoPlayClear=function(){var i=this;i.autoPlayTimer&&clearInterval(i.autoPlayTimer)},e.prototype.autoPlayIterator=function(){var i=this,e=i.currentSlide+i.options.slidesToScroll;i.paused||i.interrupted||i.focussed||(!1===i.options.infinite&&(1===i.direction&&i.currentSlide+1===i.slideCount-1?i.direction=0:0===i.direction&&(e=i.currentSlide-i.options.slidesToScroll,i.currentSlide-1==0&&(i.direction=1))),i.slideHandler(e))},e.prototype.buildArrows=function(){var e=this;!0===e.options.arrows&&(e.$prevArrow=i(e.options.prevArrow).addClass("slick-arrow"),e.$nextArrow=i(e.options.nextArrow).addClass("slick-arrow"),e.slideCount>e.options.slidesToShow?(e.$prevArrow.removeClass("slick-hidden").removeAttr("aria-hidden tabindex"),e.$nextArrow.removeClass("slick-hidden").removeAttr("aria-hidden tabindex"),e.htmlExpr.test(e.options.prevArrow)&&e.$prevArrow.prependTo(e.options.appendArrows),e.htmlExpr.test(e.options.nextArrow)&&e.$nextArrow.appendTo(e.options.appendArrows),!0!==e.options.infinite&&e.$prevArrow.addClass("slick-disabled").attr("aria-disabled","true")):e.$prevArrow.add(e.$nextArrow).addClass("slick-hidden").attr({"aria-disabled":"true",tabindex:"-1"}))},e.prototype.buildDots=function(){var e,t,o=this;if(!0===o.options.dots){for(o.$slider.addClass("slick-dotted"),t=i("<ul />").addClass(o.options.dotsClass),e=0;e<=o.getDotCount();e+=1)t.append(i("<li />").append(o.options.customPaging.call(this,o,e)));o.$dots=t.appendTo(o.options.appendDots),o.$dots.find("li").first().addClass("slick-active")}},e.prototype.buildOut=function(){var e=this;e.$slides=e.$slider.children(e.options.slide+":not(.slick-cloned)").addClass("slick-slide"),e.slideCount=e.$slides.length,e.$slides.each(function(e,t){i(t).attr("data-slick-index",e).data("originalStyling",i(t).attr("style")||"")}),e.$slider.addClass("slick-slider"),e.$slideTrack=0===e.slideCount?i('<div class="slick-track"/>').appendTo(e.$slider):e.$slides.wrapAll('<div class="slick-track"/>').parent(),e.$list=e.$slideTrack.wrap('<div class="slick-list"/>').parent(),e.$slideTrack.css("opacity",0),!0!==e.options.centerMode&&!0!==e.options.swipeToSlide||(e.options.slidesToScroll=1),i("img[data-lazy]",e.$slider).not("[src]").addClass("slick-loading"),e.setupInfinite(),e.buildArrows(),e.buildDots(),e.updateDots(),e.setSlideClasses("number"==typeof e.currentSlide?e.currentSlide:0),!0===e.options.draggable&&e.$list.addClass("draggable")},e.prototype.buildRows=function(){var i,e,t,o,s,n,r,l=this;if(o=document.createDocumentFragment(),n=l.$slider.children(),l.options.rows>1){for(r=l.options.slidesPerRow*l.options.rows,s=Math.ceil(n.length/r),i=0;i<s;i++){var d=document.createElement("div");for(e=0;e<l.options.rows;e++){var a=document.createElement("div");for(t=0;t<l.options.slidesPerRow;t++){var c=i*r+(e*l.options.slidesPerRow+t);n.get(c)&&a.appendChild(n.get(c))}d.appendChild(a)}o.appendChild(d)}l.$slider.empty().append(o),l.$slider.children().children().children().css({width:100/l.options.slidesPerRow+"%",display:"inline-block"})}},e.prototype.checkResponsive=function(e,t){var o,s,n,r=this,l=!1,d=r.$slider.width(),a=window.innerWidth||i(window).width();if("window"===r.respondTo?n=a:"slider"===r.respondTo?n=d:"min"===r.respondTo&&(n=Math.min(a,d)),r.options.responsive&&r.options.responsive.length&&null!==r.options.responsive){s=null;for(o in r.breakpoints)r.breakpoints.hasOwnProperty(o)&&(!1===r.originalSettings.mobileFirst?n<r.breakpoints[o]&&(s=r.breakpoints[o]):n>r.breakpoints[o]&&(s=r.breakpoints[o]));null!==s?null!==r.activeBreakpoint?(s!==r.activeBreakpoint||t)&&(r.activeBreakpoint=s,"unslick"===r.breakpointSettings[s]?r.unslick(s):(r.options=i.extend({},r.originalSettings,r.breakpointSettings[s]),!0===e&&(r.currentSlide=r.options.initialSlide),r.refresh(e)),l=s):(r.activeBreakpoint=s,"unslick"===r.breakpointSettings[s]?r.unslick(s):(r.options=i.extend({},r.originalSettings,r.breakpointSettings[s]),!0===e&&(r.currentSlide=r.options.initialSlide),r.refresh(e)),l=s):null!==r.activeBreakpoint&&(r.activeBreakpoint=null,r.options=r.originalSettings,!0===e&&(r.currentSlide=r.options.initialSlide),r.refresh(e),l=s),e||!1===l||r.$slider.trigger("breakpoint",[r,l])}},e.prototype.changeSlide=function(e,t){var o,s,n,r=this,l=i(e.currentTarget);switch(l.is("a")&&e.preventDefault(),l.is("li")||(l=l.closest("li")),n=r.slideCount%r.options.slidesToScroll!=0,o=n?0:(r.slideCount-r.currentSlide)%r.options.slidesToScroll,e.data.message){case"previous":s=0===o?r.options.slidesToScroll:r.options.slidesToShow-o,r.slideCount>r.options.slidesToShow&&r.slideHandler(r.currentSlide-s,!1,t);break;case"next":s=0===o?r.options.slidesToScroll:o,r.slideCount>r.options.slidesToShow&&r.slideHandler(r.currentSlide+s,!1,t);break;case"index":var d=0===e.data.index?0:e.data.index||l.index()*r.options.slidesToScroll;r.slideHandler(r.checkNavigable(d),!1,t),l.children().trigger("focus");break;default:return}},e.prototype.checkNavigable=function(i){var e,t;if(e=this.getNavigableIndexes(),t=0,i>e[e.length-1])i=e[e.length-1];else for(var o in e){if(i<e[o]){i=t;break}t=e[o]}return i},e.prototype.cleanUpEvents=function(){var e=this;e.options.dots&&null!==e.$dots&&(i("li",e.$dots).off("click.slick",e.changeSlide).off("mouseenter.slick",i.proxy(e.interrupt,e,!0)).off("mouseleave.slick",i.proxy(e.interrupt,e,!1)),!0===e.options.accessibility&&e.$dots.off("keydown.slick",e.keyHandler)),e.$slider.off("focus.slick blur.slick"),!0===e.options.arrows&&e.slideCount>e.options.slidesToShow&&(e.$prevArrow&&e.$prevArrow.off("click.slick",e.changeSlide),e.$nextArrow&&e.$nextArrow.off("click.slick",e.changeSlide),!0===e.options.accessibility&&(e.$prevArrow&&e.$prevArrow.off("keydown.slick",e.keyHandler),e.$nextArrow&&e.$nextArrow.off("keydown.slick",e.keyHandler))),e.$list.off("touchstart.slick mousedown.slick",e.swipeHandler),e.$list.off("touchmove.slick mousemove.slick",e.swipeHandler),e.$list.off("touchend.slick mouseup.slick",e.swipeHandler),e.$list.off("touchcancel.slick mouseleave.slick",e.swipeHandler),e.$list.off("click.slick",e.clickHandler),i(document).off(e.visibilityChange,e.visibility),e.cleanUpSlideEvents(),!0===e.options.accessibility&&e.$list.off("keydown.slick",e.keyHandler),!0===e.options.focusOnSelect&&i(e.$slideTrack).children().off("click.slick",e.selectHandler),i(window).off("orientationchange.slick.slick-"+e.instanceUid,e.orientationChange),i(window).off("resize.slick.slick-"+e.instanceUid,e.resize),i("[draggable!=true]",e.$slideTrack).off("dragstart",e.preventDefault),i(window).off("load.slick.slick-"+e.instanceUid,e.setPosition)},e.prototype.cleanUpSlideEvents=function(){var e=this;e.$list.off("mouseenter.slick",i.proxy(e.interrupt,e,!0)),e.$list.off("mouseleave.slick",i.proxy(e.interrupt,e,!1))},e.prototype.cleanUpRows=function(){var i,e=this;e.options.rows>1&&((i=e.$slides.children().children()).removeAttr("style"),e.$slider.empty().append(i))},e.prototype.clickHandler=function(i){!1===this.shouldClick&&(i.stopImmediatePropagation(),i.stopPropagation(),i.preventDefault())},e.prototype.destroy=function(e){var t=this;t.autoPlayClear(),t.touchObject={},t.cleanUpEvents(),i(".slick-cloned",t.$slider).detach(),t.$dots&&t.$dots.remove(),t.$prevArrow&&t.$prevArrow.length&&(t.$prevArrow.removeClass("slick-disabled slick-arrow slick-hidden").removeAttr("aria-hidden aria-disabled tabindex").css("display",""),t.htmlExpr.test(t.options.prevArrow)&&t.$prevArrow.remove()),t.$nextArrow&&t.$nextArrow.length&&(t.$nextArrow.removeClass("slick-disabled slick-arrow slick-hidden").removeAttr("aria-hidden aria-disabled tabindex").css("display",""),t.htmlExpr.test(t.options.nextArrow)&&t.$nextArrow.remove()),t.$slides&&(t.$slides.removeClass("slick-slide slick-active slick-center slick-visible slick-current").removeAttr("aria-hidden").removeAttr("data-slick-index").each(function(){i(this).attr("style",i(this).data("originalStyling"))}),t.$slideTrack.children(this.options.slide).detach(),t.$slideTrack.detach(),t.$list.detach(),t.$slider.append(t.$slides)),t.cleanUpRows(),t.$slider.removeClass("slick-slider"),t.$slider.removeClass("slick-initialized"),t.$slider.removeClass("slick-dotted"),t.unslicked=!0,e||t.$slider.trigger("destroy",[t])},e.prototype.disableTransition=function(i){var e=this,t={};t[e.transitionType]="",!1===e.options.fade?e.$slideTrack.css(t):e.$slides.eq(i).css(t)},e.prototype.fadeSlide=function(i,e){var t=this;!1===t.cssTransitions?(t.$slides.eq(i).css({zIndex:t.options.zIndex}),t.$slides.eq(i).animate({opacity:1},t.options.speed,t.options.easing,e)):(t.applyTransition(i),t.$slides.eq(i).css({opacity:1,zIndex:t.options.zIndex}),e&&setTimeout(function(){t.disableTransition(i),e.call()},t.options.speed))},e.prototype.fadeSlideOut=function(i){var e=this;!1===e.cssTransitions?e.$slides.eq(i).animate({opacity:0,zIndex:e.options.zIndex-2},e.options.speed,e.options.easing):(e.applyTransition(i),e.$slides.eq(i).css({opacity:0,zIndex:e.options.zIndex-2}))},e.prototype.filterSlides=e.prototype.slickFilter=function(i){var e=this;null!==i&&(e.$slidesCache=e.$slides,e.unload(),e.$slideTrack.children(this.options.slide).detach(),e.$slidesCache.filter(i).appendTo(e.$slideTrack),e.reinit())},e.prototype.focusHandler=function(){var e=this;e.$slider.off("focus.slick blur.slick").on("focus.slick blur.slick","*",function(t){t.stopImmediatePropagation();var o=i(this);setTimeout(function(){e.options.pauseOnFocus&&(e.focussed=o.is(":focus"),e.autoPlay())},0)})},e.prototype.getCurrent=e.prototype.slickCurrentSlide=function(){return this.currentSlide},e.prototype.getDotCount=function(){var i=this,e=0,t=0,o=0;if(!0===i.options.infinite)if(i.slideCount<=i.options.slidesToShow)++o;else for(;e<i.slideCount;)++o,e=t+i.options.slidesToScroll,t+=i.options.slidesToScroll<=i.options.slidesToShow?i.options.slidesToScroll:i.options.slidesToShow;else if(!0===i.options.centerMode)o=i.slideCount;else if(i.options.asNavFor)for(;e<i.slideCount;)++o,e=t+i.options.slidesToScroll,t+=i.options.slidesToScroll<=i.options.slidesToShow?i.options.slidesToScroll:i.options.slidesToShow;else o=1+Math.ceil((i.slideCount-i.options.slidesToShow)/i.options.slidesToScroll);return o-1},e.prototype.getLeft=function(i){var e,t,o,s,n=this,r=0;return n.slideOffset=0,t=n.$slides.first().outerHeight(!0),!0===n.options.infinite?(n.slideCount>n.options.slidesToShow&&(n.slideOffset=n.slideWidth*n.options.slidesToShow*-1,s=-1,!0===n.options.vertical&&!0===n.options.centerMode&&(2===n.options.slidesToShow?s=-1.5:1===n.options.slidesToShow&&(s=-2)),r=t*n.options.slidesToShow*s),n.slideCount%n.options.slidesToScroll!=0&&i+n.options.slidesToScroll>n.slideCount&&n.slideCount>n.options.slidesToShow&&(i>n.slideCount?(n.slideOffset=(n.options.slidesToShow-(i-n.slideCount))*n.slideWidth*-1,r=(n.options.slidesToShow-(i-n.slideCount))*t*-1):(n.slideOffset=n.slideCount%n.options.slidesToScroll*n.slideWidth*-1,r=n.slideCount%n.options.slidesToScroll*t*-1))):i+n.options.slidesToShow>n.slideCount&&(n.slideOffset=(i+n.options.slidesToShow-n.slideCount)*n.slideWidth,r=(i+n.options.slidesToShow-n.slideCount)*t),n.slideCount<=n.options.slidesToShow&&(n.slideOffset=0,r=0),!0===n.options.centerMode&&n.slideCount<=n.options.slidesToShow?n.slideOffset=n.slideWidth*Math.floor(n.options.slidesToShow)/2-n.slideWidth*n.slideCount/2:!0===n.options.centerMode&&!0===n.options.infinite?n.slideOffset+=n.slideWidth*Math.floor(n.options.slidesToShow/2)-n.slideWidth:!0===n.options.centerMode&&(n.slideOffset=0,n.slideOffset+=n.slideWidth*Math.floor(n.options.slidesToShow/2)),e=!1===n.options.vertical?i*n.slideWidth*-1+n.slideOffset:i*t*-1+r,!0===n.options.variableWidth&&(o=n.slideCount<=n.options.slidesToShow||!1===n.options.infinite?n.$slideTrack.children(".slick-slide").eq(i):n.$slideTrack.children(".slick-slide").eq(i+n.options.slidesToShow),e=!0===n.options.rtl?o[0]?-1*(n.$slideTrack.width()-o[0].offsetLeft-o.width()):0:o[0]?-1*o[0].offsetLeft:0,!0===n.options.centerMode&&(o=n.slideCount<=n.options.slidesToShow||!1===n.options.infinite?n.$slideTrack.children(".slick-slide").eq(i):n.$slideTrack.children(".slick-slide").eq(i+n.options.slidesToShow+1),e=!0===n.options.rtl?o[0]?-1*(n.$slideTrack.width()-o[0].offsetLeft-o.width()):0:o[0]?-1*o[0].offsetLeft:0,e+=(n.$list.width()-o.outerWidth())/2)),e},e.prototype.getOption=e.prototype.slickGetOption=function(i){return this.options[i]},e.prototype.getNavigableIndexes=function(){var i,e=this,t=0,o=0,s=[];for(!1===e.options.infinite?i=e.slideCount:(t=-1*e.options.slidesToScroll,o=-1*e.options.slidesToScroll,i=2*e.slideCount);t<i;)s.push(t),t=o+e.options.slidesToScroll,o+=e.options.slidesToScroll<=e.options.slidesToShow?e.options.slidesToScroll:e.options.slidesToShow;return s},e.prototype.getSlick=function(){return this},e.prototype.getSlideCount=function(){var e,t,o=this;return t=!0===o.options.centerMode?o.slideWidth*Math.floor(o.options.slidesToShow/2):0,!0===o.options.swipeToSlide?(o.$slideTrack.find(".slick-slide").each(function(s,n){if(n.offsetLeft-t+i(n).outerWidth()/2>-1*o.swipeLeft)return e=n,!1}),Math.abs(i(e).attr("data-slick-index")-o.currentSlide)||1):o.options.slidesToScroll},e.prototype.goTo=e.prototype.slickGoTo=function(i,e){this.changeSlide({data:{message:"index",index:parseInt(i)}},e)},e.prototype.init=function(e){var t=this;i(t.$slider).hasClass("slick-initialized")||(i(t.$slider).addClass("slick-initialized"),t.buildRows(),t.buildOut(),t.setProps(),t.startLoad(),t.loadSlider(),t.initializeEvents(),t.updateArrows(),t.updateDots(),t.checkResponsive(!0),t.focusHandler()),e&&t.$slider.trigger("init",[t]),!0===t.options.accessibility&&t.initADA(),t.options.autoplay&&(t.paused=!1,t.autoPlay())},e.prototype.initADA=function(){var e=this,t=Math.ceil(e.slideCount/e.options.slidesToShow),o=e.getNavigableIndexes().filter(function(i){return i>=0&&i<e.slideCount});e.$slides.add(e.$slideTrack.find(".slick-cloned")).attr({"aria-hidden":"true",tabindex:"-1"}).find("a, input, button, select").attr({tabindex:"-1"}),null!==e.$dots&&(e.$slides.not(e.$slideTrack.find(".slick-cloned")).each(function(t){var s=o.indexOf(t);i(this).attr({role:"tabpanel",id:"slick-slide"+e.instanceUid+t,tabindex:-1}),-1!==s&&i(this).attr({"aria-describedby":"slick-slide-control"+e.instanceUid+s})}),e.$dots.attr("role","tablist").find("li").each(function(s){var n=o[s];i(this).attr({role:"presentation"}),i(this).find("button").first().attr({role:"tab",id:"slick-slide-control"+e.instanceUid+s,"aria-controls":"slick-slide"+e.instanceUid+n,"aria-label":s+1+" of "+t,"aria-selected":null,tabindex:"-1"})}).eq(e.currentSlide).find("button").attr({"aria-selected":"true",tabindex:"0"}).end());for(var s=e.currentSlide,n=s+e.options.slidesToShow;s<n;s++)e.$slides.eq(s).attr("tabindex",0);e.activateADA()},e.prototype.initArrowEvents=function(){var i=this;!0===i.options.arrows&&i.slideCount>i.options.slidesToShow&&(i.$prevArrow.off("click.slick").on("click.slick",{message:"previous"},i.changeSlide),i.$nextArrow.off("click.slick").on("click.slick",{message:"next"},i.changeSlide),!0===i.options.accessibility&&(i.$prevArrow.on("keydown.slick",i.keyHandler),i.$nextArrow.on("keydown.slick",i.keyHandler)))},e.prototype.initDotEvents=function(){var e=this;!0===e.options.dots&&(i("li",e.$dots).on("click.slick",{message:"index"},e.changeSlide),!0===e.options.accessibility&&e.$dots.on("keydown.slick",e.keyHandler)),!0===e.options.dots&&!0===e.options.pauseOnDotsHover&&i("li",e.$dots).on("mouseenter.slick",i.proxy(e.interrupt,e,!0)).on("mouseleave.slick",i.proxy(e.interrupt,e,!1))},e.prototype.initSlideEvents=function(){var e=this;e.options.pauseOnHover&&(e.$list.on("mouseenter.slick",i.proxy(e.interrupt,e,!0)),e.$list.on("mouseleave.slick",i.proxy(e.interrupt,e,!1)))},e.prototype.initializeEvents=function(){var e=this;e.initArrowEvents(),e.initDotEvents(),e.initSlideEvents(),e.$list.on("touchstart.slick mousedown.slick",{action:"start"},e.swipeHandler),e.$list.on("touchmove.slick mousemove.slick",{action:"move"},e.swipeHandler),e.$list.on("touchend.slick mouseup.slick",{action:"end"},e.swipeHandler),e.$list.on("touchcancel.slick mouseleave.slick",{action:"end"},e.swipeHandler),e.$list.on("click.slick",e.clickHandler),i(document).on(e.visibilityChange,i.proxy(e.visibility,e)),!0===e.options.accessibility&&e.$list.on("keydown.slick",e.keyHandler),!0===e.options.focusOnSelect&&i(e.$slideTrack).children().on("click.slick",e.selectHandler),i(window).on("orientationchange.slick.slick-"+e.instanceUid,i.proxy(e.orientationChange,e)),i(window).on("resize.slick.slick-"+e.instanceUid,i.proxy(e.resize,e)),i("[draggable!=true]",e.$slideTrack).on("dragstart",e.preventDefault),i(window).on("load.slick.slick-"+e.instanceUid,e.setPosition),i(e.setPosition)},e.prototype.initUI=function(){var i=this;!0===i.options.arrows&&i.slideCount>i.options.slidesToShow&&(i.$prevArrow.show(),i.$nextArrow.show()),!0===i.options.dots&&i.slideCount>i.options.slidesToShow&&i.$dots.show()},e.prototype.keyHandler=function(i){var e=this;i.target.tagName.match("TEXTAREA|INPUT|SELECT")||(37===i.keyCode&&!0===e.options.accessibility?e.changeSlide({data:{message:!0===e.options.rtl?"next":"previous"}}):39===i.keyCode&&!0===e.options.accessibility&&e.changeSlide({data:{message:!0===e.options.rtl?"previous":"next"}}))},e.prototype.lazyLoad=function(){function e(e){i("img[data-lazy]",e).each(function(){var e=i(this),t=i(this).attr("data-lazy"),o=i(this).attr("data-srcset"),s=i(this).attr("data-sizes")||n.$slider.attr("data-sizes"),r=document.createElement("img");r.onload=function(){e.animate({opacity:0},100,function(){o&&(e.attr("srcset",o),s&&e.attr("sizes",s)),e.attr("src",t).animate({opacity:1},200,function(){e.removeAttr("data-lazy data-srcset data-sizes").removeClass("slick-loading")}),n.$slider.trigger("lazyLoaded",[n,e,t])})},r.onerror=function(){e.removeAttr("data-lazy").removeClass("slick-loading").addClass("slick-lazyload-error"),n.$slider.trigger("lazyLoadError",[n,e,t])},r.src=t})}var t,o,s,n=this;if(!0===n.options.centerMode?!0===n.options.infinite?s=(o=n.currentSlide+(n.options.slidesToShow/2+1))+n.options.slidesToShow+2:(o=Math.max(0,n.currentSlide-(n.options.slidesToShow/2+1)),s=n.options.slidesToShow/2+1+2+n.currentSlide):(o=n.options.infinite?n.options.slidesToShow+n.currentSlide:n.currentSlide,s=Math.ceil(o+n.options.slidesToShow),!0===n.options.fade&&(o>0&&o--,s<=n.slideCount&&s++)),t=n.$slider.find(".slick-slide").slice(o,s),"anticipated"===n.options.lazyLoad)for(var r=o-1,l=s,d=n.$slider.find(".slick-slide"),a=0;a<n.options.slidesToScroll;a++)r<0&&(r=n.slideCount-1),t=(t=t.add(d.eq(r))).add(d.eq(l)),r--,l++;e(t),n.slideCount<=n.options.slidesToShow?e(n.$slider.find(".slick-slide")):n.currentSlide>=n.slideCount-n.options.slidesToShow?e(n.$slider.find(".slick-cloned").slice(0,n.options.slidesToShow)):0===n.currentSlide&&e(n.$slider.find(".slick-cloned").slice(-1*n.options.slidesToShow))},e.prototype.loadSlider=function(){var i=this;i.setPosition(),i.$slideTrack.css({opacity:1}),i.$slider.removeClass("slick-loading"),i.initUI(),"progressive"===i.options.lazyLoad&&i.progressiveLazyLoad()},e.prototype.next=e.prototype.slickNext=function(){this.changeSlide({data:{message:"next"}})},e.prototype.orientationChange=function(){var i=this;i.checkResponsive(),i.setPosition()},e.prototype.pause=e.prototype.slickPause=function(){var i=this;i.autoPlayClear(),i.paused=!0},e.prototype.play=e.prototype.slickPlay=function(){var i=this;i.autoPlay(),i.options.autoplay=!0,i.paused=!1,i.focussed=!1,i.interrupted=!1},e.prototype.postSlide=function(e){var t=this;t.unslicked||(t.$slider.trigger("afterChange",[t,e]),t.animating=!1,t.slideCount>t.options.slidesToShow&&t.setPosition(),t.swipeLeft=null,t.options.autoplay&&t.autoPlay(),!0===t.options.accessibility&&(t.initADA(),t.options.focusOnChange&&i(t.$slides.get(t.currentSlide)).attr("tabindex",0).focus()))},e.prototype.prev=e.prototype.slickPrev=function(){this.changeSlide({data:{message:"previous"}})},e.prototype.preventDefault=function(i){i.preventDefault()},e.prototype.progressiveLazyLoad=function(e){e=e||1;var t,o,s,n,r,l=this,d=i("img[data-lazy]",l.$slider);d.length?(t=d.first(),o=t.attr("data-lazy"),s=t.attr("data-srcset"),n=t.attr("data-sizes")||l.$slider.attr("data-sizes"),(r=document.createElement("img")).onload=function(){s&&(t.attr("srcset",s),n&&t.attr("sizes",n)),t.attr("src",o).removeAttr("data-lazy data-srcset data-sizes").removeClass("slick-loading"),!0===l.options.adaptiveHeight&&l.setPosition(),l.$slider.trigger("lazyLoaded",[l,t,o]),l.progressiveLazyLoad()},r.onerror=function(){e<3?setTimeout(function(){l.progressiveLazyLoad(e+1)},500):(t.removeAttr("data-lazy").removeClass("slick-loading").addClass("slick-lazyload-error"),l.$slider.trigger("lazyLoadError",[l,t,o]),l.progressiveLazyLoad())},r.src=o):l.$slider.trigger("allImagesLoaded",[l])},e.prototype.refresh=function(e){var t,o,s=this;o=s.slideCount-s.options.slidesToShow,!s.options.infinite&&s.currentSlide>o&&(s.currentSlide=o),s.slideCount<=s.options.slidesToShow&&(s.currentSlide=0),t=s.currentSlide,s.destroy(!0),i.extend(s,s.initials,{currentSlide:t}),s.init(),e||s.changeSlide({data:{message:"index",index:t}},!1)},e.prototype.registerBreakpoints=function(){var e,t,o,s=this,n=s.options.responsive||null;if("array"===i.type(n)&&n.length){s.respondTo=s.options.respondTo||"window";for(e in n)if(o=s.breakpoints.length-1,n.hasOwnProperty(e)){for(t=n[e].breakpoint;o>=0;)s.breakpoints[o]&&s.breakpoints[o]===t&&s.breakpoints.splice(o,1),o--;s.breakpoints.push(t),s.breakpointSettings[t]=n[e].settings}s.breakpoints.sort(function(i,e){return s.options.mobileFirst?i-e:e-i})}},e.prototype.reinit=function(){var e=this;e.$slides=e.$slideTrack.children(e.options.slide).addClass("slick-slide"),e.slideCount=e.$slides.length,e.currentSlide>=e.slideCount&&0!==e.currentSlide&&(e.currentSlide=e.currentSlide-e.options.slidesToScroll),e.slideCount<=e.options.slidesToShow&&(e.currentSlide=0),e.registerBreakpoints(),e.setProps(),e.setupInfinite(),e.buildArrows(),e.updateArrows(),e.initArrowEvents(),e.buildDots(),e.updateDots(),e.initDotEvents(),e.cleanUpSlideEvents(),e.initSlideEvents(),e.checkResponsive(!1,!0),!0===e.options.focusOnSelect&&i(e.$slideTrack).children().on("click.slick",e.selectHandler),e.setSlideClasses("number"==typeof e.currentSlide?e.currentSlide:0),e.setPosition(),e.focusHandler(),e.paused=!e.options.autoplay,e.autoPlay(),e.$slider.trigger("reInit",[e])},e.prototype.resize=function(){var e=this;i(window).width()!==e.windowWidth&&(clearTimeout(e.windowDelay),e.windowDelay=window.setTimeout(function(){e.windowWidth=i(window).width(),e.checkResponsive(),e.unslicked||e.setPosition()},50))},e.prototype.removeSlide=e.prototype.slickRemove=function(i,e,t){var o=this;if(i="boolean"==typeof i?!0===(e=i)?0:o.slideCount-1:!0===e?--i:i,o.slideCount<1||i<0||i>o.slideCount-1)return!1;o.unload(),!0===t?o.$slideTrack.children().remove():o.$slideTrack.children(this.options.slide).eq(i).remove(),o.$slides=o.$slideTrack.children(this.options.slide),o.$slideTrack.children(this.options.slide).detach(),o.$slideTrack.append(o.$slides),o.$slidesCache=o.$slides,o.reinit()},e.prototype.setCSS=function(i){var e,t,o=this,s={};!0===o.options.rtl&&(i=-i),e="left"==o.positionProp?Math.ceil(i)+"px":"0px",t="top"==o.positionProp?Math.ceil(i)+"px":"0px",s[o.positionProp]=i,!1===o.transformsEnabled?o.$slideTrack.css(s):(s={},!1===o.cssTransitions?(s[o.animType]="translate("+e+", "+t+")",o.$slideTrack.css(s)):(s[o.animType]="translate3d("+e+", "+t+", 0px)",o.$slideTrack.css(s)))},e.prototype.setDimensions=function(){var i=this;!1===i.options.vertical?!0===i.options.centerMode&&i.$list.css({padding:"0px "+i.options.centerPadding}):(i.$list.height(i.$slides.first().outerHeight(!0)*i.options.slidesToShow),!0===i.options.centerMode&&i.$list.css({padding:i.options.centerPadding+" 0px"})),i.listWidth=i.$list.width(),i.listHeight=i.$list.height(),!1===i.options.vertical&&!1===i.options.variableWidth?(i.slideWidth=Math.ceil(i.listWidth/i.options.slidesToShow),i.$slideTrack.width(Math.ceil(i.slideWidth*i.$slideTrack.children(".slick-slide").length))):!0===i.options.variableWidth?i.$slideTrack.width(5e3*i.slideCount):(i.slideWidth=Math.ceil(i.listWidth),i.$slideTrack.height(Math.ceil(i.$slides.first().outerHeight(!0)*i.$slideTrack.children(".slick-slide").length)));var e=i.$slides.first().outerWidth(!0)-i.$slides.first().width();!1===i.options.variableWidth&&i.$slideTrack.children(".slick-slide").width(i.slideWidth-e)},e.prototype.setFade=function(){var e,t=this;t.$slides.each(function(o,s){e=t.slideWidth*o*-1,!0===t.options.rtl?i(s).css({position:"relative",right:e,top:0,zIndex:t.options.zIndex-2,opacity:0}):i(s).css({position:"relative",left:e,top:0,zIndex:t.options.zIndex-2,opacity:0})}),t.$slides.eq(t.currentSlide).css({zIndex:t.options.zIndex-1,opacity:1})},e.prototype.setHeight=function(){var i=this;if(1===i.options.slidesToShow&&!0===i.options.adaptiveHeight&&!1===i.options.vertical){var e=i.$slides.eq(i.currentSlide).outerHeight(!0);i.$list.css("height",e)}},e.prototype.setOption=e.prototype.slickSetOption=function(){var e,t,o,s,n,r=this,l=!1;if("object"===i.type(arguments[0])?(o=arguments[0],l=arguments[1],n="multiple"):"string"===i.type(arguments[0])&&(o=arguments[0],s=arguments[1],l=arguments[2],"responsive"===arguments[0]&&"array"===i.type(arguments[1])?n="responsive":void 0!==arguments[1]&&(n="single")),"single"===n)r.options[o]=s;else if("multiple"===n)i.each(o,function(i,e){r.options[i]=e});else if("responsive"===n)for(t in s)if("array"!==i.type(r.options.responsive))r.options.responsive=[s[t]];else{for(e=r.options.responsive.length-1;e>=0;)r.options.responsive[e].breakpoint===s[t].breakpoint&&r.options.responsive.splice(e,1),e--;r.options.responsive.push(s[t])}l&&(r.unload(),r.reinit())},e.prototype.setPosition=function(){var i=this;i.setDimensions(),i.setHeight(),!1===i.options.fade?i.setCSS(i.getLeft(i.currentSlide)):i.setFade(),i.$slider.trigger("setPosition",[i])},e.prototype.setProps=function(){var i=this,e=document.body.style;i.positionProp=!0===i.options.vertical?"top":"left","top"===i.positionProp?i.$slider.addClass("slick-vertical"):i.$slider.removeClass("slick-vertical"),void 0===e.WebkitTransition&&void 0===e.MozTransition&&void 0===e.msTransition||!0===i.options.useCSS&&(i.cssTransitions=!0),i.options.fade&&("number"==typeof i.options.zIndex?i.options.zIndex<3&&(i.options.zIndex=3):i.options.zIndex=i.defaults.zIndex),void 0!==e.OTransform&&(i.animType="OTransform",i.transformType="-o-transform",i.transitionType="OTransition",void 0===e.perspectiveProperty&&void 0===e.webkitPerspective&&(i.animType=!1)),void 0!==e.MozTransform&&(i.animType="MozTransform",i.transformType="-moz-transform",i.transitionType="MozTransition",void 0===e.perspectiveProperty&&void 0===e.MozPerspective&&(i.animType=!1)),void 0!==e.webkitTransform&&(i.animType="webkitTransform",i.transformType="-webkit-transform",i.transitionType="webkitTransition",void 0===e.perspectiveProperty&&void 0===e.webkitPerspective&&(i.animType=!1)),void 0!==e.msTransform&&(i.animType="msTransform",i.transformType="-ms-transform",i.transitionType="msTransition",void 0===e.msTransform&&(i.animType=!1)),void 0!==e.transform&&!1!==i.animType&&(i.animType="transform",i.transformType="transform",i.transitionType="transition"),i.transformsEnabled=i.options.useTransform&&null!==i.animType&&!1!==i.animType},e.prototype.setSlideClasses=function(i){var e,t,o,s,n=this;if(t=n.$slider.find(".slick-slide").removeClass("slick-active slick-center slick-current").attr("aria-hidden","true"),n.$slides.eq(i).addClass("slick-current"),!0===n.options.centerMode){var r=n.options.slidesToShow%2==0?1:0;e=Math.floor(n.options.slidesToShow/2),!0===n.options.infinite&&(i>=e&&i<=n.slideCount-1-e?n.$slides.slice(i-e+r,i+e+1).addClass("slick-active").attr("aria-hidden","false"):(o=n.options.slidesToShow+i,t.slice(o-e+1+r,o+e+2).addClass("slick-active").attr("aria-hidden","false")),0===i?t.eq(t.length-1-n.options.slidesToShow).addClass("slick-center"):i===n.slideCount-1&&t.eq(n.options.slidesToShow).addClass("slick-center")),n.$slides.eq(i).addClass("slick-center")}else i>=0&&i<=n.slideCount-n.options.slidesToShow?n.$slides.slice(i,i+n.options.slidesToShow).addClass("slick-active").attr("aria-hidden","false"):t.length<=n.options.slidesToShow?t.addClass("slick-active").attr("aria-hidden","false"):(s=n.slideCount%n.options.slidesToShow,o=!0===n.options.infinite?n.options.slidesToShow+i:i,n.options.slidesToShow==n.options.slidesToScroll&&n.slideCount-i<n.options.slidesToShow?t.slice(o-(n.options.slidesToShow-s),o+s).addClass("slick-active").attr("aria-hidden","false"):t.slice(o,o+n.options.slidesToShow).addClass("slick-active").attr("aria-hidden","false"));"ondemand"!==n.options.lazyLoad&&"anticipated"!==n.options.lazyLoad||n.lazyLoad()},e.prototype.setupInfinite=function(){var e,t,o,s=this;if(!0===s.options.fade&&(s.options.centerMode=!1),!0===s.options.infinite&&!1===s.options.fade&&(t=null,s.slideCount>s.options.slidesToShow)){for(o=!0===s.options.centerMode?s.options.slidesToShow+1:s.options.slidesToShow,e=s.slideCount;e>s.slideCount-o;e-=1)t=e-1,i(s.$slides[t]).clone(!0).attr("id","").attr("data-slick-index",t-s.slideCount).prependTo(s.$slideTrack).addClass("slick-cloned");for(e=0;e<o+s.slideCount;e+=1)t=e,i(s.$slides[t]).clone(!0).attr("id","").attr("data-slick-index",t+s.slideCount).appendTo(s.$slideTrack).addClass("slick-cloned");s.$slideTrack.find(".slick-cloned").find("[id]").each(function(){i(this).attr("id","")})}},e.prototype.interrupt=function(i){var e=this;i||e.autoPlay(),e.interrupted=i},e.prototype.selectHandler=function(e){var t=this,o=i(e.target).is(".slick-slide")?i(e.target):i(e.target).parents(".slick-slide"),s=parseInt(o.attr("data-slick-index"));s||(s=0),t.slideCount<=t.options.slidesToShow?t.slideHandler(s,!1,!0):t.slideHandler(s)},e.prototype.slideHandler=function(i,e,t){var o,s,n,r,l,d=null,a=this;if(e=e||!1,!(!0===a.animating&&!0===a.options.waitForAnimate||!0===a.options.fade&&a.currentSlide===i))if(!1===e&&a.asNavFor(i),o=i,d=a.getLeft(o),r=a.getLeft(a.currentSlide),a.currentLeft=null===a.swipeLeft?r:a.swipeLeft,!1===a.options.infinite&&!1===a.options.centerMode&&(i<0||i>a.getDotCount()*a.options.slidesToScroll))!1===a.options.fade&&(o=a.currentSlide,!0!==t?a.animateSlide(r,function(){a.postSlide(o)}):a.postSlide(o));else if(!1===a.options.infinite&&!0===a.options.centerMode&&(i<0||i>a.slideCount-a.options.slidesToScroll))!1===a.options.fade&&(o=a.currentSlide,!0!==t?a.animateSlide(r,function(){a.postSlide(o)}):a.postSlide(o));else{if(a.options.autoplay&&clearInterval(a.autoPlayTimer),s=o<0?a.slideCount%a.options.slidesToScroll!=0?a.slideCount-a.slideCount%a.options.slidesToScroll:a.slideCount+o:o>=a.slideCount?a.slideCount%a.options.slidesToScroll!=0?0:o-a.slideCount:o,a.animating=!0,a.$slider.trigger("beforeChange",[a,a.currentSlide,s]),n=a.currentSlide,a.currentSlide=s,a.setSlideClasses(a.currentSlide),a.options.asNavFor&&(l=(l=a.getNavTarget()).slick("getSlick")).slideCount<=l.options.slidesToShow&&l.setSlideClasses(a.currentSlide),a.updateDots(),a.updateArrows(),!0===a.options.fade)return!0!==t?(a.fadeSlideOut(n),a.fadeSlide(s,function(){a.postSlide(s)})):a.postSlide(s),void a.animateHeight();!0!==t?a.animateSlide(d,function(){a.postSlide(s)}):a.postSlide(s)}},e.prototype.startLoad=function(){var i=this;!0===i.options.arrows&&i.slideCount>i.options.slidesToShow&&(i.$prevArrow.hide(),i.$nextArrow.hide()),!0===i.options.dots&&i.slideCount>i.options.slidesToShow&&i.$dots.hide(),i.$slider.addClass("slick-loading")},e.prototype.swipeDirection=function(){var i,e,t,o,s=this;return i=s.touchObject.startX-s.touchObject.curX,e=s.touchObject.startY-s.touchObject.curY,t=Math.atan2(e,i),(o=Math.round(180*t/Math.PI))<0&&(o=360-Math.abs(o)),o<=45&&o>=0?!1===s.options.rtl?"left":"right":o<=360&&o>=315?!1===s.options.rtl?"left":"right":o>=135&&o<=225?!1===s.options.rtl?"right":"left":!0===s.options.verticalSwiping?o>=35&&o<=135?"down":"up":"vertical"},e.prototype.swipeEnd=function(i){var e,t,o=this;if(o.dragging=!1,o.swiping=!1,o.scrolling)return o.scrolling=!1,!1;if(o.interrupted=!1,o.shouldClick=!(o.touchObject.swipeLength>10),void 0===o.touchObject.curX)return!1;if(!0===o.touchObject.edgeHit&&o.$slider.trigger("edge",[o,o.swipeDirection()]),o.touchObject.swipeLength>=o.touchObject.minSwipe){switch(t=o.swipeDirection()){case"left":case"down":e=o.options.swipeToSlide?o.checkNavigable(o.currentSlide+o.getSlideCount()):o.currentSlide+o.getSlideCount(),o.currentDirection=0;break;case"right":case"up":e=o.options.swipeToSlide?o.checkNavigable(o.currentSlide-o.getSlideCount()):o.currentSlide-o.getSlideCount(),o.currentDirection=1}"vertical"!=t&&(o.slideHandler(e),o.touchObject={},o.$slider.trigger("swipe",[o,t]))}else o.touchObject.startX!==o.touchObject.curX&&(o.slideHandler(o.currentSlide),o.touchObject={})},e.prototype.swipeHandler=function(i){var e=this;if(!(!1===e.options.swipe||"ontouchend"in document&&!1===e.options.swipe||!1===e.options.draggable&&-1!==i.type.indexOf("mouse")))switch(e.touchObject.fingerCount=i.originalEvent&&void 0!==i.originalEvent.touches?i.originalEvent.touches.length:1,e.touchObject.minSwipe=e.listWidth/e.options.touchThreshold,!0===e.options.verticalSwiping&&(e.touchObject.minSwipe=e.listHeight/e.options.touchThreshold),i.data.action){case"start":e.swipeStart(i);break;case"move":e.swipeMove(i);break;case"end":e.swipeEnd(i)}},e.prototype.swipeMove=function(i){var e,t,o,s,n,r,l=this;return n=void 0!==i.originalEvent?i.originalEvent.touches:null,!(!l.dragging||l.scrolling||n&&1!==n.length)&&(e=l.getLeft(l.currentSlide),l.touchObject.curX=void 0!==n?n[0].pageX:i.clientX,l.touchObject.curY=void 0!==n?n[0].pageY:i.clientY,l.touchObject.swipeLength=Math.round(Math.sqrt(Math.pow(l.touchObject.curX-l.touchObject.startX,2))),r=Math.round(Math.sqrt(Math.pow(l.touchObject.curY-l.touchObject.startY,2))),!l.options.verticalSwiping&&!l.swiping&&r>4?(l.scrolling=!0,!1):(!0===l.options.verticalSwiping&&(l.touchObject.swipeLength=r),t=l.swipeDirection(),void 0!==i.originalEvent&&l.touchObject.swipeLength>4&&(l.swiping=!0,i.preventDefault()),s=(!1===l.options.rtl?1:-1)*(l.touchObject.curX>l.touchObject.startX?1:-1),!0===l.options.verticalSwiping&&(s=l.touchObject.curY>l.touchObject.startY?1:-1),o=l.touchObject.swipeLength,l.touchObject.edgeHit=!1,!1===l.options.infinite&&(0===l.currentSlide&&"right"===t||l.currentSlide>=l.getDotCount()&&"left"===t)&&(o=l.touchObject.swipeLength*l.options.edgeFriction,l.touchObject.edgeHit=!0),!1===l.options.vertical?l.swipeLeft=e+o*s:l.swipeLeft=e+o*(l.$list.height()/l.listWidth)*s,!0===l.options.verticalSwiping&&(l.swipeLeft=e+o*s),!0!==l.options.fade&&!1!==l.options.touchMove&&(!0===l.animating?(l.swipeLeft=null,!1):void l.setCSS(l.swipeLeft))))},e.prototype.swipeStart=function(i){var e,t=this;if(t.interrupted=!0,1!==t.touchObject.fingerCount||t.slideCount<=t.options.slidesToShow)return t.touchObject={},!1;void 0!==i.originalEvent&&void 0!==i.originalEvent.touches&&(e=i.originalEvent.touches[0]),t.touchObject.startX=t.touchObject.curX=void 0!==e?e.pageX:i.clientX,t.touchObject.startY=t.touchObject.curY=void 0!==e?e.pageY:i.clientY,t.dragging=!0},e.prototype.unfilterSlides=e.prototype.slickUnfilter=function(){var i=this;null!==i.$slidesCache&&(i.unload(),i.$slideTrack.children(this.options.slide).detach(),i.$slidesCache.appendTo(i.$slideTrack),i.reinit())},e.prototype.unload=function(){var e=this;i(".slick-cloned",e.$slider).remove(),e.$dots&&e.$dots.remove(),e.$prevArrow&&e.htmlExpr.test(e.options.prevArrow)&&e.$prevArrow.remove(),e.$nextArrow&&e.htmlExpr.test(e.options.nextArrow)&&e.$nextArrow.remove(),e.$slides.removeClass("slick-slide slick-active slick-visible slick-current").attr("aria-hidden","true").css("width","")},e.prototype.unslick=function(i){var e=this;e.$slider.trigger("unslick",[e,i]),e.destroy()},e.prototype.updateArrows=function(){var i=this;Math.floor(i.options.slidesToShow/2),!0===i.options.arrows&&i.slideCount>i.options.slidesToShow&&!i.options.infinite&&(i.$prevArrow.removeClass("slick-disabled").attr("aria-disabled","false"),i.$nextArrow.removeClass("slick-disabled").attr("aria-disabled","false"),0===i.currentSlide?(i.$prevArrow.addClass("slick-disabled").attr("aria-disabled","true"),i.$nextArrow.removeClass("slick-disabled").attr("aria-disabled","false")):i.currentSlide>=i.slideCount-i.options.slidesToShow&&!1===i.options.centerMode?(i.$nextArrow.addClass("slick-disabled").attr("aria-disabled","true"),i.$prevArrow.removeClass("slick-disabled").attr("aria-disabled","false")):i.currentSlide>=i.slideCount-1&&!0===i.options.centerMode&&(i.$nextArrow.addClass("slick-disabled").attr("aria-disabled","true"),i.$prevArrow.removeClass("slick-disabled").attr("aria-disabled","false")))},e.prototype.updateDots=function(){var i=this;null!==i.$dots&&(i.$dots.find("li").removeClass("slick-active").end(),i.$dots.find("li").eq(Math.floor(i.currentSlide/i.options.slidesToScroll)).addClass("slick-active"))},e.prototype.visibility=function(){var i=this;i.options.autoplay&&(document[i.hidden]?i.interrupted=!0:i.interrupted=!1)},i.fn.slick=function(){var i,t,o=this,s=arguments[0],n=Array.prototype.slice.call(arguments,1),r=o.length;for(i=0;i<r;i++)if("object"==typeof s||void 0===s?o[i].slick=new e(o[i],s):t=o[i].slick[s].apply(o[i].slick,n),void 0!==t)return t;return o}});

window.theme = window.theme || {};

/* ================ SLATE ================ */
window.theme = window.theme || {};

theme.Sections = function Sections() {
  this.constructors = {};
  this.instances = [];

  $(document)
    .on('shopify:section:load', this._onSectionLoad.bind(this))
    .on('shopify:section:unload', this._onSectionUnload.bind(this))
    .on('shopify:section:select', this._onSelect.bind(this))
    .on('shopify:section:deselect', this._onDeselect.bind(this))
    .on('shopify:block:select', this._onBlockSelect.bind(this))
    .on('shopify:block:deselect', this._onBlockDeselect.bind(this));
};

theme.Sections.prototype = _.assignIn({}, theme.Sections.prototype, {
  _createInstance: function(container, constructor) {
    var $container = $(container);
    var id = $container.attr('data-section-id');
    var type = $container.attr('data-section-type');

    constructor = constructor || this.constructors[type];

    if (_.isUndefined(constructor)) {
      return;
    }

    var instance = _.assignIn(new constructor(container), {
      id: id,
      type: type,
      container: container
    });

    this.instances.push(instance);
  },

  _onSectionLoad: function(evt) {
    var container = $('[data-section-id]', evt.target)[0];
    if (container) {
      this._createInstance(container);
    }
  },

  _onSectionUnload: function(evt) {
    this.instances = _.filter(this.instances, function(instance) {
      var isEventInstance = instance.id === evt.detail.sectionId;

      if (isEventInstance) {
        if (_.isFunction(instance.onUnload)) {
          instance.onUnload(evt);
        }
      }

      return !isEventInstance;
    });
  },

  _onSelect: function(evt) {
    // eslint-disable-next-line no-shadow
    var instance = _.find(this.instances, function(instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (!_.isUndefined(instance) && _.isFunction(instance.onSelect)) {
      instance.onSelect(evt);
    }
  },

  _onDeselect: function(evt) {
    // eslint-disable-next-line no-shadow
    var instance = _.find(this.instances, function(instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (!_.isUndefined(instance) && _.isFunction(instance.onDeselect)) {
      instance.onDeselect(evt);
    }
  },

  _onBlockSelect: function(evt) {
    // eslint-disable-next-line no-shadow
    var instance = _.find(this.instances, function(instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (!_.isUndefined(instance) && _.isFunction(instance.onBlockSelect)) {
      instance.onBlockSelect(evt);
    }
  },

  _onBlockDeselect: function(evt) {
    // eslint-disable-next-line no-shadow
    var instance = _.find(this.instances, function(instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (!_.isUndefined(instance) && _.isFunction(instance.onBlockDeselect)) {
      instance.onBlockDeselect(evt);
    }
  },

  register: function(type, constructor) {
    this.constructors[type] = constructor;

    $('[data-section-type=' + type + ']').each(
      function(index, container) {
        this._createInstance(container, constructor);
      }.bind(this)
    );
  }
});

window.slate = window.slate || {};

/**
 * Slate utilities
 * -----------------------------------------------------------------------------
 * A collection of useful utilities to help build your theme
 *
 *
 * @namespace utils
 */

slate.utils = {
  /**
   * Get the query params in a Url
   * Ex
   * https://mysite.com/search?q=noodles&b
   * getParameterByName('q') = "noodles"
   * getParameterByName('b') = "" (empty value)
   * getParameterByName('test') = null (absent)
   */
  getParameterByName: function(name, url) {
    if (!url) url = window.location.href;
    name = name.replace(/[[\]]/g, '\\$&');
    var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
      results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
  },

  keyboardKeys: {
    TAB: 9,
    ENTER: 13,
    ESCAPE: 27,
    LEFTARROW: 37,
    RIGHTARROW: 39
  }
};

window.slate = window.slate || {};

/**
 * iFrames
 * -----------------------------------------------------------------------------
 * Wrap videos in div to force responsive layout.
 *
 * @namespace iframes
 */

slate.rte = {
  /**
   * Wrap tables in a container div to make them scrollable when needed
   *
   * @param {object} options - Options to be used
   * @param {jquery} options.$tables - jquery object(s) of the table(s) to wrap
   * @param {string} options.tableWrapperClass - table wrapper class name
   */
  wrapTable: function(options) {
    options.$tables.wrap(
      '<div class="' + options.tableWrapperClass + '"></div>'
    );
  },

  /**
   * Wrap iframes in a container div to make them responsive
   *
   * @param {object} options - Options to be used
   * @param {jquery} options.$iframes - jquery object(s) of the iframe(s) to wrap
   * @param {string} options.iframeWrapperClass - class name used on the wrapping div
   */
  wrapIframe: function(options) {
    options.$iframes.each(function() {
      // Add wrapper to make video responsive
      $(this).wrap('<div class="' + options.iframeWrapperClass + '"></div>');

      // Re-set the src attribute on each iframe after page load
      // for Chrome's "incorrect iFrame content on 'back'" bug.
      // https://code.google.com/p/chromium/issues/detail?id=395791
      // Need to specifically target video and admin bar
      this.src = this.src;
    });
  }
};

window.slate = window.slate || {};

/**
 * A11y Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help make your theme more accessible
 * to users with visual impairments.
 *
 *
 * @namespace a11y
 */

slate.a11y = {
  /**
   * For use when focus shifts to a container rather than a link
   * eg for In-page links, after scroll, focus shifts to content area so that
   * next `tab` is where user expects if focusing a link, just $link.focus();
   *
   * @param {JQuery} $element - The element to be acted upon
   */
  pageLinkFocus: function($element) {
    var focusClass = 'js-focus-hidden';

    $element
      .first()
      .attr('tabIndex', '-1')
      .focus()
      .addClass(focusClass)
      .one('blur', callback);

    function callback() {
      $element
        .first()
        .removeClass(focusClass)
        .removeAttr('tabindex');
    }
  },

  /**
   * If there's a hash in the url, focus the appropriate element
   */
  focusHash: function() {
    var hash = window.location.hash;

    // is there a hash in the url? is it an element on the page?
    if (hash && document.getElementById(hash.slice(1))) {
      this.pageLinkFocus($(hash));
    }
  },

  /**
   * When an in-page (url w/hash) link is clicked, focus the appropriate element
   */
  bindInPageLinks: function() {
    $('a[href*=#]').on(
      'click',
      function(evt) {
        this.pageLinkFocus($(evt.currentTarget.hash));
      }.bind(this)
    );
  },

  /**
   * Traps the focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {jQuery} options.$elementToFocus - Element to be focused when focus leaves container
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  trapFocus: function(options) {
    var eventsName = {
      focusin: options.namespace ? 'focusin.' + options.namespace : 'focusin',
      focusout: options.namespace
        ? 'focusout.' + options.namespace
        : 'focusout',
      keydown: options.namespace
        ? 'keydown.' + options.namespace
        : 'keydown.handleFocus'
    };

    /**
     * Get every possible visible focusable element
     */
    var $focusableElements = options.$container.find(
      $(
        'button, [href], input, select, textarea, [tabindex]:not([tabindex^="-"])'
      ).filter(':visible')
    );
    var firstFocusable = $focusableElements[0];
    var lastFocusable = $focusableElements[$focusableElements.length - 1];

    if (!options.$elementToFocus) {
      options.$elementToFocus = options.$container;
    }

    function _manageFocus(evt) {
      if (evt.keyCode !== slate.utils.keyboardKeys.TAB) return;

      /**
       * On the last focusable element and tab forward,
       * focus the first element.
       */
      if (evt.target === lastFocusable && !evt.shiftKey) {
        evt.preventDefault();
        firstFocusable.focus();
      }
      /**
       * On the first focusable element and tab backward,
       * focus the last element.
       */
      if (evt.target === firstFocusable && evt.shiftKey) {
        evt.preventDefault();
        lastFocusable.focus();
      }
    }

    options.$container.attr('tabindex', '-1');
    options.$elementToFocus.focus();

    $(document).off('focusin');

    $(document).on(eventsName.focusout, function() {
      $(document).off(eventsName.keydown);
    });

    $(document).on(eventsName.focusin, function(evt) {
      if (evt.target !== lastFocusable && evt.target !== firstFocusable) return;

      $(document).on(eventsName.keydown, function(evt) {
        _manageFocus(evt);
      });
    });
  },

  /**
   * Removes the trap of focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  removeTrapFocus: function(options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (options.$container && options.$container.length) {
      options.$container.removeAttr('tabindex');
    }

    $(document).off(eventName);
  },

  /**
   * Add aria-describedby attribute to external and new window links
   *
   * @param {object} options - Options to be used
   * @param {object} options.messages - Custom messages to be used
   * @param {jQuery} options.$links - Specific links to be targeted
   */
  accessibleLinks: function(options) {
    var body = document.querySelector('body');

    var idSelectors = {
      newWindow: 'a11y-new-window-message',
      external: 'a11y-external-message',
      newWindowExternal: 'a11y-new-window-external-message'
    };

    if (options.$links === undefined || !options.$links.jquery) {
      options.$links = $('a[href]:not([aria-describedby])');
    }

    function generateHTML(customMessages) {
      if (typeof customMessages !== 'object') {
        customMessages = {};
      }

      var messages = $.extend(
        {
          newWindow: 'Opens in a new window.',
          external: 'Opens external website.',
          newWindowExternal: 'Opens external website in a new window.'
        },
        customMessages
      );

      var container = document.createElement('ul');
      var htmlMessages = '';

      for (var message in messages) {
        htmlMessages +=
          '<li id=' + idSelectors[message] + '>' + messages[message] + '</li>';
      }

      container.setAttribute('hidden', true);
      container.innerHTML = htmlMessages;

      body.appendChild(container);
    }

    function _externalSite($link) {
      var hostname = window.location.hostname;

      return $link[0].hostname !== hostname;
    }

    $.each(options.$links, function() {
      var $link = $(this);
      var target = $link.attr('target');
      var rel = $link.attr('rel');
      var isExternal = _externalSite($link);
      var isTargetBlank = target === '_blank';

      if (isExternal) {
        $link.attr('aria-describedby', idSelectors.external);
      }
      if (isTargetBlank) {
        if (rel === undefined || rel.indexOf('noopener') === -1) {
          $link.attr('rel', function(i, val) {
            var relValue = val === undefined ? '' : val + ' ';
            return relValue + 'noopener';
          });
        }
        $link.attr('aria-describedby', idSelectors.newWindow);
      }
      if (isExternal && isTargetBlank) {
        $link.attr('aria-describedby', idSelectors.newWindowExternal);
      }
    });

    generateHTML(options.messages);
  }
};

/**
 * Image Helper Functions
 * -----------------------------------------------------------------------------
 * A collection of functions that help with basic image operations.
 *
 */

theme.Images = (function() {
  /**
   * Preloads an image in memory and uses the browsers cache to store it until needed.
   *
   * @param {Array} images - A list of image urls
   * @param {String} size - A shopify image size attribute
   */

  function preload(images, size) {
    if (typeof images === 'string') {
      images = [images];
    }

    for (var i = 0; i < images.length; i++) {
      var image = images[i];
      this.loadImage(this.getSizedImageUrl(image, size));
    }
  }

  /**
   * Loads and caches an image in the browsers cache.
   * @param {string} path - An image url
   */
  function loadImage(path) {
    new Image().src = path;
  }

  /**
   * Swaps the src of an image for another OR returns the imageURL to the callback function
   * @param image
   * @param element
   * @param callback
   */
  function switchImage(image, element, callback) {
    var size = this.imageSize(element.src);
    var imageUrl = this.getSizedImageUrl(image.src, size);

    if (callback) {
      callback(imageUrl, image, element); // eslint-disable-line callback-return
    } else {
      element.src = imageUrl;
    }
  }

  /**
   * +++ Useful
   * Find the Shopify image attribute size
   *
   * @param {string} src
   * @returns {null}
   */
  function imageSize(src) {
    var match = src.match(
      /.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\\.@]/
    );

    if (match !== null) {
      if (match[2] !== undefined) {
        return match[1] + match[2];
      } else {
        return match[1];
      }
    } else {
      return null;
    }
  }

  /**
   * +++ Useful
   * Adds a Shopify size attribute to a URL
   *
   * @param src
   * @param size
   * @returns {*}
   */
  function getSizedImageUrl(src, size) {
    if (size === null) {
      return src;
    }

    if (size === 'master') {
      return this.removeProtocol(src);
    }

    var match = src.match(
      /\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i
    );

    if (match !== null) {
      var prefix = src.split(match[0]);
      var suffix = match[0];

      return this.removeProtocol(prefix[0] + '_' + size + suffix);
    }

    return null;
  }

  function removeProtocol(path) {
    return path.replace(/http(s)?:/, '');
  }

  return {
    preload: preload,
    loadImage: loadImage,
    switchImage: switchImage,
    imageSize: imageSize,
    getSizedImageUrl: getSizedImageUrl,
    removeProtocol: removeProtocol
  };
})();

/**
 * Currency Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help with currency formatting
 *
 * Current contents
 * - formatMoney - Takes an amount in cents and returns it as a formatted dollar value.
 *
 * Alternatives
 * - Accounting.js - http://openexchangerates.github.io/accounting.js/
 *
 */

theme.Currency = (function() {
  var moneyFormat = '${{amount}}'; // eslint-disable-line camelcase

  function formatMoney(cents, format) {
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = format || moneyFormat;

    function formatWithDelimiters(number, precision, thousands, decimal) {
      thousands = thousands || ',';
      decimal = decimal || '.';

      if (isNaN(number) || number === null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);

      var parts = number.split('.');
      var dollarsAmount = parts[0].replace(
        /(\d)(?=(\d\d\d)+(?!\d))/g,
        '$1' + thousands
      );
      var centsAmount = parts[1] ? decimal + parts[1] : '';

      return dollarsAmount + centsAmount;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
      case 'amount_no_decimals_with_space_separator':
        value = formatWithDelimiters(cents, 0, ' ');
        break;
      case 'amount_with_apostrophe_separator':
        value = formatWithDelimiters(cents, 2, "'");
        break;
    }

    return formatString.replace(placeholderRegex, value);
  }

  return {
    formatMoney: formatMoney
  };
})();

/**
 * Variant Selection scripts
 * ------------------------------------------------------------------------------
 *
 * Handles change events from the variant inputs in any `cart/add` forms that may
 * exist.  Also updates the master select and triggers updates when the variants
 * price or image changes.
 *
 * @namespace variants
 */

slate.Variants = (function() {
  /**
   * Variant constructor
   *
   * @param {object} options - Settings from `product.js`
   */
  
  function Variants(options) {
    this.$container = options.$container;
    this.product = options.product;
    this.singleOptionSelector = options.singleOptionSelector;
    this.originalSelectorId = options.originalSelectorId;
    this.enableHistoryState = options.enableHistoryState;
    this.currentVariant = this._getVariantFromOptions();
    $(this.singleOptionSelector, this.$container).on(
      'change',
      this._onSelectChange.bind(this)
    );
  }

  Variants.prototype = _.assignIn({}, Variants.prototype, {
    /**
     * Get the currently selected options from add-to-cart form. Works with all
     * form input elements.
     *
     * @return {array} options - Values of currently selected variants
     */
    _getCurrentOptions: function() {
      var currentOptions = _.map(
        $(this.singleOptionSelector, this.$container),
        function(element) {
          var $element = $(element);
          var type = $element.attr('type');
          var currentOption = {};

          if (type === 'radio' || type === 'checkbox') {
            if ($element[0].checked) {
              currentOption.value = $element.val();
              currentOption.index = $element.data('index');

              return currentOption;
            } else {
              return false;
            }
          } else {
            currentOption.value = $element.val();
            currentOption.index = $element.data('index');

            return currentOption;
          }
        }
      );

      // remove any unchecked input values if using radio buttons or checkboxes
      currentOptions = _.compact(currentOptions);

      return currentOptions;
    },

    /**
     * Find variant based on selected values.
     *
     * @param  {array} selectedValues - Values of variant inputs
     * @return {object || undefined} found - Variant object from product.variants
     */
    _getVariantFromOptions: function() {
      var selectedValues = this._getCurrentOptions();
      var variants = this.product.variants;

      var found = _.find(variants, function(variant) {
        return selectedValues.every(function(values) {
          return _.isEqual(variant[values.index], values.value);
        });
      });

      return found;
    },

    /**
     * Event handler for when a variant input changes.
     */
    _onSelectChange: function() {

      var variant = this._getVariantFromOptions();

      // CD CODE...
      if($('.sticky_action_bar').length){
        if(variant.featured_media != undefined){
          $('.sticky_action_bar .image img').attr('src', variant.featured_media.preview_image.src);
        }
        $('.sticky_action_bar .sty_action_btn .bar_price').html(theme.Currency.formatMoney(variant.price,theme.moneyFormat).replace('Rs. ', '₹'))
      }
      
      // cd jaydip
      if(variant.featured_media != undefined){
        var current_img = (variant.featured_image.position - 1);
        if($('.template_alt_pro .prod-single-slider').length){
          $('.template_alt_pro .prod-single-slider').slick('slickGoTo', current_img);
        }else{
          $('.new_product_temp .prod-single-slider').slick('slickGoTo', current_img);
        }
      }
      
      this.$container.trigger({
        type: 'variantChange',
        variant: variant
      });

      if (!variant) {
        return;
      }

      this._updateMasterSelect(variant);
      if(!$('.template_alt_pro .prod-single-slider').length){
        this._updateImages(variant);
      }
      this._updatePrice(variant);
      this._updateSKU(variant);
      this.currentVariant = variant;

      if (this.enableHistoryState) {
        this._updateHistoryState(variant);
      }

      if($('.product-form .product-form__item button[type="submit"] .price').length){
        $('.product-form .product-form__item button[type="submit"] .price').html(theme.Currency.formatMoney(variant.price,theme.moneyFormat).replace('Rs. ', '₹'));
      }
    },

    /**
     * Trigger event when variant image changes
     *
     * @param  {object} variant - Currently selected variant
     * @return {event}  variantImageChange
     */
    _updateImages: function(variant) {
      var variantImage = variant.featured_image || {};
      var currentVariantImage = this.currentVariant.featured_image || {};

      if (
        !variant.featured_image ||
        variantImage.src === currentVariantImage.src
      ) {
        return;
      }

      this.$container.trigger({
        type: 'variantImageChange',
        variant: variant
      });
    },

    /**
     * Trigger event when variant price changes.
     *
     * @param  {object} variant - Currently selected variant
     * @return {event} variantPriceChange
     */
    _updatePrice: function(variant) {
      if (
        variant.price === this.currentVariant.price &&
        variant.compare_at_price === this.currentVariant.compare_at_price
      ) {
        return;
      }

      this.$container.trigger({
        type: 'variantPriceChange',
        variant: variant
      });
    },

    /**
     * Trigger event when variant sku changes.
     *
     * @param  {object} variant - Currently selected variant
     * @return {event} variantSKUChange
     */
    _updateSKU: function(variant) {
      if (variant.sku === this.currentVariant.sku) {
        return;
      }

      this.$container.trigger({
        type: 'variantSKUChange',
        variant: variant
      });
    },

    /**
     * Update history state for product deeplinking
     *
     * @param  {variant} variant - Currently selected variant
     * @return {k}         [description]
     */
    _updateHistoryState: function(variant) {
      if (!history.replaceState || !variant) {
        return;
      }

      var newurl =
        window.location.protocol +
        '//' +
        window.location.host +
        window.location.pathname +
        '?variant=' +
        variant.id;
      window.history.replaceState({ path: newurl }, '', newurl);
    },

    /**
     * Update hidden master select of variant change
     *
     * @param  {variant} variant - Currently selected variant
     */
    _updateMasterSelect: function(variant) {
      $(this.originalSelectorId, this.$container).val(variant.id);
    }
  });

  return Variants;
})();


/* ================ GLOBAL ================ */
/*============================================================================
  Drawer modules
==============================================================================*/
theme.Drawers = (function() {
  function Drawer(id, position, options) {
    var defaults = {
      close: '.js-drawer-close',
      open: '.js-drawer-open-' + position,
      openClass: 'js-drawer-open',
      dirOpenClass: 'js-drawer-open-' + position
    };

    this.nodes = {
      $parent: $('html').add('body'),
      $page: $('#PageContainer')
    };

    this.config = $.extend(defaults, options);
    this.position = position;

    this.$drawer = $('#' + id);

    if (!this.$drawer.length) {
      return false;
    }

    this.drawerIsOpen = false;
    this.init();
  }

  Drawer.prototype.init = function() {
    $(this.config.open).on('click', $.proxy(this.open, this));
    this.$drawer.on('click', this.config.close, $.proxy(this.close, this));
  };

  Drawer.prototype.open = function(evt) {
    // Keep track if drawer was opened from a click, or called by another function
    var externalCall = false;

    // Prevent following href if link is clicked
    if (evt) {
      evt.preventDefault();
    } else {
      externalCall = true;
    }

    // Without this, the drawer opens, the click event bubbles up to nodes.$page
    // which closes the drawer.
    if (evt && evt.stopPropagation) {
      evt.stopPropagation();
      // save the source of the click, we'll focus to this on close
      this.$activeSource = $(evt.currentTarget);
    }

    if (this.drawerIsOpen && !externalCall) {
      return this.close();
    }

    // Add is-transitioning class to moved elements on open so drawer can have
    // transition for close animation
    this.$drawer.prepareTransition();

    this.nodes.$parent.addClass(
      this.config.openClass + ' ' + this.config.dirOpenClass
    );
    this.drawerIsOpen = true;

    // Set focus on drawer
    slate.a11y.trapFocus({
      $container: this.$drawer,
      namespace: 'drawer_focus'
    });

    // Run function when draw opens if set
    if (
      this.config.onDrawerOpen &&
      typeof this.config.onDrawerOpen === 'function'
    ) {
      if (!externalCall) {
        this.config.onDrawerOpen();
      }
    }

    if (this.$activeSource && this.$activeSource.attr('aria-expanded')) {
      this.$activeSource.attr('aria-expanded', 'true');
    }

    this.bindEvents();

    return this;
  };

  Drawer.prototype.close = function() {
    if (!this.drawerIsOpen) {
      // don't close a closed drawer
      return;
    }

    // deselect any focused form elements
    $(document.activeElement).trigger('blur');

    // Ensure closing transition is applied to moved elements, like the nav
    this.$drawer.prepareTransition();

    this.nodes.$parent.removeClass(
      this.config.dirOpenClass + ' ' + this.config.openClass
    );

    if (this.$activeSource && this.$activeSource.attr('aria-expanded')) {
      this.$activeSource.attr('aria-expanded', 'false');
    }

    this.drawerIsOpen = false;

    // Remove focus on drawer
    slate.a11y.removeTrapFocus({
      $container: this.$drawer,
      namespace: 'drawer_focus'
    });

    this.unbindEvents();

    // Run function when draw closes if set
    if (
      this.config.onDrawerClose &&
      typeof this.config.onDrawerClose === 'function'
    ) {
      this.config.onDrawerClose();
    }
  };

  Drawer.prototype.bindEvents = function() {
    this.nodes.$parent.on(
      'keyup.drawer',
      $.proxy(function(evt) {
        // close on 'esc' keypress
        if (evt.keyCode === 27) {
          this.close();
          return false;
        } else {
          return true;
        }
      }, this)
    );

    // Lock scrolling on mobile
    this.nodes.$page.on('touchmove.drawer', function() {
      return false;
    });

    this.nodes.$page.on(
      'click.drawer',
      $.proxy(function() {
        this.close();
        return false;
      }, this)
    );
  };

  Drawer.prototype.unbindEvents = function() {
    this.nodes.$page.off('.drawer');
    this.nodes.$parent.off('.drawer');
  };

  return Drawer;
})();


/* ================ MODULES ================ */
window.theme = window.theme || {};

theme.Header = (function() {
  var selectors = {
    body: 'body',
    multicurrencySelector: '[data-currency-selector]',
    navigation: '#AccessibleNav',
    siteNavHasDropdown: '[data-has-dropdowns]',
    siteNavChildLinks: '.site-nav__child-link',
    siteNavActiveDropdown: '.site-nav--active-dropdown',
    siteNavHasCenteredDropdown: '.site-nav--has-centered-dropdown',
    siteNavCenteredDropdown: '.site-nav__dropdown--centered',
    siteNavLinkMain: '.site-nav__link--main',
    siteNavChildLink: '.site-nav__link--last',
    siteNavDropdown: '.site-nav__dropdown',
    siteHeader: '.site-header'
  };

  var config = {
    activeClass: 'site-nav--active-dropdown',
    childLinkClass: 'site-nav__child-link',
    rightDropdownClass: 'site-nav__dropdown--right',
    leftDropdownClass: 'site-nav__dropdown--left'
  };

  var cache = {};

  function init() {
    cacheSelectors();
    styleDropdowns($(selectors.siteNavHasDropdown));
    positionFullWidthDropdowns();

    cache.$parents.on('click.siteNav', function() {
      var $el = $(this);
      $el.hasClass(config.activeClass) ? hideDropdown($el) : showDropdown($el);
    });

    // check when we're leaving a dropdown and close the active dropdown
    $(selectors.siteNavChildLink).on('focusout.siteNav', function() {
      setTimeout(function() {
        if (
          $(document.activeElement).hasClass(config.childLinkClass) ||
          !cache.$activeDropdown.length
        ) {
          return;
        }

        hideDropdown(cache.$activeDropdown);
      });
    });

    // close dropdowns when on top level nav
    cache.$topLevel.on('focus.siteNav', function() {
      if (cache.$activeDropdown.length) {
        hideDropdown(cache.$activeDropdown);
      }
    });

    cache.$subMenuLinks.on('click.siteNav', function(evt) {
      // Prevent click on body from firing instead of link
      evt.stopImmediatePropagation();
    });

    $(selectors.multicurrencySelector).on('change', function() {
      $(this)
        .parents('form')
        .submit();
    });

    $(window).resize(
      $.debounce(50, function() {
        styleDropdowns($(selectors.siteNavHasDropdown));
        positionFullWidthDropdowns();
      })
    );
  }

  function cacheSelectors() {
    cache = {
      $nav: $(selectors.navigation),
      $topLevel: $(selectors.siteNavLinkMain),
      $parents: $(selectors.navigation).find(selectors.siteNavHasDropdown),
      $subMenuLinks: $(selectors.siteNavChildLinks),
      $activeDropdown: $(selectors.siteNavActiveDropdown),
      $siteHeader: $(selectors.siteHeader)
    };
  }

  function showDropdown($el) {
    $el.addClass(config.activeClass);

    // close open dropdowns
    if (cache.$activeDropdown.length) {
      hideDropdown(cache.$activeDropdown);
    }

    cache.$activeDropdown = $el;

    // set expanded on open dropdown
    $el.find(selectors.siteNavLinkMain).attr('aria-expanded', 'true');

    setTimeout(function() {
      $(window).on('keyup.siteNav', function(evt) {
        if (evt.keyCode === 27) {
          hideDropdown($el);
        }
      });

      $(selectors.body).on('click.siteNav', function() {
        hideDropdown($el);
      });
    }, 250);
  }

  function hideDropdown($el) {
    // remove aria on open dropdown
    $el.find(selectors.siteNavLinkMain).attr('aria-expanded', 'false');
    $el.removeClass(config.activeClass);

    // reset active dropdown
    cache.$activeDropdown = $(selectors.siteNavActiveDropdown);

    $(selectors.body).off('click.siteNav');
    $(window).off('keyup.siteNav');
  }

  function styleDropdowns($dropdownListItems) {
    $dropdownListItems.each(function() {
      var $dropdownLi = $(this).find(selectors.siteNavDropdown);
      if (!$dropdownLi.length) {
        return;
      }
      var isRightOfLogo =
        Math.ceil($(this).offset().left) >
        Math.floor(cache.$siteHeader.outerWidth()) / 2
          ? true
          : false;
      if (isRightOfLogo) {
        $dropdownLi
          .removeClass(config.leftDropdownClass)
          .addClass(config.rightDropdownClass);
      } else {
        $dropdownLi
          .removeClass(config.rightDropdownClass)
          .addClass(config.leftDropdownClass);
      }
    });
  }

  function positionFullWidthDropdowns() {
    var $listWithCenteredDropdown = $(selectors.siteNavHasCenteredDropdown);

    $listWithCenteredDropdown.each(function() {
      var $hasCenteredDropdown = $(this);
      var $fullWidthDropdown = $hasCenteredDropdown.find(
        selectors.siteNavCenteredDropdown
      );

      var fullWidthDropdownOffset = $hasCenteredDropdown.position().top + 41;
      $fullWidthDropdown.css('top', fullWidthDropdownOffset);
    });
  }

  function unload() {
    $(window).off('.siteNav');
    cache.$parents.off('.siteNav');
    cache.$subMenuLinks.off('.siteNav');
    cache.$topLevel.off('.siteNav');
    $(selectors.siteNavChildLink).off('.siteNav');
    $(selectors.body).off('.siteNav');
  }

  return {
    init: init,
    unload: unload
  };
})();

window.theme = window.theme || {};

theme.MobileNav = (function() {
  var classes = {
    mobileNavOpenIcon: 'mobile-nav--open',
    mobileNavCloseIcon: 'mobile-nav--close',
    navLinkWrapper: 'mobile-nav__item',
    navLink: 'mobile-nav__link',
    subNavLink: 'mobile-nav__sublist-link',
    return: 'mobile-nav__return-btn',
    subNavActive: 'is-active',
    subNavClosing: 'is-closing',
    navOpen: 'js-menu--is-open',
    subNavShowing: 'sub-nav--is-open',
    thirdNavShowing: 'third-nav--is-open',
    subNavToggleBtn: 'js-toggle-submenu'
  };
  var cache = {};
  var isTransitioning;
  var $activeSubNav;
  var $activeTrigger;
  var menuLevel = 1;
  // Breakpoints from src/stylesheets/global/variables.scss.liquid
  var mediaQuerySmall = 'screen and (max-width: 749px)';

  function init() {
    cacheSelectors();

    cache.$mobileNavToggle.on('click', toggleMobileNav);
    cache.$subNavToggleBtn.on('click.subNav', toggleSubNav);

    // Close mobile nav when unmatching mobile breakpoint
    enquire.register(mediaQuerySmall, {
      unmatch: function() {
        if (cache.$mobileNavContainer.hasClass(classes.navOpen)) {
          closeMobileNav();
        }
      }
    });
  }

  function toggleMobileNav() {
    if (cache.$mobileNavToggle.hasClass(classes.mobileNavCloseIcon)) {
      closeMobileNav();
    } else {
      openMobileNav();
    }
  }

  function cacheSelectors() {
    cache = {
      $pageContainer: $('#PageContainer'),
      $siteHeader: $('.site-header'),
      $mobileNavToggle: $('.js-mobile-nav-toggle'),
      $mobileNavContainer: $('.mobile-nav-wrapper'),
      $mobileNav: $('#MobileNav'),
      $sectionHeader: $('#shopify-section-header'),
      $subNavToggleBtn: $('.' + classes.subNavToggleBtn)
    };
  }

  function openMobileNav() {
    var translateHeaderHeight = cache.$siteHeader.outerHeight();

    cache.$mobileNavContainer.prepareTransition().addClass(classes.navOpen);

    cache.$mobileNavContainer.css({
      transform: 'translateY(' + translateHeaderHeight + 'px)'
    });

    cache.$pageContainer.css({
      transform:
        'translate3d(0, ' + cache.$mobileNavContainer[0].scrollHeight + 'px, 0)'
    });

    slate.a11y.trapFocus({
      $container: cache.$sectionHeader,
      $elementToFocus: cache.$mobileNavToggle,
      namespace: 'navFocus'
    });

    cache.$mobileNavToggle
      .addClass(classes.mobileNavCloseIcon)
      .removeClass(classes.mobileNavOpenIcon)
      .attr('aria-expanded', true);

    // close on escape
    $(window).on('keyup.mobileNav', function(evt) {
      if (evt.which === 27) {
        closeMobileNav();
      }
    });
  }

  function closeMobileNav() {
    cache.$mobileNavContainer.prepareTransition().removeClass(classes.navOpen);

    cache.$mobileNavContainer.css({
      transform: 'translateY(-100%)'
    });

    cache.$pageContainer.removeAttr('style');

    slate.a11y.trapFocus({
      $container: $('html'),
      $elementToFocus: $('body')
    });

    cache.$mobileNavContainer.one(
      'TransitionEnd.navToggle webkitTransitionEnd.navToggle transitionend.navToggle oTransitionEnd.navToggle',
      function() {
        slate.a11y.removeTrapFocus({
          $container: cache.$mobileNav,
          namespace: 'navFocus'
        });
      }
    );

    cache.$mobileNavToggle
      .addClass(classes.mobileNavOpenIcon)
      .removeClass(classes.mobileNavCloseIcon)
      .attr('aria-expanded', false)
      .focus();

    $(window).off('keyup.mobileNav');

    scrollTo(0, 0);
  }

  function toggleSubNav(evt) {
    if (isTransitioning) {
      return;
    }

    var $toggleBtn = $(evt.currentTarget);
    var isReturn = $toggleBtn.hasClass(classes.return);
    isTransitioning = true;

    if (isReturn) {
      // Close all subnavs by removing active class on buttons
      $(
        '.' + classes.subNavToggleBtn + '[data-level="' + (menuLevel - 1) + '"]'
      ).removeClass(classes.subNavActive);

      if ($activeTrigger && $activeTrigger.length) {
        $activeTrigger.removeClass(classes.subNavActive);
      }
    } else {
      $toggleBtn.addClass(classes.subNavActive);
    }

    $activeTrigger = $toggleBtn;

    goToSubnav($toggleBtn.data('target'));
  }

  function goToSubnav(target) {
    /*eslint-disable shopify/jquery-dollar-sign-reference */

    var $targetMenu = target
      ? $('.mobile-nav__dropdown[data-parent="' + target + '"]')
      : cache.$mobileNav;

    menuLevel = $targetMenu.data('level') ? $targetMenu.data('level') : 1;

    if ($activeSubNav && $activeSubNav.length) {
      $activeSubNav.prepareTransition().addClass(classes.subNavClosing);
    }

    $activeSubNav = $targetMenu;

    /*eslint-enable shopify/jquery-dollar-sign-reference */

    var translateMenuHeight = $targetMenu.outerHeight();

    var openNavClass =
      menuLevel > 2 ? classes.thirdNavShowing : classes.subNavShowing;

    cache.$mobileNavContainer
      .css('height', translateMenuHeight)
      .removeClass(classes.thirdNavShowing)
      .addClass(openNavClass);

    if (!target) {
      // Show top level nav
      cache.$mobileNavContainer
        .removeClass(classes.thirdNavShowing)
        .removeClass(classes.subNavShowing);
    }

    /* if going back to first subnav, focus is on whole header */
    var $container = menuLevel === 1 ? cache.$sectionHeader : $targetMenu;

    var $menuTitle = $targetMenu.find('[data-menu-title=' + menuLevel + ']');
    var $elementToFocus = $menuTitle ? $menuTitle : $targetMenu;

    // Focusing an item in the subnav early forces element into view and breaks the animation.
    cache.$mobileNavContainer.one(
      'TransitionEnd.subnavToggle webkitTransitionEnd.subnavToggle transitionend.subnavToggle oTransitionEnd.subnavToggle',
      function() {
        slate.a11y.trapFocus({
          $container: $container,
          $elementToFocus: $elementToFocus,
          namespace: 'subNavFocus'
        });

        cache.$mobileNavContainer.off('.subnavToggle');
        isTransitioning = false;
      }
    );

    // Match height of subnav
    cache.$pageContainer.css({
      transform: 'translateY(' + translateMenuHeight + 'px)'
    });

    $activeSubNav.removeClass(classes.subNavClosing);
  }

  return {
    init: init,
    closeMobileNav: closeMobileNav
  };
})(jQuery);

window.theme = window.theme || {};

theme.Search = (function() {
  var selectors = {
    search: '.search',
    searchSubmit: '.search__submit',
    searchInput: '.search__input',

    siteHeader: '.site-header',
    siteHeaderSearchToggle: '.site-header__search-toggle',
    siteHeaderSearch: '.site-header__search',

    searchDrawer: '.search-bar',
    searchDrawerInput: '.search-bar__input',

    searchHeader: '.search-header',
    searchHeaderInput: '.search-header__input',
    searchHeaderSubmit: '.search-header__submit',

    searchResultSubmit: '#SearchResultSubmit',
    searchResultInput: '#SearchInput',
    searchResultMessage: '[data-search-error-message]',

    mobileNavWrapper: '.mobile-nav-wrapper'
  };

  var classes = {
    focus: 'search--focus',
    hidden: 'hide',
    mobileNavIsOpen: 'js-menu--is-open',
    searchTemplate: 'template-search'
  };

  function init() {
    if (!$(selectors.siteHeader).length) {
      return;
    }

    this.$searchResultInput = $(selectors.searchResultInput);
    this.$searchErrorMessage = $(selectors.searchResultMessage);

    initDrawer();

    var isSearchPage =
      slate.utils.getParameterByName('q') !== null &&
      $('body').hasClass(classes.searchTemplate);

    if (isSearchPage) {
      validateSearchResultForm.call(this);
    }

    $(selectors.searchResultSubmit).on(
      'click',
      validateSearchResultForm.bind(this)
    );

    $(selectors.searchHeaderInput)
      .add(selectors.searchHeaderSubmit)
      .on('focus blur', function() {
        $(selectors.searchHeader).toggleClass(classes.focus);
      });

    $(selectors.siteHeaderSearchToggle).on('click', function() {
      var searchHeight = $(selectors.siteHeader).outerHeight();
      var searchOffset = $(selectors.siteHeader).offset().top - searchHeight;

      $(selectors.searchDrawer).css({
        height: searchHeight + 'px',
        top: searchOffset + 'px'
      });
    });
  }

  function initDrawer() {
    // Add required classes to HTML
    $('#PageContainer').addClass('drawer-page-content');
    $('.js-drawer-open-top')
      .attr('aria-controls', 'SearchDrawer')
      .attr('aria-expanded', 'false')
      .attr('aria-haspopup', 'dialog');

    theme.SearchDrawer = new theme.Drawers('SearchDrawer', 'top', {
      onDrawerOpen: searchDrawerFocus,
      onDrawerClose: searchDrawerFocusClose
    });
  }

  function searchDrawerFocus() {
    searchFocus($(selectors.searchDrawerInput));

    if ($(selectors.mobileNavWrapper).hasClass(classes.mobileNavIsOpen)) {
      theme.MobileNav.closeMobileNav();
    }
  }

  function searchFocus($el) {
    $el.focus();
    // set selection range hack for iOS
    $el[0].setSelectionRange(0, $el[0].value.length);
  }

  function searchDrawerFocusClose() {
    $(selectors.siteHeaderSearchToggle).focus();
  }

  /**
   * Remove the aria-attributes and hide the error messages
   */
  function hideErrorMessage() {
    this.$searchErrorMessage.addClass(classes.hidden);
    this.$searchResultInput
      .removeAttr('aria-describedby')
      .removeAttr('aria-invalid');
  }

  /**
   * Add the aria-attributes and show the error messages
   */
  function showErrorMessage() {
    this.$searchErrorMessage.removeClass(classes.hidden);
    this.$searchResultInput
      .attr('aria-describedby', 'error-search-form')
      .attr('aria-invalid', true);
  }

  function validateSearchResultForm(evt) {
    var isInputValueEmpty = this.$searchResultInput.val().trim().length === 0;

    if (!isInputValueEmpty) {
      hideErrorMessage.call(this);
      return;
    }

    if (typeof evt !== 'undefined') {
      evt.preventDefault();
    }

    searchFocus(this.$searchResultInput);
    showErrorMessage.call(this);
  }

  return {
    init: init
  };
})();

(function() {
  var selectors = {
    backButton: '.return-link'
  };

  var $backButton = $(selectors.backButton);

  if (!document.referrer || !$backButton.length || !window.history.length) {
    return;
  }

  $backButton.one('click', function(evt) {
    evt.preventDefault();

    var referrerDomain = urlDomain(document.referrer);
    var shopDomain = urlDomain(window.location.href);

    if (shopDomain === referrerDomain) {
      history.back();
    }

    return false;
  });

  function urlDomain(url) {
    var anchor = document.createElement('a');
    anchor.ref = url;

    return anchor.hostname;
  }
})();

theme.Slideshow = (function() {
  this.$slideshow = null;
  var classes = {
    slideshow: 'slideshow',
    slickActiveMobile: 'slick-active-mobile',
    controlsHover: 'slideshow__controls--hover',
    isPaused: 'is-paused'
  };

  var selectors = {
    section: '.shopify-section',
    wrapper: '#SlideshowWrapper-',
    slides: '.slideshow__slide',
    textWrapperMobile: '.slideshow__text-wrap--mobile',
    textContentMobile: '.slideshow__text-content--mobile',
    controls: '.slideshow__controls',
    pauseButton: '.slideshow__pause',
    dots: '.slick-dots',
    arrows: '.slideshow__arrows',
    arrowsMobile: '.slideshow__arrows--mobile',
    arrowLeft: '.slideshow__arrow-left',
    arrowRight: '.slideshow__arrow-right'
  };

  function slideshow(el, sectionId) {
    var $slideshow = (this.$slideshow = $(el));
    this.adaptHeight = this.$slideshow.data('adapt-height');
    this.$wrapper = this.$slideshow.closest(selectors.wrapper + sectionId);
    this.$section = this.$wrapper.closest(selectors.section);
    this.$controls = this.$wrapper.find(selectors.controls);
    this.$arrows = this.$section.find(selectors.arrows);
    this.$arrowsMobile = this.$section.find(selectors.arrowsMobile);
    this.$pause = this.$controls.find(selectors.pauseButton);
    this.$textWrapperMobile = this.$section.find(selectors.textWrapperMobile);
    this.autorotate = this.$slideshow.data('autorotate');
    var autoplaySpeed = this.$slideshow.data('speed');
    var loadSlideA11yString = this.$slideshow.data('slide-nav-a11y');

    this.settings = {
      accessibility: true,
      arrows: false,
      dots: true,
      fade: true,
      draggable: true,
      touchThreshold: 20,
      autoplay: this.autorotate,
      autoplaySpeed: autoplaySpeed,
      // eslint-disable-next-line shopify/jquery-dollar-sign-reference
      appendDots: this.$arrows,
      customPaging: function(slick, index) {
        return (
          '<a href="' +
          selectors.wrapper +
          sectionId +
          '" aria-label="' +
          loadSlideA11yString.replace('[slide_number]', index + 1) +
          '" data-slide-number="' +
          index +
          '"></a>'
        );
      }
    };

    this.$slideshow.on('beforeChange', beforeChange.bind(this));
    this.$slideshow.on('init', slideshowA11ySetup.bind(this));

    // Add class to style mobile dots & show the correct text content for the
    // first slide on mobile when the slideshow initialises
    this.$slideshow.on(
      'init',
      function() {
        this.$mobileDots
          .find('li:first-of-type')
          .addClass(classes.slickActiveMobile);
        this.showMobileText(0);
      }.bind(this)
    );

    // Stop the autorotate when you scroll past the mobile controls, resume when
    // they are scrolled back into view
    if (this.autorotate) {
      $(document).scroll(
        $.debounce(
          250,
          function() {
            if (
              this.$arrowsMobile.offset().top +
                this.$arrowsMobile.outerHeight() <
              window.pageYOffset
            ) {
              $slideshow.slick('slickPause');
            } else if (!this.$pause.hasClass(classes.isPaused)) {
              $slideshow.slick('slickPlay');
            }
          }.bind(this)
        )
      );
    }

    if (this.adaptHeight) {
      this.setSlideshowHeight();
      $(window).resize($.debounce(50, this.setSlideshowHeight.bind(this)));
    }

    this.$slideshow.slick(this.settings);

    // This can't be called when the slick 'init' event fires due to how slick
    // adds a11y features.
    slideshowPostInitA11ySetup.bind(this)();

    this.$arrows.find(selectors.arrowLeft).on('click', function() {
      $slideshow.slick('slickPrev');
    });
    this.$arrows.find(selectors.arrowRight).on('click', function() {
      $slideshow.slick('slickNext');
    });

    this.$pause.on('click', this.togglePause.bind(this));
  }

  function slideshowA11ySetup(event, obj) {
    var $slider = obj.$slider;
    var $list = obj.$list;
    this.$dots = this.$section.find(selectors.dots);
    this.$mobileDots = this.$dots.eq(1);

    // Remove default Slick aria-live attr until slider is focused
    $list.removeAttr('aria-live');

    this.$wrapper.on('keyup', keyboardNavigation.bind(this));
    this.$controls.on('keyup', keyboardNavigation.bind(this));
    this.$textWrapperMobile.on('keyup', keyboardNavigation.bind(this));

    // When an element in the slider is focused
    // pause slideshow and set aria-live.
    this.$wrapper
      .on(
        'focusin',
        function(evt) {
          if (!this.$wrapper.has(evt.target).length) {
            return;
          }

          $list.attr('aria-live', 'polite');
          if (this.autorotate) {
            $slider.slick('slickPause');
          }
        }.bind(this)
      )
      .on(
        'focusout',
        function(evt) {
          if (!this.$wrapper.has(evt.target).length) {
            return;
          }

          $list.removeAttr('aria-live');
          if (this.autorotate) {
            // Only resume playing if the user hasn't paused using the pause
            // button
            if (!this.$pause.is('.is-paused')) {
              $slider.slick('slickPlay');
            }
          }
        }.bind(this)
      );

    // Add arrow key support when focused
    if (this.$dots) {
      this.$dots
        .find('a')
        .each(function() {
          var $dot = $(this);
          $dot.on('click keyup', function(evt) {
            if (
              evt.type === 'keyup' &&
              evt.which !== slate.utils.keyboardKeys.ENTER
            )
              return;

            evt.preventDefault();

            var slideNumber = $(evt.target).data('slide-number');

            $slider.attr('tabindex', -1).slick('slickGoTo', slideNumber);

            if (evt.type === 'keyup') {
              $slider.focus();
            }
          });
        })
        .eq(0)
        .attr('aria-current', 'true');
    }

    this.$controls
      .on('focusin', highlightControls.bind(this))
      .on('focusout', unhighlightControls.bind(this));
  }

  function slideshowPostInitA11ySetup() {
    var $slides = this.$slideshow.find(selectors.slides);

    $slides.removeAttr('role').removeAttr('aria-labelledby');
    this.$dots
      .removeAttr('role')
      .find('li')
      .removeAttr('role')
      .removeAttr('aria-selected')
      .each(function() {
        var $dot = $(this);
        var ariaControls = $dot.attr('aria-controls');
        $dot
          .removeAttr('aria-controls')
          .find('a')
          .attr('aria-controls', ariaControls);
      });
  }

  function beforeChange(event, slick, currentSlide, nextSlide) {
    var $dotLinks = this.$dots.find('a');
    var $mobileDotLinks = this.$mobileDots.find('li');

    $dotLinks
      .removeAttr('aria-current')
      .eq(nextSlide)
      .attr('aria-current', 'true');

    $mobileDotLinks
      .removeClass(classes.slickActiveMobile)
      .eq(nextSlide)
      .addClass(classes.slickActiveMobile);
    this.showMobileText(nextSlide);
  }

  function keyboardNavigation() {
    if (event.keyCode === slate.utils.keyboardKeys.LEFTARROW) {
      this.$slideshow.slick('slickPrev');
    }
    if (event.keyCode === slate.utils.keyboardKeys.RIGHTARROW) {
      this.$slideshow.slick('slickNext');
    }
  }

  function highlightControls() {
    this.$controls.addClass(classes.controlsHover);
  }

  function unhighlightControls() {
    this.$controls.removeClass(classes.controlsHover);
  }

  slideshow.prototype.togglePause = function() {
    var slideshowSelector = getSlideshowId(this.$pause);
    if (this.$pause.hasClass(classes.isPaused)) {
      this.$pause.removeClass(classes.isPaused).attr('aria-pressed', 'false');
      if (this.autorotate) {
        $(slideshowSelector).slick('slickPlay');
      }
    } else {
      this.$pause.addClass(classes.isPaused).attr('aria-pressed', 'true');
      if (this.autorotate) {
        $(slideshowSelector).slick('slickPause');
      }
    }
  };

  slideshow.prototype.setSlideshowHeight = function() {
    var minAspectRatio = this.$slideshow.data('min-aspect-ratio');
    this.$slideshow.height($(document).width() / minAspectRatio);
  };

  slideshow.prototype.showMobileText = function(slideIndex) {
    var $allTextContent = this.$textWrapperMobile.find(
      selectors.textContentMobile
    );
    var currentTextContentSelector =
      selectors.textContentMobile + '-' + slideIndex;
    var $currentTextContent = this.$textWrapperMobile.find(
      currentTextContentSelector
    );
    if (
      !$currentTextContent.length &&
      this.$slideshow.find(selectors.slides).length === 1
    ) {
      this.$textWrapperMobile.hide();
    } else {
      this.$textWrapperMobile.show();
    }
    $allTextContent.hide();
    $currentTextContent.show();
  };

  function getSlideshowId($el) {
    return '#Slideshow-' + $el.data('id');
  }

  return slideshow;
})();

// Youtube API callback
// eslint-disable-next-line no-unused-vars
function onYouTubeIframeAPIReady() {
  theme.Video.loadVideos();
}

theme.Video = (function() {
  var autoplayCheckComplete = false;
  var playOnClickChecked = false;
  var playOnClick = false;
  var youtubeLoaded = false;
  var videos = {};
  var videoPlayers = [];
  var videoOptions = {
    ratio: 16 / 9,
    scrollAnimationDuration: 400,
    playerVars: {
      // eslint-disable-next-line camelcase
      iv_load_policy: 3,
      modestbranding: 1,
      autoplay: 0,
      controls: 0,
      wmode: 'opaque',
      branding: 0,
      autohide: 0,
      rel: 0
    },
    events: {
      onReady: onPlayerReady,
      onStateChange: onPlayerChange
    }
  };
  var classes = {
    playing: 'video-is-playing',
    paused: 'video-is-paused',
    loading: 'video-is-loading',
    loaded: 'video-is-loaded',
    backgroundVideoWrapper: 'video-background-wrapper',
    videoWithImage: 'video--image_with_play',
    backgroundVideo: 'video--background',
    userPaused: 'is-paused',
    supportsAutoplay: 'autoplay',
    supportsNoAutoplay: 'no-autoplay',
    wrapperMinHeight: 'video-section-wrapper--min-height'
  };

  var selectors = {
    section: '.video-section',
    videoWrapper: '.video-section-wrapper',
    playVideoBtn: '.video-control__play',
    closeVideoBtn: '.video-control__close-wrapper',
    pauseVideoBtn: '.video__pause',
    pauseVideoStop: '.video__pause-stop',
    pauseVideoResume: '.video__pause-resume',
    fallbackText: '.icon__fallback-text'
  };

  /**
   * Public functions
   */
  function init($video) {
    if (!$video.length) {
      return;
    }

    videos[$video.attr('id')] = {
      id: $video.attr('id'),
      videoId: $video.data('id'),
      type: $video.data('type'),
      status:
        $video.data('type') === 'image_with_play' ? 'closed' : 'background', // closed, open, background
      $video: $video,
      $videoWrapper: $video.closest(selectors.videoWrapper),
      $section: $video.closest(selectors.section),
      controls: $video.data('type') === 'background' ? 0 : 1
    };

    if (!youtubeLoaded) {
      // This code loads the IFrame Player API code asynchronously.
      var tag = document.createElement('script');
      tag.src = 'https://www.youtube.com/iframe_api';
      var firstScriptTag = document.getElementsByTagName('script')[0];
      firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
    }

    playOnClickCheck();
  }

  function customPlayVideo(playerId) {
    // Make sure we have carried out the playOnClick check first
    if (!playOnClickChecked && !playOnClick) {
      return;
    }

    if (playerId && typeof videoPlayers[playerId].playVideo === 'function') {
      privatePlayVideo(playerId);
    }
  }

  function pauseVideo(playerId) {
    if (
      videoPlayers[playerId] &&
      typeof videoPlayers[playerId].pauseVideo === 'function'
    ) {
      videoPlayers[playerId].pauseVideo();
    }
  }

  function loadVideos() {
    for (var key in videos) {
      if (videos.hasOwnProperty(key)) {
        createPlayer(key);
      }
    }

    initEvents();
    youtubeLoaded = true;
  }

  function editorLoadVideo(key) {
    if (!youtubeLoaded) {
      return;
    }
    createPlayer(key);

    initEvents();
  }

  /**
   * Private functions
   */

  function privatePlayVideo(id, clicked) {
    var videoData = videos[id];
    var player = videoPlayers[id];
    var $videoWrapper = videoData.$videoWrapper;

    if (playOnClick) {
      // playOnClick means we are probably on mobile (no autoplay).
      // setAsPlaying will show the iframe, requiring another click
      // to play the video.
      setAsPlaying(videoData);
    } else if (clicked || autoplayCheckComplete) {
      // Play if autoplay is available or clicked to play
      $videoWrapper.removeClass(classes.loading);
      setAsPlaying(videoData);
      player.playVideo();
      return;
    } else {
      player.playVideo();
    }
  }

  function setAutoplaySupport(supported) {
    var supportClass = supported
      ? classes.supportsAutoplay
      : classes.supportsNoAutoplay;
    $(document.documentElement)
      .removeClass(classes.supportsAutoplay)
      .removeClass(classes.supportsNoAutoplay)
      .addClass(supportClass);

    if (!supported) {
      playOnClick = true;
    }

    autoplayCheckComplete = true;
  }

  function playOnClickCheck() {
    // Bail early for a few instances:
    // - small screen
    // - device sniff mobile browser

    if (playOnClickChecked) {
      return;
    }

    if (isMobile()) {
      playOnClick = true;
    }

    if (playOnClick) {
      // No need to also do the autoplay check
      setAutoplaySupport(false);
    }

    playOnClickChecked = true;
  }

  // The API will call this function when each video player is ready
  function onPlayerReady(evt) {
    evt.target.setPlaybackQuality('hd1080');
    var videoData = getVideoOptions(evt);
    var videoTitle = evt.target.getVideoData().title;
    playOnClickCheck();

    // Prevent tabbing through YouTube player controls until visible
    $('#' + videoData.id).attr('tabindex', '-1');

    sizeBackgroundVideos();
    setButtonLabels(videoData.$videoWrapper, videoTitle);

    // Customize based on options from the video ID
    if (videoData.type === 'background') {
      evt.target.mute();
      privatePlayVideo(videoData.id);
    }

    videoData.$videoWrapper.addClass(classes.loaded);
  }

  function onPlayerChange(evt) {
    var videoData = getVideoOptions(evt);
    if (
      videoData.status === 'background' &&
      !isMobile() &&
      !autoplayCheckComplete &&
      (evt.data === YT.PlayerState.PLAYING ||
        evt.data === YT.PlayerState.BUFFERING)
    ) {
      setAutoplaySupport(true);
      autoplayCheckComplete = true;
      videoData.$videoWrapper.removeClass(classes.loading);
    }
    switch (evt.data) {
      case YT.PlayerState.ENDED:
        setAsFinished(videoData);
        break;
      case YT.PlayerState.PAUSED:
        // Seeking on a YouTube video also fires a PAUSED state change,
        // checking the state after a delay prevents us pausing the video when
        // the user is seeking instead of pausing
        setTimeout(function() {
          if (evt.target.getPlayerState() === YT.PlayerState.PAUSED) {
            setAsPaused(videoData);
          }
        }, 200);
        break;
    }
  }

  function setAsFinished(videoData) {
    switch (videoData.type) {
      case 'background':
        videoPlayers[videoData.id].seekTo(0);
        break;
      case 'image_with_play':
        closeVideo(videoData.id);
        toggleExpandVideo(videoData.id, false);
        break;
    }
  }

  function setAsPlaying(videoData) {
    var $videoWrapper = videoData.$videoWrapper;
    var $pauseButton = $videoWrapper.find(selectors.pauseVideoBtn);

    $videoWrapper.removeClass(classes.loading);

    if ($pauseButton.hasClass(classes.userPaused)) {
      $pauseButton.removeClass(classes.userPaused);
    }

    // Do not change element visibility if it is a background video
    if (videoData.status === 'background') {
      return;
    }

    $('#' + videoData.id).attr('tabindex', '0');

    if (videoData.type === 'image_with_play') {
      $videoWrapper.removeClass(classes.paused).addClass(classes.playing);
    }

    // Update focus to the close button so we stay within the video wrapper,
    // allowing time for the scroll animation
    setTimeout(function() {
      $videoWrapper.find(selectors.closeVideoBtn).focus();
    }, videoOptions.scrollAnimationDuration);
  }

  function setAsPaused(videoData) {
    var $videoWrapper = videoData.$videoWrapper;

    // YT's events fire after our click event. This status flag ensures
    // we don't interact with a closed or background video.
    if (videoData.type === 'image_with_play') {
      if (videoData.status === 'closed') {
        $videoWrapper.removeClass(classes.paused);
      } else {
        $videoWrapper.addClass(classes.paused);
      }
    }

    $videoWrapper.removeClass(classes.playing);
  }

  function closeVideo(playerId) {
    var videoData = videos[playerId];
    var $videoWrapper = videoData.$videoWrapper;
    var classesToRemove = [classes.paused, classes.playing].join(' ');

    if (isMobile()) {
      $videoWrapper.removeAttr('style');
    }

    $('#' + videoData.id).attr('tabindex', '-1');

    videoData.status = 'closed';

    switch (videoData.type) {
      case 'image_with_play':
        videoPlayers[playerId].stopVideo();
        setAsPaused(videoData); // in case the video is already paused
        break;
      case 'background':
        videoPlayers[playerId].mute();
        setBackgroundVideo(playerId);
        break;
    }

    $videoWrapper.removeClass(classesToRemove);
  }

  function getVideoOptions(evt) {
    return videos[evt.target.a.id];
  }

  function toggleExpandVideo(playerId, expand) {
    var video = videos[playerId];
    var elementTop = video.$videoWrapper.offset().top;
    var $playButton = video.$videoWrapper.find(selectors.playVideoBtn);
    var offset = 0;
    var newHeight = 0;

    if (isMobile()) {
      video.$videoWrapper.parent().toggleClass('page-width', !expand);
    }

    if (expand) {
      if (isMobile()) {
        newHeight = $(window).width() / videoOptions.ratio;
      } else {
        newHeight = video.$videoWrapper.width() / videoOptions.ratio;
      }
      offset = ($(window).height() - newHeight) / 2;

      video.$videoWrapper
        .removeClass(classes.wrapperMinHeight)
        .animate({ height: newHeight }, 600);

      // Animate doesn't work in mobile editor, so we don't use it
      if (!(isMobile() && Shopify.designMode)) {
        $('html, body').animate(
          {
            scrollTop: elementTop - offset
          },
          videoOptions.scrollAnimationDuration
        );
      }
    } else {
      if (isMobile()) {
        newHeight = video.$videoWrapper.data('mobile-height');
      } else {
        newHeight = video.$videoWrapper.data('desktop-height');
      }

      video.$videoWrapper
        .height(video.$videoWrapper.width() / videoOptions.ratio)
        .animate({ height: newHeight }, 600);
      setTimeout(function() {
        video.$videoWrapper.addClass(classes.wrapperMinHeight);
      }, 600);
      $playButton.focus();
    }
  }

  function togglePause(playerId) {
    var $pauseButton = videos[playerId].$videoWrapper.find(
      selectors.pauseVideoBtn
    );
    var paused = $pauseButton.hasClass(classes.userPaused);
    if (paused) {
      $pauseButton.removeClass(classes.userPaused);
      customPlayVideo(playerId);
    } else {
      $pauseButton.addClass(classes.userPaused);
      pauseVideo(playerId);
    }
    $pauseButton.attr('aria-pressed', !paused);
  }

  function startVideoOnClick(playerId) {
    var video = videos[playerId];

    // add loading class to wrapper
    video.$videoWrapper.addClass(classes.loading);

    // Explicity set the video wrapper height (needed for height transition)
    video.$videoWrapper.attr(
      'style',
      'height: ' + video.$videoWrapper.height() + 'px'
    );

    video.status = 'open';

    switch (video.type) {
      case 'image_with_play':
        privatePlayVideo(playerId, true);
        break;
      case 'background':
        unsetBackgroundVideo(playerId, video);
        videoPlayers[playerId].unMute();
        privatePlayVideo(playerId, true);
        break;
    }

    toggleExpandVideo(playerId, true);

    // esc to close video player
    $(document).on('keydown.videoPlayer', function(evt) {
      var playerId = $(document.activeElement).data('controls');
      if (evt.keyCode !== slate.utils.keyboardKeys.ESCAPE || !playerId) {
        return;
      }

      closeVideo(playerId);
      toggleExpandVideo(playerId, false);
    });
  }

  function sizeBackgroundVideos() {
    $('.' + classes.backgroundVideo).each(function(index, el) {
      sizeBackgroundVideo($(el));
    });
  }

  function sizeBackgroundVideo($videoPlayer) {
    if (!youtubeLoaded) {
      return;
    }

    if (isMobile()) {
      $videoPlayer.removeAttr('style');
    } else {
      var $videoWrapper = $videoPlayer.closest(selectors.videoWrapper);
      var videoWidth = $videoWrapper.width();
      var playerWidth = $videoPlayer.width();
      var desktopHeight = $videoWrapper.data('desktop-height');

      // when screen aspect ratio differs from video, video must center and underlay one dimension
      if (videoWidth / videoOptions.ratio < desktopHeight) {
        playerWidth = Math.ceil(desktopHeight * videoOptions.ratio); // get new player width
        $videoPlayer
          .width(playerWidth)
          .height(desktopHeight)
          .css({
            left: (videoWidth - playerWidth) / 2,
            top: 0
          }); // player width is greater, offset left; reset top
      } else {
        // new video width < window width (gap to right)
        desktopHeight = Math.ceil(videoWidth / videoOptions.ratio); // get new player height
        $videoPlayer
          .width(videoWidth)
          .height(desktopHeight)
          .css({
            left: 0,
            top: (desktopHeight - desktopHeight) / 2
          }); // player height is greater, offset top; reset left
      }

      $videoPlayer.prepareTransition();
      $videoWrapper.addClass(classes.loaded);
    }
  }

  function unsetBackgroundVideo(playerId) {
    // Switch the background video to a chrome-only player once played
    $('#' + playerId)
      .removeClass(classes.backgroundVideo)
      .addClass(classes.videoWithImage);

    setTimeout(function() {
      $('#' + playerId).removeAttr('style');
    }, 600);

    videos[playerId].$videoWrapper
      .removeClass(classes.backgroundVideoWrapper)
      .addClass(classes.playing);

    videos[playerId].status = 'open';
  }

  function setBackgroundVideo(playerId) {
    $('#' + playerId)
      .removeClass(classes.videoWithImage)
      .addClass(classes.backgroundVideo);

    videos[playerId].$videoWrapper.addClass(classes.backgroundVideoWrapper);

    videos[playerId].status = 'background';
    sizeBackgroundVideo($('#' + playerId));
  }

  function isMobile() {
    return $(window).width() < 750 || window.mobileCheck();
  }

  function initEvents() {
    $(document).on('click.videoPlayer', selectors.playVideoBtn, function(evt) {
      var playerId = $(evt.currentTarget).data('controls');

      startVideoOnClick(playerId);
    });

    $(document).on('click.videoPlayer', selectors.closeVideoBtn, function(evt) {
      var playerId = $(evt.currentTarget).data('controls');

      $(evt.currentTarget).blur();
      closeVideo(playerId);
      toggleExpandVideo(playerId, false);
    });

    $(document).on('click.videoPlayer', selectors.pauseVideoBtn, function(evt) {
      var playerId = $(evt.currentTarget).data('controls');
      togglePause(playerId);
    });

    // Listen to resize to keep a background-size:cover-like layout
    $(window).on(
      'resize.videoPlayer',
      $.debounce(200, function() {
        if (!youtubeLoaded) return;
        var key;
        var fullscreen = window.innerHeight === screen.height;

        sizeBackgroundVideos();

        if (isMobile()) {
          for (key in videos) {
            if (videos.hasOwnProperty(key)) {
              if (videos[key].$videoWrapper.hasClass(classes.playing)) {
                if (!fullscreen) {
                  pauseVideo(key);
                  setAsPaused(videos[key]);
                }
              }
              videos[key].$videoWrapper.height(
                $(document).width() / videoOptions.ratio
              );
            }
          }
          setAutoplaySupport(false);
        } else {
          setAutoplaySupport(true);
          for (key in videos) {
            if (
              videos[key].$videoWrapper.find('.' + classes.videoWithImage)
                .length
            ) {
              continue;
            }
            videoPlayers[key].playVideo();
            setAsPlaying(videos[key]);
          }
        }
      })
    );

    $(window).on(
      'scroll.videoPlayer',
      $.debounce(50, function() {
        if (!youtubeLoaded) return;

        for (var key in videos) {
          if (videos.hasOwnProperty(key)) {
            var $videoWrapper = videos[key].$videoWrapper;

            // Close the video if more than 75% of it is scrolled out of view
            if (
              $videoWrapper.hasClass(classes.playing) &&
              ($videoWrapper.offset().top + $videoWrapper.height() * 0.75 <
                $(window).scrollTop() ||
                $videoWrapper.offset().top + $videoWrapper.height() * 0.25 >
                  $(window).scrollTop() + $(window).height())
            ) {
              closeVideo(key);
              toggleExpandVideo(key, false);
            }
          }
        }
      })
    );
  }

  function createPlayer(key) {
    var args = $.extend({}, videoOptions, videos[key]);
    args.playerVars.controls = args.controls;
    videoPlayers[key] = new YT.Player(key, args);
  }

  function removeEvents() {
    $(document).off('.videoPlayer');
    $(window).off('.videoPlayer');
  }

  function setButtonLabels($videoWrapper, title) {
    var $playButtons = $videoWrapper.find(selectors.playVideoBtn);
    var $closeButton = $videoWrapper.find(selectors.closeVideoBtn);
    var $pauseButton = $videoWrapper.find(selectors.pauseVideoBtn);
    var $closeButtonText = $closeButton.find(selectors.fallbackText);
    var $pauseButtonStopText = $pauseButton
      .find(selectors.pauseVideoStop)
      .find(selectors.fallbackText);
    var $pauseButtonResumeText = $pauseButton
      .find(selectors.pauseVideoResume)
      .find(selectors.fallbackText);

    // Insert the video title retrieved from YouTube into the instructional text
    // for each button
    $playButtons.each(function() {
      var $playButton = $(this);
      var $playButtonText = $playButton.find(selectors.fallbackText);

      $playButtonText.text(
        $playButtonText.text().replace('[video_title]', title)
      );
    });
    $closeButtonText.text(
      $closeButtonText.text().replace('[video_title]', title)
    );
    $pauseButtonStopText.text(
      $pauseButtonStopText.text().replace('[video_title]', title)
    );
    $pauseButtonResumeText.text(
      $pauseButtonResumeText.text().replace('[video_title]', title)
    );
  }

  return {
    init: init,
    editorLoadVideo: editorLoadVideo,
    loadVideos: loadVideos,
    playVideo: customPlayVideo,
    pauseVideo: pauseVideo,
    removeEvents: removeEvents
  };
})();

window.theme = window.theme || {};

theme.FormStatus = (function() {
  var selectors = {
    statusMessage: '[data-form-status]'
  };

  function init() {
    this.$statusMessage = $(selectors.statusMessage);

    if (!this.$statusMessage) return;

    this.$statusMessage.attr('tabindex', -1).focus();

    this.$statusMessage.on('blur', handleBlur.bind(this));
  }

  function handleBlur() {
    this.$statusMessage.removeAttr('tabindex');
  }

  return {
    init: init
  };
})();

theme.Hero = (function() {
  var classes = {
    indexSectionFlush: 'index-section--flush'
  };

  var selectors = {
    heroFixedWidthContent: '.hero-fixed-width__content',
    heroFixedWidthImage: '.hero-fixed-width__image'
  };

  function hero(el, sectionId) {
    this.$hero = $(el);
    this.layout = this.$hero.data('layout');
    var $parentSection = $('#shopify-section-' + sectionId);
    var $heroContent = $parentSection.find(selectors.heroFixedWidthContent);
    var $heroImage = $parentSection.find(selectors.heroFixedWidthImage);

    if (this.layout !== 'fixed_width') {
      return;
    }

    $parentSection.removeClass(classes.indexSectionFlush);
    heroFixedHeight();
    $(window).resize(
      $.debounce(50, function() {
        heroFixedHeight();
      })
    );

    function heroFixedHeight() {
      var contentHeight = $heroContent.height() + 50;
      var imageHeight = $heroImage.height();

      if (contentHeight > imageHeight) {
        $heroImage.css('min-height', contentHeight);
      }
    }
  }

  return hero;
})();


/* ================ TEMPLATES ================ */
(function() {
  var $filterBy = $('#BlogTagFilter');

  if (!$filterBy.length) {
    return;
  }

  $filterBy.on('change', function() {
    location.href = $(this).val();
  });
})();

window.theme = theme || {};

theme.customerTemplates = (function() {
  var selectors = {
    RecoverHeading: '#RecoverHeading',
    RecoverEmail: '#RecoverEmail',
    LoginHeading: '#LoginHeading'
  };

  function initEventListeners() {
    this.$RecoverHeading = $(selectors.RecoverHeading);
    this.$RecoverEmail = $(selectors.RecoverEmail);
    this.$LoginHeading = $(selectors.LoginHeading);

    // Show reset password form
    $('#RecoverPassword').on(
      'click',
      function(evt) {
        evt.preventDefault();
        showRecoverPasswordForm();
        this.$RecoverHeading.attr('tabindex', '-1').focus();
      }.bind(this)
    );

    // Hide reset password form
    $('#HideRecoverPasswordLink').on(
      'click',
      function(evt) {
        evt.preventDefault();
        hideRecoverPasswordForm();
        this.$LoginHeading.attr('tabindex', '-1').focus();
      }.bind(this)
    );

    this.$RecoverHeading.on('blur', function() {
      $(this).removeAttr('tabindex');
    });

    this.$LoginHeading.on('blur', function() {
      $(this).removeAttr('tabindex');
    });
  }

  /**
   *
   *  Show/Hide recover password form
   *
   */

  function showRecoverPasswordForm() {
    $('#RecoverPasswordForm').removeClass('hide');
    $('#CustomerLoginForm').addClass('hide');

    if (this.$RecoverEmail.attr('aria-invalid') === 'true') {
      this.$RecoverEmail.focus();
    }
  }

  function hideRecoverPasswordForm() {
    $('#RecoverPasswordForm').addClass('hide');
    $('#CustomerLoginForm').removeClass('hide');
  }

  /**
   *
   *  Show reset password success message
   *
   */
  function resetPasswordSuccess() {
    var $formState = $('.reset-password-success');

    // check if reset password form was successfully submited.
    if (!$formState.length) {
      return;
    }

    // show success message
    $('#ResetSuccess')
      .removeClass('hide')
      .focus();
  }

  /**
   *
   *  Show/hide customer address forms
   *
   */
  function customerAddressForm() {
    var $newAddressForm = $('#AddressNewForm');
    var $newAddressFormButton = $('#AddressNewButton');

    if (!$newAddressForm.length) {
      return;
    }

    // Initialize observers on address selectors, defined in shopify_common.js
    if (Shopify) {
      // eslint-disable-next-line no-new
      new Shopify.CountryProvinceSelector(
        'AddressCountryNew',
        'AddressProvinceNew',
        {
          hideElement: 'AddressProvinceContainerNew'
        }
      );
    }

    // Initialize each edit form's country/province selector
    $('.address-country-option').each(function() {
      var formId = $(this).data('form-id');
      var countrySelector = 'AddressCountry_' + formId;
      var provinceSelector = 'AddressProvince_' + formId;
      var containerSelector = 'AddressProvinceContainer_' + formId;

      // eslint-disable-next-line no-new
      new Shopify.CountryProvinceSelector(countrySelector, provinceSelector, {
        hideElement: containerSelector
      });
    });

    // Toggle new/edit address forms
    $('.address-new-toggle').on('click', function() {
      var isExpanded = $newAddressFormButton.attr('aria-expanded') === 'true';

      $newAddressForm.toggleClass('hide');
      $newAddressFormButton.attr('aria-expanded', !isExpanded).focus();
    });

    $('.address-edit-toggle').on('click', function() {
      var formId = $(this).data('form-id');
      var $editButton = $('#EditFormButton_' + formId);
      var $editAddress = $('#EditAddress_' + formId);
      var isExpanded = $editButton.attr('aria-expanded') === 'true';

      $editAddress.toggleClass('hide');
      $editButton.attr('aria-expanded', !isExpanded).focus();
    });

    $('.address-delete').on('click', function() {
      var $el = $(this);
      var target = $el.data('target');
      var confirmMessage = $el.data('confirm-message');

      // eslint-disable-next-line no-alert
      if (
        confirm(
          confirmMessage || 'Are you sure you wish to delete this address?'
        )
      ) {
        Shopify.postLink(target, {
          parameters: { _method: 'delete' }
        });
      }
    });
  }

  /**
   *
   *  Check URL for reset password hash
   *
   */
  function checkUrlHash() {
    var hash = window.location.hash;

    // Allow deep linking to recover password form
    if (hash === '#recover') {
      showRecoverPasswordForm.bind(this)();
    }
  }

  return {
    init: function() {
      initEventListeners();
      checkUrlHash();
      resetPasswordSuccess();
      customerAddressForm();
    }
  };
})();


/*================ SECTIONS ================*/
window.theme = window.theme || {};

theme.Cart = (function() {
  var selectors = {
    cartCount: '[data-cart-count]',
    cartCountBubble: '[data-cart-count-bubble]',
    cartDiscount: '[data-cart-discount]',
    cartDiscountTitle: '[data-cart-discount-title]',
    cartDiscountAmount: '[data-cart-discount-amount]',
    cartDiscountWrapper: '[data-cart-discount-wrapper]',
    cartErrorMessage: '[data-cart-error-message]',
    cartErrorMessageWrapper: '[data-cart-error-message-wrapper]',
    cartItem: '[data-cart-item]',
    cartItemDetails: '[data-cart-item-details]',
    cartItemDiscount: '[data-cart-item-discount]',
    cartItemDiscountedPriceGroup: '[data-cart-item-discounted-price-group]',
    cartItemDiscountTitle: '[data-cart-item-discount-title]',
    cartItemDiscountAmount: '[data-cart-item-discount-amount]',
    cartItemDiscountList: '[data-cart-item-discount-list]',
    cartItemFinalPrice: '[data-cart-item-final-price]',
    cartItemImage: '[data-cart-item-image]',
    cartItemLinePrice: '[data-cart-item-line-price]',
    cartItemOriginalPrice: '[data-cart-item-original-price]',
    cartItemPrice: '[data-cart-item-price]',
    cartItemPriceList: '[data-cart-item-price-list]',
    cartItemProperty: '[data-cart-item-property]',
    cartItemPropertyName: '[data-cart-item-property-name]',
    cartItemPropertyValue: '[data-cart-item-property-value]',
    cartItemRegularPriceGroup: '[data-cart-item-regular-price-group]',
    cartItemRegularPrice: '[data-cart-item-regular-price]',
    cartItemTitle: '[data-cart-item-title]',
    cartItemOption: '[data-cart-item-option]',
    cartLineItems: '[data-cart-line-items]',
    cartNote: '[data-cart-notes]',
    cartQuantityErrorMessage: '[data-cart-quantity-error-message]',
    cartQuantityErrorMessageWrapper:
      '[data-cart-quantity-error-message-wrapper]',
    cartRemove: '[data-cart-remove]',
    cartStatus: '[data-cart-status]',
    cartSubtotal: '[data-cart-subtotal]',
    cartTableCell: '[data-cart-table-cell]',
    cartWrapper: '[data-cart-wrapper]',
    emptyPageContent: '[data-empty-page-content]',
    quantityInput: '[data-quantity-input]',
    quantityInputMobile: '[data-quantity-input-mobile]',
    quantityInputDesktop: '[data-quantity-input-desktop]',
    quantityLabelMobile: '[data-quantity-label-mobile]',
    quantityLabelDesktop: '[data-quantity-label-desktop]',
    inputQty: '[data-quantity-input]',
    thumbnails: '.cart__image',
    unitPrice: '[data-unit-price]',
    unitPriceBaseUnit: '[data-unit-price-base-unit]',
    unitPriceGroup: '[data-unit-price-group]'
  };

  var classes = {
    cartNoCookies: 'cart--no-cookies',
    cartRemovedProduct: 'cart__removed-product',
    hide: 'hide',
    inputError: 'input--error'
  };

  var attributes = {
    cartItemIndex: 'data-cart-item-index',
    cartItemKey: 'data-cart-item-key',
    cartItemQuantity: 'data-cart-item-quantity',
    cartItemTitle: 'data-cart-item-title',
    cartItemUrl: 'data-cart-item-url',
    quantityItem: 'data-quantity-item'
  };

  theme.breakpoints = theme.breakpoints || {};

  if (
    isNaN(theme.breakpoints.medium) ||
    theme.breakpoints.medium === undefined
  ) {
    theme.breakpoints.medium = 750;
  }

  var mediumUpQuery = '(min-width: ' + theme.breakpoints.medium + 'px)';

  function Cart(container) {
    this.$container = $(container);
    this.$thumbnails = $(selectors.thumbnails, this.$container);
    this.ajaxEnabled = this.$container.data('ajax-enabled');

    if (!this.cookiesEnabled()) {
      this.$container.addClass(classes.cartNoCookies);
    }

    this.$thumbnails.css('cursor', 'pointer');
    this.$container.on(
      'click',
      selectors.thumbnails,
      this._handleThumbnailClick
    );

    this.$container.on(
      'change',
      selectors.inputQty,
      $.debounce(500, this._handleInputQty.bind(this))
    );

    this.mql = window.matchMedia(mediumUpQuery);
    this.mql.addListener(this.setQuantityFormControllers.bind(this));
    this.setQuantityFormControllers();

    if (this.ajaxEnabled) {
      /**
       * Because the entire cart is recreated when a cart item is updated,
       * we cannot cache the elements in the cart. Instead, we add the event
       * listeners on the cart's container to allow us to retain the event
       * listeners after rebuilding the cart when an item is updated.
       */

      this.$container.on(
        'change',
        selectors.cartNote,
        this._onNoteChange.bind(this)
      );

      this.$container.on(
        'click',
        selectors.cartRemove,
        this._onRemoveItem.bind(this)
      );

      this._setupCartTemplates();
    }
  }

  Cart.prototype = _.assignIn({}, Cart.prototype, {
    _setupCartTemplates: function() {
      this.$itemTemplate = $(selectors.cartItem, this.$container)
        .first()
        .clone();
      this.$itemDiscountTemplate = $(
        selectors.cartItemDiscount,
        this.$itemTemplate
      ).clone();
      this.$itemOptionTemplate = $(
        selectors.cartItemOption,
        this.$itemTemplate
      ).clone();
      this.$itemPropertyTemplate = $(
        selectors.cartItemProperty,
        this.$itemTemplate
      ).clone();
      this.$itemPriceListTemplate = $(
        selectors.cartItemPriceList,
        this.$itemTemplate
      ).clone();
      this.$itemLinePriceTemplate = $(
        selectors.cartItemLinePrice,
        this.$itemTemplate
      ).clone();
      this.$cartDiscountTemplate = $(
        selectors.cartDiscount,
        this.$container
      ).clone();
    },

    _handleInputQty: function(evt) {
      var $input = $(evt.target);
      var itemIndex = $input.data('quantity-item');
      var $itemElement = $input.closest(selectors.cartItem);
      var $itemQtyInputs = $('[data-quantity-item=' + itemIndex + ']');
      var value = parseInt($input.val());
      var isValidValue = !(value < 0 || isNaN(value));
      $itemQtyInputs.val(value);

      this._hideCartError();
      this._hideQuantityErrorMessage();

      if (!isValidValue) {
        this._showQuantityErrorMessages($itemElement);
        return;
      }

      if (isValidValue && this.ajaxEnabled) {
        this._updateItemQuantity(
          itemIndex,
          $itemElement,
          $itemQtyInputs,
          value
        );
      }
    },

    _updateItemQuantity: function(
      itemIndex,
      $itemElement,
      $itemQtyInputs,
      value
    ) {
      var key = $itemElement.attr(attributes.cartItemKey);
      var index = $itemElement.attr(attributes.cartItemIndex);

      var params = {
        url: '/cart/change.js',
        data: { quantity: value, line: index },
        dataType: 'json'
      };

      $.post(params)
        .done(
          function(state) {
            if (state.item_count === 0) {
              this._emptyCart();
            } else {
              this._createCart(state);

              if (value === 0) {
                this._showRemoveMessage($itemElement.clone());
              } else {
                var $lineItem = $('[data-cart-item-key="' + key + '"]');
                var item = this.getItem(key, state);

                $(selectors.quantityInput, $lineItem).focus();
                this._updateLiveRegion(item);
              }
            }

            this._setCartCountBubble(state.item_count);
          }.bind(this)
        )
        .fail(
          function() {
            this._showCartError($itemQtyInputs);
          }.bind(this)
        );
    },

    getItem: function(key, state) {
      return state.items.find(function(item) {
        return item.key === key;
      });
    },

    _liveRegionText: function(item) {
      // Dummy content for live region
      var liveRegionText =
        theme.strings.update +
        ': [QuantityLabel]: [Quantity], [Regular] [$$] [DiscountedPrice] [$]. [PriceInformation]';

      // Update Quantity
      liveRegionText = liveRegionText
        .replace('[QuantityLabel]', theme.strings.quantity)
        .replace('[Quantity]', item.quantity);

      // Update pricing information
      var regularLabel = '';
      var regularPrice = theme.Currency.formatMoney(
        item.original_line_price,
        theme.moneyFormat
      );
      var discountLabel = '';
      var discountPrice = '';
      var discountInformation = '';

      if (item.original_line_price > item.final_line_price) {
        regularLabel = theme.strings.regularTotal;

        discountLabel = theme.strings.discountedTotal;
        discountPrice = theme.Currency.formatMoney(
          item.final_line_price,
          theme.moneyFormat
        );

        discountInformation = theme.strings.priceColumn;
      }

      liveRegionText = liveRegionText
        .replace('[Regular]', regularLabel)
        .replace('[$$]', regularPrice)
        .replace('[DiscountedPrice]', discountLabel)
        .replace('[$]', discountPrice)
        .replace('[PriceInformation]', discountInformation)
        .trim();

      return liveRegionText;
    },

    _updateLiveRegion: function(item) {
      var $liveRegion = $(selectors.cartStatus);
      $liveRegion.html(this._liveRegionText(item)).attr('aria-hidden', false);

      // hide content from accessibility tree after announcement
      setTimeout(function() {
        $liveRegion.attr('aria-hidden', true);
      }, 1000);
    },

    _createCart: function(state) {
      var cartDiscountList = this._createCartDiscountList(state);

      $(selectors.cartLineItems, this.$container).html(
        this._createLineItemList(state)
      );

      this.setQuantityFormControllers();

      $(selectors.cartNote, this.$container).val(state.note);

      if (cartDiscountList.length === 0) {
        $(selectors.cartDiscountWrapper, this.$container)
          .html('')
          .addClass(classes.hide);
      } else {
        $(selectors.cartDiscountWrapper, this.$container)
          .html(cartDiscountList)
          .removeClass(classes.hide);
      }

      $(selectors.cartSubtotal, this.$container).html(
        theme.Currency.formatMoney(
          state.total_price,
          theme.moneyFormatWithCurrency
        )
      );
    },

    _createCartDiscountList: function(cart) {
      return $.map(
        cart.cart_level_discount_applications,
        function(discount) {
          var $discount = this.$cartDiscountTemplate.clone();
          $discount.find(selectors.cartDiscountTitle).text(discount.title);
          $discount
            .find(selectors.cartDiscountAmount)
            .html(
              theme.Currency.formatMoney(
                discount.total_allocated_amount,
                theme.moneyFormat
              )
            );
          return $discount[0];
        }.bind(this)
      );
    },

    _createLineItemList: function(state) {
      return $.map(
        state.items,
        function(item, index) {
          var $item = this.$itemTemplate.clone();
          var $itemPriceList = this.$itemPriceListTemplate.clone();

          this._setLineItemAttributes($item, item, index);
          this._setLineItemImage($item, item.featured_image);

          $(selectors.cartItemTitle, $item)
            .text(item.product_title)
            .attr('href', item.url);

          var productDetailsList = this._createProductDetailsList(
            item.product_has_only_default_variant,
            item.options_with_values,
            item.properties
          );
          this._setProductDetailsList($item, productDetailsList);

          this._setItemRemove($item, item.title);

          $itemPriceList.html(
            this._createItemPrice(
              item.original_price,
              item.final_price,
              this.$itemPriceListTemplate
            )
          );

          if (item.unit_price_measurement) {
            $itemPriceList.append(
              this._createUnitPrice(
                item.unit_price,
                item.unit_price_measurement,
                this.$itemPriceListTemplate
              )
            );
          }

          this._setItemPrice($item, $itemPriceList);

          var itemDiscountList = this._createItemDiscountList(item);
          this._setItemDiscountList($item, itemDiscountList);

          this._setQuantityInputs($item, item, index);

          var itemLinePrice = this._createItemPrice(
            item.original_line_price,
            item.final_line_price,
            this.$itemLinePriceTemplate
          );
          this._setItemLinePrice($item, itemLinePrice);

          return $item[0];
        }.bind(this)
      );
    },

    _setLineItemAttributes: function($item, item, index) {
      $item
        .attr(attributes.cartItemKey, item.key)
        .attr(attributes.cartItemUrl, item.url)
        .attr(attributes.cartItemTitle, item.title)
        .attr(attributes.cartItemIndex, index + 1)
        .attr(attributes.cartItemQuantity, item.quantity);
    },

    _setLineItemImage: function($item, featuredImage) {
      var $image = $(selectors.cartItemImage, $item);

      var sizedImageUrl =
        featuredImage.url !== null
          ? theme.Images.getSizedImageUrl(featuredImage.url, 'x190')
          : null;

      if (sizedImageUrl) {
        $image
          .attr('alt', featuredImage.alt)
          .attr('src', sizedImageUrl)
          .removeClass(classes.hide);
      } else {
        $image.remove();
      }
    },

    _setProductDetailsList: function($item, productDetailsList) {
      var $itemDetails = $(selectors.cartItemDetails, $item);

      if (productDetailsList.length === 0) {
        $itemDetails.addClass(classes.hide).text('');
      } else {
        $itemDetails.removeClass(classes.hide).html(productDetailsList);
      }
    },

    _setItemPrice: function($item, price) {
      $(selectors.cartItemPrice, $item).html(price);
    },

    _setItemDiscountList: function($item, discountList) {
      var $itemDiscountList = $(selectors.cartItemDiscountList, $item);

      if (discountList.length === 0) {
        $itemDiscountList.html('').addClass(classes.hide);
      } else {
        $itemDiscountList.html(discountList).removeClass(classes.hide);
      }
    },

    _setItemRemove: function($item, title) {
      $(selectors.cartRemove, $item).attr(
        'aria-label',
        theme.strings.removeLabel.replace('[product]', title)
      );
    },

    _setQuantityInputs: function($item, item, index) {
      $(selectors.quantityInputMobile, $item)
        .attr('id', 'updates_' + item.key)
        .attr(attributes.quantityItem, index + 1)
        .val(item.quantity);

      $(selectors.quantityInputDesktop, $item)
        .attr('id', 'updates_large_' + item.key)
        .attr(attributes.quantityItem, index + 1)
        .val(item.quantity);

      $(selectors.quantityLabelMobile, $item).attr(
        'for',
        'updates_' + item.key
      );

      $(selectors.quantityLabelDesktop, $item).attr(
        'for',
        'updates_large_' + item.key
      );
    },

    setQuantityFormControllers: function() {
      if (this.mql.matches) {
        $(selectors.quantityInputDesktop).attr('name', 'updates[]');
        $(selectors.quantityInputMobile).removeAttr('name');
      } else {
        $(selectors.quantityInputMobile).attr('name', 'updates[]');
        $(selectors.quantityInputDesktop).removeAttr('name');
      }
    },

    _setItemLinePrice: function($item, price) {
      $(selectors.cartItemLinePrice, $item).html(price);
    },

    _createProductDetailsList: function(
      product_has_only_default_variant,
      options,
      properties
    ) {
      var optionsPropertiesHTML = [];

      if (!product_has_only_default_variant) {
        optionsPropertiesHTML = optionsPropertiesHTML.concat(
          this._getOptionList(options)
        );
      }

      if (properties !== null && Object.keys(properties).length !== 0) {
        optionsPropertiesHTML = optionsPropertiesHTML.concat(
          this._getPropertyList(properties)
        );
      }

      return optionsPropertiesHTML;
    },

    _getOptionList: function(options) {
      return $.map(
        options,
        function(option) {
          var $optionElement = this.$itemOptionTemplate.clone();

          $optionElement
            .text(option.name + ': ' + option.value)
            .removeClass(classes.hide);

          return $optionElement[0];
        }.bind(this)
      );
    },

    _getPropertyList: function(properties) {
      var propertiesArray =
        properties !== null ? Object.entries(properties) : [];

      return $.map(
        propertiesArray,
        function(property) {
          var $propertyElement = this.$itemPropertyTemplate.clone();

          // Line item properties prefixed with an underscore are not to be displayed
          if (property[0].charAt(0) === '_') return;

          // if the property value has a length of 0 (empty), don't display it
          if (property[1].length === 0) return;

          $propertyElement
            .find(selectors.cartItemPropertyName)
            .text(property[0]);

          if (property[0].indexOf('/uploads/') === -1) {
            $propertyElement
              .find(selectors.cartItemPropertyValue)
              .text(': ' + property[1]);
          } else {
            $propertyElement
              .find(selectors.cartItemPropertyValue)
              .html(
                ': <a href="' +
                  property[1] +
                  '"> ' +
                  property[1].split('/').pop() +
                  '</a>'
              );
          }

          $propertyElement.removeClass(classes.hide);

          return $propertyElement[0];
        }.bind(this)
      );
    },

    _createItemPrice: function(original_price, final_price, $priceTemplate) {
      if (original_price !== final_price) {
        var $discountedPrice = $(
          selectors.cartItemDiscountedPriceGroup,
          $priceTemplate
        ).clone();

        $(selectors.cartItemOriginalPrice, $discountedPrice).html(
          theme.Currency.formatMoney(original_price, theme.moneyFormat)
        );
        $(selectors.cartItemFinalPrice, $discountedPrice).html(
          theme.Currency.formatMoney(final_price, theme.moneyFormat)
        );
        $discountedPrice.removeClass(classes.hide);

        return $discountedPrice[0];
      } else {
        var $regularPrice = $(
          selectors.cartItemRegularPriceGroup,
          $priceTemplate
        ).clone();

        $(selectors.cartItemRegularPrice, $regularPrice).html(
          theme.Currency.formatMoney(original_price, theme.moneyFormat)
        );

        $regularPrice.removeClass(classes.hide);

        return $regularPrice[0];
      }
    },

    _createUnitPrice: function(
      unitPrice,
      unitPriceMeasurement,
      $itemPriceGroup
    ) {
      var $unitPriceGroup = $(
        selectors.unitPriceGroup,
        $itemPriceGroup
      ).clone();

      var unitPriceBaseUnit =
        (unitPriceMeasurement.reference_value !== 1
          ? unitPriceMeasurement.reference_value
          : '') + unitPriceMeasurement.reference_unit;

      $(selectors.unitPriceBaseUnit, $unitPriceGroup).text(unitPriceBaseUnit);
      $(selectors.unitPrice, $unitPriceGroup).html(
        theme.Currency.formatMoney(unitPrice, theme.moneyFormat)
      );

      $unitPriceGroup.removeClass(classes.hide);

      return $unitPriceGroup[0];
    },

    _createItemDiscountList: function(item) {
      return $.map(
        item.line_level_discount_allocations,
        function(discount) {
          var $discount = this.$itemDiscountTemplate.clone();
          $discount
            .find(selectors.cartItemDiscountTitle)
            .text(discount.discount_application.title);
          $discount
            .find(selectors.cartItemDiscountAmount)
            .html(
              theme.Currency.formatMoney(discount.amount, theme.moneyFormat)
            );
          return $discount[0];
        }.bind(this)
      );
    },

    _showQuantityErrorMessages: function(itemElement) {
      $(selectors.cartQuantityErrorMessage, itemElement).text(
        theme.strings.quantityMinimumMessage
      );

      $(selectors.cartQuantityErrorMessageWrapper, itemElement).removeClass(
        classes.hide
      );

      $(selectors.inputQty, itemElement)
        .addClass(classes.inputError)
        .focus();
    },

    _hideQuantityErrorMessage: function() {
      var $errorMessages = $(
        selectors.cartQuantityErrorMessageWrapper
      ).addClass(classes.hide);

      $(selectors.cartQuantityErrorMessage, $errorMessages).text('');

      $(selectors.inputQty, this.$container).removeClass(classes.inputError);
    },

    _handleThumbnailClick: function(evt) {
      var url = $(evt.target)
        .closest(selectors.cartItem)
        .data('cart-item-url');

      window.location.href = url;
    },

    _onNoteChange: function(evt) {
      var note = evt.currentTarget.value;
      this._hideCartError();
      this._hideQuantityErrorMessage();

      var params = {
        url: '/cart/update.js',
        data: { note: note },
        dataType: 'json'
      };

      $.post(params).fail(
        function() {
          this._showCartError(evt.currentTarget);
        }.bind(this)
      );
    },

    _showCartError: function(elementToFocus) {
      $(selectors.cartErrorMessage).text(theme.strings.cartError);

      $(selectors.cartErrorMessageWrapper).removeClass(classes.hide);

      elementToFocus.focus();
    },

    _hideCartError: function() {
      $(selectors.cartErrorMessageWrapper).addClass(classes.hide);
      $(selectors.cartErrorMessage).text('');
    },

    _onRemoveItem: function(evt) {
      evt.preventDefault();
      var $remove = $(evt.target);
      var $lineItem = $remove.closest(selectors.cartItem);
      var index = $lineItem.attr(attributes.cartItemIndex);
      this._hideCartError();

      var params = {
        url: '/cart/change.js',
        data: { quantity: 0, line: index },
        dataType: 'json'
      };

      $.post(params)
        .done(
          function(state) {
            if (state.item_count === 0) {
              this._emptyCart();
            } else {
              this._createCart(state);
              this._showRemoveMessage($lineItem.clone());
            }

            this._setCartCountBubble(state.item_count);
          }.bind(this)
        )
        .fail(
          function() {
            this._showCartError(null);
          }.bind(this)
        );
    },

    _showRemoveMessage: function(lineItem) {
      var index = lineItem.data('cart-item-index');
      var removeMessage = this._getRemoveMessage(lineItem);
      var $lineItemAtIndex;

      if (index - 1 === 0) {
        $lineItemAtIndex = $('[data-cart-item-index="1"]', this.$container);
        $(removeMessage).insertBefore($lineItemAtIndex);
      } else {
        $lineItemAtIndex = $(
          '[data-cart-item-index="' + (index - 1) + '"]',
          this.$container
        );
        removeMessage.insertAfter($lineItemAtIndex);
      }
      removeMessage.focus();
    },

    _getRemoveMessage: function(lineItem) {
      var formattedMessage = this._formatRemoveMessage(lineItem);

      var $tableCell = $(selectors.cartTableCell, lineItem).clone();
      $tableCell
        .removeClass()
        .addClass(classes.cartRemovedProduct)
        .attr('colspan', '4')
        .html(formattedMessage);

      lineItem
        .attr('role', 'alert')
        .html($tableCell)
        .attr('tabindex', '-1');

      return lineItem;
    },

    _formatRemoveMessage: function(lineItem) {
      var quantity = lineItem.data('cart-item-quantity');
      var url = lineItem.attr(attributes.cartItemUrl);
      var title = lineItem.attr(attributes.cartItemTitle);

      return theme.strings.removedItemMessage
        .replace('[quantity]', quantity)
        .replace(
          '[link]',
          '<a ' +
            'href="' +
            url +
            '" class="text-link text-link--accent">' +
            title +
            '</a>'
        );
    },

    _setCartCountBubble: function(quantity) {
      this.$cartCountBubble =
        this.$cartCountBubble || $(selectors.cartCountBubble);
      this.$cartCount = this.$cartCount || $(selectors.cartCount);

      if (quantity > 0) {
        this.$cartCountBubble.removeClass(classes.hide);
        this.$cartCount.html(quantity);
      } else {
        this.$cartCountBubble.addClass(classes.hide);
        this.$cartCount.html('');
      }
    },

    _emptyCart: function() {
      this.$emptyPageContent =
        this.$emptyPageContent ||
        $(selectors.emptyPageContent, this.$container);
      this.$cartWrapper =
        this.$cartWrapper || $(selectors.cartWrapper, this.$container);

      this.$emptyPageContent.removeClass(classes.hide);
      this.$cartWrapper.addClass(classes.hide);
    },

    cookiesEnabled: function() {
      var cookieEnabled = navigator.cookieEnabled;

      if (!cookieEnabled) {
        document.cookie = 'testcookie';
        cookieEnabled = document.cookie.indexOf('testcookie') !== -1;
      }
      return cookieEnabled;
    }
  });

  return Cart;
})();

window.theme = window.theme || {};

theme.Filters = (function() {
  var settings = {
    // Breakpoints from src/stylesheets/global/variables.scss.liquid
    mediaQueryMediumUp: 'screen and (min-width: 750px)'
  };

  var selectors = {
    mainContent: '#MainContent',
    filterSelection: '#FilterTags',
    sortSelection: '#SortBy'
  };

  var data = {
    sortBy: 'data-default-sortby'
  };

  function Filters(container) {
    var $container = (this.$container = $(container));

    this.$filterSelect = $(selectors.filterSelection, $container);
    this.$sortSelect = $(selectors.sortSelection, $container);
    this.$selects = $(selectors.filterSelection, $container).add(
      $(selectors.sortSelection, $container)
    );

    this.defaultSort = this._getDefaultSortValue();
    this.$selects.removeClass('hidden');

    this.$filterSelect.on('change', this._onFilterChange.bind(this));
    this.$sortSelect.on('change', this._onSortChange.bind(this));
    this._initBreakpoints();
    this._initParams();
  }

  Filters.prototype = _.assignIn({}, Filters.prototype, {
    _initBreakpoints: function() {
      var self = this;

      enquire.register(settings.mediaQueryMediumUp, {
        match: function() {
          self._resizeSelect(self.$selects);
        }
      });
    },

    _initParams: function() {
      self.queryParams = {};
      if (location.search.length) {
        var aKeyValue;
        var aCouples = location.search.substr(1).split('&');
        for (var i = 0; i < aCouples.length; i++) {
          aKeyValue = aCouples[i].split('=');
          if (aKeyValue.length > 1) {
            self.queryParams[
              decodeURIComponent(aKeyValue[0])
            ] = decodeURIComponent(aKeyValue[1]);
          }
        }
      }
    },

    _onSortChange: function() {
      self.queryParams.sort_by = this._getSortValue();

      if (self.queryParams.page) {
        delete self.queryParams.page;
      }
      window.location.search = decodeURIComponent($.param(self.queryParams));
    },

    _onFilterChange: function() {
      document.location.href = this._getFilterValue();
    },

    _getFilterValue: function() {
      return this.$filterSelect.val();
    },

    _getSortValue: function() {
      return this.$sortSelect.val() || this.defaultSort;
    },

    _getDefaultSortValue: function() {
      return this.$sortSelect.attr(data.sortBy);
    },

    _resizeSelect: function($selection) {
      $selection.each(function() {
        var $this = $(this);
        var arrowWidth = 10;
        // create test element
        var text = $this.find('option:selected').text();
        var $test = $('<span>').html(text);

        // add to body, get width, and get out
        $test.appendTo('body');
        var width = $test.width();
        $test.remove();

        // set select width
        $this.width(width + arrowWidth);
      });
    },

    onUnload: function() {
      this.$filterSelect.off('change', this._onFilterChange);
      this.$sortSelect.off('change', this._onSortChange);
    }
  });

  return Filters;
})();

window.theme = window.theme || {};

theme.HeaderSection = (function() {
  function Header() {
    theme.Header.init();
    theme.MobileNav.init();
    theme.Search.init();
  }

  Header.prototype = _.assignIn({}, Header.prototype, {
    onUnload: function() {
      theme.Header.unload();
    }
  });

  return Header;
})();

theme.Maps = (function() {
  var config = {
    zoom: 14
  };
  var apiStatus = null;
  var mapsToLoad = [];

  var errors = {
    addressNoResults: theme.strings.addressNoResults,
    addressQueryLimit: theme.strings.addressQueryLimit,
    addressError: theme.strings.addressError,
    authError: theme.strings.authError
  };

  var selectors = {
    section: '[data-section-type="map"]',
    map: '[data-map]',
    mapOverlay: '[data-map-overlay]'
  };

  var classes = {
    mapError: 'map-section--load-error',
    errorMsg: 'map-section__error errors text-center'
  };

  // Global function called by Google on auth errors.
  // Show an auto error message on all map instances.
  // eslint-disable-next-line camelcase, no-unused-vars
  window.gm_authFailure = function() {
    if (!Shopify.designMode) {
      return;
    }

    $(selectors.section).addClass(classes.mapError);
    $(selectors.map).remove();
    $(selectors.mapOverlay).after(
      '<div class="' +
        classes.errorMsg +
        '">' +
        theme.strings.authError +
        '</div>'
    );
  };

  function Map(container) {
    this.$container = $(container);
    this.$map = this.$container.find(selectors.map);
    this.key = this.$map.data('api-key');

    if (typeof this.key === 'undefined') {
      return;
    }

    if (apiStatus === 'loaded') {
      this.createMap();
    } else {
      mapsToLoad.push(this);

      if (apiStatus !== 'loading') {
        apiStatus = 'loading';
        if (typeof window.google === 'undefined') {
          $.getScript(
            'https://maps.googleapis.com/maps/api/js?key=' + this.key
          ).then(function() {
            apiStatus = 'loaded';
            initAllMaps();
          });
        }
      }
    }
  }

  function initAllMaps() {
    // API has loaded, load all Map instances in queue
    $.each(mapsToLoad, function(index, instance) {
      instance.createMap();
    });
  }

  function geolocate($map) {
    var deferred = $.Deferred();
    var geocoder = new google.maps.Geocoder();
    var address = $map.data('address-setting');

    geocoder.geocode({ address: address }, function(results, status) {
      if (status !== google.maps.GeocoderStatus.OK) {
        deferred.reject(status);
      }

      deferred.resolve(results);
    });

    return deferred;
  }

  Map.prototype = _.assignIn({}, Map.prototype, {
    createMap: function() {
      var $map = this.$map;

      return geolocate($map)
        .then(
          function(results) {
            var mapOptions = {
              zoom: config.zoom,
              center: results[0].geometry.location,
              draggable: false,
              clickableIcons: false,
              scrollwheel: false,
              disableDoubleClickZoom: true,
              disableDefaultUI: true
            };

            var map = (this.map = new google.maps.Map($map[0], mapOptions));
            var center = (this.center = map.getCenter());

            //eslint-disable-next-line no-unused-vars
            var marker = new google.maps.Marker({
              map: map,
              position: map.getCenter()
            });

            google.maps.event.addDomListener(
              window,
              'resize',
              $.debounce(250, function() {
                google.maps.event.trigger(map, 'resize');
                map.setCenter(center);
                $map.removeAttr('style');
              })
            );
          }.bind(this)
        )
        .fail(function() {
          var errorMessage;

          switch (status) {
            case 'ZERO_RESULTS':
              errorMessage = errors.addressNoResults;
              break;
            case 'OVER_QUERY_LIMIT':
              errorMessage = errors.addressQueryLimit;
              break;
            case 'REQUEST_DENIED':
              errorMessage = errors.authError;
              break;
            default:
              errorMessage = errors.addressError;
              break;
          }

          // Show errors only to merchant in the editor.
          if (Shopify.designMode) {
            $map
              .parent()
              .addClass(classes.mapError)
              .html(
                '<div class="' +
                  classes.errorMsg +
                  '">' +
                  errorMessage +
                  '</div>'
              );
          }
        });
    },

    onUnload: function() {
      if (this.$map.length === 0) {
        return;
      }
      google.maps.event.clearListeners(this.map, 'resize');
    }
  });

  return Map;
})();

/* eslint-disable no-new */
theme.Product = (function() {
  function Product(container) {
    var $container = (this.$container = $(container));
    var sectionId = $container.attr('data-section-id');
    this.ajaxEnabled = $container.data('ajax-enabled');

    this.settings = {
      // Breakpoints from src/stylesheets/global/variables.scss.liquid
      mediaQueryMediumUp: 'screen and (min-width: 750px)',
      mediaQuerySmall: 'screen and (max-width: 749px)',
      bpSmall: false,
      enableHistoryState: $container.data('enable-history-state') || false,
      namespace: '.slideshow-' + sectionId,
      sectionId: sectionId,
      sliderActive: false,
      zoomEnabled: false
    };
    
    this.selectors = {
      addToCart: '[data-add-to-cart]',
      addToCartText: '[data-add-to-cart-text]',
      cartCount: '[data-cart-count]',
      cartCountBubble: '[data-cart-count-bubble]',
      cartPopup: '[data-cart-popup]',
      cartPopupCartQuantity: '[data-cart-popup-cart-quantity]',
      cartPopupClose: '[data-cart-popup-close]',
      cartPopupDismiss: '[data-cart-popup-dismiss]',
      cartPopupImage: '[data-cart-popup-image]',
      cartPopupImageWrapper: '[data-cart-popup-image-wrapper]',
      cartPopupImagePlaceholder: '[data-cart-popup-image-placeholder]',
      cartPopupPlaceholderSize: '[data-placeholder-size]',
      cartPopupProductDetails: '[data-cart-popup-product-details]',
      cartPopupQuantity: '[data-cart-popup-quantity]',
      cartPopupQuantityLabel: '[data-cart-popup-quantity-label]',
      cartPopupTitle: '[data-cart-popup-title]',
      cartPopupWrapper: '[data-cart-popup-wrapper]',
      loader: '[data-loader]',
      loaderStatus: '[data-loader-status]',
      quantity: '[data-quantity-input]',
      SKU: '.variant-sku',
      productStatus: '[data-product-status]',
      originalSelectorId: '#ProductSelect-' + sectionId,
      productForm: '[data-product-form]',
      errorMessage: '[data-error-message]',
      errorMessageWrapper: '[data-error-message-wrapper]',
      productImageWraps: '.product-single__photo',
      productThumbImages: '.product-single__thumbnail--' + sectionId,
      productThumbs: '.product-single__thumbnails-' + sectionId,
      productThumbListItem: '.product-single__thumbnails-item',
      productFeaturedImage: '.product-featured-img',
      productThumbsWrapper: '.thumbnails-wrapper',
      saleLabel: '.product-price__sale-label-' + sectionId,
      singleOptionSelector: '.single-option-selector-' + sectionId,
      shopifyPaymentButton: '.shopify-payment-button',
      priceContainer: '[data-price]',
      regularPrice: '[data-regular-price]',
      salePrice: '[data-sale-price]',
      unitPrice: '[data-unit-price]',
      unitPriceBaseUnit: '[data-unit-price-base-unit]',
      productPolicies: '[data-product-policies]'
    };

    this.classes = {
      cartPopupWrapperHidden: 'cart-popup-wrapper--hidden',
      hidden: 'hide',
      visibilityHidden: 'visibility-hidden',
      inputError: 'input--error',
      productOnSale: 'price--on-sale',
      productUnitAvailable: 'price--unit-available',
      productUnavailable: 'price--unavailable',
      productSoldOut: 'price--sold-out',
      cartImage: 'cart-popup-item__image',
      productFormErrorMessageWrapperHidden:
        'product-form__error-message-wrapper--hidden',
      activeClass: 'active-thumb'
    };

    this.$quantityInput = $(this.selectors.quantity, $container);
    this.$errorMessageWrapper = $(
      this.selectors.errorMessageWrapper,
      $container
    );
    this.$addToCart = $(this.selectors.addToCart, $container);
    this.$addToCartText = $(this.selectors.addToCartText, this.$addToCart);
    this.$shopifyPaymentButton = $(
      this.selectors.shopifyPaymentButton,
      $container
    );
    
    this.$productPolicies = $(this.selectors.productPolicies, $container);

    this.$loader = $(this.selectors.loader, this.$addToCart);
    this.$loaderStatus = $(this.selectors.loaderStatus, $container);
    // Stop parsing if we don't have the product json script tag when loading
    // section in the Theme Editor
    
    if (!$('#ProductJson-' + sectionId).html()) {
      return;
    }

    this.productSingleObject = JSON.parse(
      document.getElementById('ProductJson-' + sectionId).innerHTML
    );

    this.settings.zoomEnabled = $(this.selectors.productImageWraps).hasClass(
      'js-zoom-enabled'
    );
    
    this._initBreakpoints();
    this._stringOverrides();
    this._initVariants();
    this._initImageSwitch();
    this._initAddToCart();
    this._setActiveThumbnail();
  }

  Product.prototype = _.assignIn({}, Product.prototype, {
    _stringOverrides: function() {
      theme.productStrings = theme.productStrings || {};
      $.extend(theme.strings, theme.productStrings);
    },

    _initBreakpoints: function() {
      var self = this;

      enquire.register(this.settings.mediaQuerySmall, {
        match: function() {
          // initialize thumbnail slider on mobile if more than three thumbnails
          if ($(self.selectors.productThumbImages).length > 3) {
            self._initThumbnailSlider();
          }

          // destroy image zooming if enabled
          if (self.settings.zoomEnabled) {
            $(self.selectors.productImageWraps).each(function() {
              _destroyZoom(this);
            });
          }

          self.settings.bpSmall = true;
        },
        unmatch: function() {
          if (self.settings.sliderActive) {
            self._destroyThumbnailSlider();
          }

          self.settings.bpSmall = false;
        }
      });

      enquire.register(this.settings.mediaQueryMediumUp, {
        match: function() {
          if (self.settings.zoomEnabled) {
            $(self.selectors.productImageWraps).each(function() {
              _enableZoom(this);
            });
          }
        }
      });
    },

    _initVariants: function() {
      var options = {
        $container: this.$container,
        enableHistoryState:
          this.$container.data('enable-history-state') || false,
        singleOptionSelector: this.selectors.singleOptionSelector,
        originalSelectorId: this.selectors.originalSelectorId,
        product: this.productSingleObject
      };

      this.variants = new slate.Variants(options);

      this.$container.on(
        'variantChange' + this.settings.namespace,
        this._updateAvailability.bind(this)
      );
      this.$container.on(
        'variantImageChange' + this.settings.namespace,
        this._updateImages.bind(this)
      );
      this.$container.on(
        'variantPriceChange' + this.settings.namespace,
        this._updatePrice.bind(this)
      );
      this.$container.on(
        'variantSKUChange' + this.settings.namespace,
        this._updateSKU.bind(this)
      );
    },

    _initImageSwitch: function() {
      if (!$(this.selectors.productThumbImages).length) {
        return;
      }

      var self = this;

      $(this.selectors.productThumbImages)
        .on('click', function(evt) {
          evt.preventDefault();
          var $el = $(this);

          var imageId = $el.data('thumbnail-id');

          self._switchImage(imageId);
          self._setActiveThumbnail(imageId);
        })
        .on('keyup', self._handleImageFocus.bind(self));
    },

    _initAddToCart: function() {
      $(this.selectors.productForm, this.$container).on(
        'submit',
        function(evt) {
          if (this.$addToCart.is('[aria-disabled]')) {
            evt.preventDefault();
            return;
          }

          if (!this.ajaxEnabled) return;

          evt.preventDefault();

          this.$previouslyFocusedElement = $(':focus');

          var isInvalidQuantity = this.$quantityInput.val() <= 0;

          if (isInvalidQuantity) {
            this._showErrorMessage(theme.strings.quantityMinimumMessage);
            return;
          }

          if (!isInvalidQuantity && this.ajaxEnabled) {
            // disable the addToCart and dynamic checkout button while
            // request/cart popup is loading and handle loading state
            this._handleButtonLoadingState(true);
            var $data = $(this.selectors.productForm, this.$container);
            this._addItemToCart($data);
            return;
          }
        }.bind(this)
      );
    },

    _addItemToCart: function(data) {
      var params = {
        url: '/cart/add.js',
        data: $(data).serialize(),
        dataType: 'json'
      };

      $.post(params)
        .done(
          function(item) {
            this._hideErrorMessage();
            if($('.template_alt_pro').length){
              cart_drawer();
              this._handleButtonLoadingState(false);
              $('.cart_drawer').addClass('drawer_is_open');
              $('html body').addClass("stop_page_scroll");
            }else{
              this._setupCartPopup(item);
            }
          }.bind(this)
        )
        .fail(
          function(response) {
            this.$previouslyFocusedElement.focus();
            var errorMessage = response.responseJSON
              ? response.responseJSON.description
              : theme.strings.cartError;
            this._showErrorMessage(errorMessage);
            this._handleButtonLoadingState(false);
          }.bind(this)
        );
    },

    _handleButtonLoadingState: function(isLoading) {
      if (isLoading) {
        this.$addToCart.attr('aria-disabled', true);
        this.$addToCartText.addClass(this.classes.hidden);
        this.$loader.removeClass(this.classes.hidden);
        this.$shopifyPaymentButton.attr('disabled', true);
        this.$loaderStatus.attr('aria-hidden', false);
      } else {
        this.$addToCart.removeAttr('aria-disabled');
        this.$addToCartText.removeClass(this.classes.hidden);
        this.$loader.addClass(this.classes.hidden);
        this.$shopifyPaymentButton.removeAttr('disabled');
        this.$loaderStatus.attr('aria-hidden', true);
      }
    },

    _showErrorMessage: function(errorMessage) {
      $(this.selectors.errorMessage, this.$container).html(errorMessage);

      if (this.$quantityInput.length !== 0) {
        this.$quantityInput.addClass(this.classes.inputError);
      }

      this.$errorMessageWrapper
        .removeClass(this.classes.productFormErrorMessageWrapperHidden)
        .attr('aria-hidden', true)
        .removeAttr('aria-hidden');
    },

    _hideErrorMessage: function() {
      this.$errorMessageWrapper.addClass(
        this.classes.productFormErrorMessageWrapperHidden
      );

      if (this.$quantityInput.length !== 0) {
        this.$quantityInput.removeClass(this.classes.inputError);
      }
    },

    _setupCartPopup: function(item) {
      this.$cartPopup = this.$cartPopup || $(this.selectors.cartPopup);
      this.$cartPopupWrapper =
        this.$cartPopupWrapper || $(this.selectors.cartPopupWrapper);
      this.$cartPopupTitle =
        this.$cartPopupTitle || $(this.selectors.cartPopupTitle);
      this.$cartPopupQuantity =
        this.$cartPopupQuantity || $(this.selectors.cartPopupQuantity);
      this.$cartPopupQuantityLabel =
        this.$cartPopupQuantityLabel ||
        $(this.selectors.cartPopupQuantityLabel);
      this.$cartPopupClose =
        this.$cartPopupClose || $(this.selectors.cartPopupClose);
      this.$cartPopupDismiss =
        this.$cartPopupDismiss || $(this.selectors.cartPopupDismiss);
      this.$cartPopupImagePlaceholder =
        this.$cartPopupImagePlaceholder ||
        $(this.selectors.cartPopupImagePlaceholder);

      this._setupCartPopupEventListeners();

      this._updateCartPopupContent(item);
    },

    _updateCartPopupContent: function(item) {
      var quantity = this.$quantityInput.length ? this.$quantityInput.val() : 1;

      this.$cartPopupTitle.text(item.product_title);
      this.$cartPopupQuantity.text(quantity);
      this.$cartPopupQuantityLabel.text(
        theme.strings.quantityLabel.replace('[count]', quantity)
      );

      this._setCartPopupPlaceholder(
        item.featured_image.url,
        item.featured_image.aspect_ratio
      );
      this._setCartPopupImage(item.featured_image.url, item.featured_image.alt);
      this._setCartPopupProductDetails(
        item.product_has_only_default_variant,
        item.options_with_values,
        item.properties
      );

      $.getJSON('/cart.js').then(
        function(cart) {
          this._setCartQuantity(cart.item_count);
          this._setCartCountBubble(cart.item_count);
          this._showCartPopup();
        }.bind(this)
      );
    },

    _setupCartPopupEventListeners: function() {
      this.$cartPopupWrapper.on(
        'keyup',
        function(event) {
          if (event.keyCode === slate.utils.keyboardKeys.ESCAPE) {
            this._hideCartPopup(event);
          }
        }.bind(this)
      );

      this.$cartPopupClose.on('click', this._hideCartPopup.bind(this));
      this.$cartPopupDismiss.on('click', this._hideCartPopup.bind(this));
      $('body').on('click', this._onBodyClick.bind(this));
    },

    _setCartPopupPlaceholder: function(imageUrl, imageAspectRatio) {
      this.$cartPopupImageWrapper =
        this.$cartPopupImageWrapper || $(this.selectors.cartPopupImageWrapper);

      if (imageUrl === null) {
        this.$cartPopupImageWrapper.addClass(this.classes.hidden);
        return;
      }

      var $placeholder = $(this.selectors.cartPopupPlaceholderSize);
      var maxWidth = 95 * imageAspectRatio;
      var heightRatio = 100 / imageAspectRatio;

      this.$cartPopupImagePlaceholder.css('max-width', maxWidth);

      $placeholder.css('padding-top', heightRatio + '%');
    },

    _setCartPopupImage: function(imageUrl, imageAlt) {
      if (imageUrl === null) return;

      this.$cartPopupImageWrapper.removeClass(this.classes.hidden);
      var sizedImageUrl = theme.Images.getSizedImageUrl(imageUrl, '200x');
      var image = document.createElement('img');
      image.src = sizedImageUrl;
      image.alt = imageAlt;
      image.classList.add(this.classes.cartImage);
      image.dataset.cartPopupImage = '';

      image.onload = function() {
        this.$cartPopupImagePlaceholder.addClass(this.classes.hidden);
        this.$cartPopupImageWrapper.append(image);
      }.bind(this);
    },

    _setCartPopupProductDetails: function(
      product_has_only_default_variant,
      options,
      properties
    ) {
      this.$cartPopupProductDetails =
        this.$cartPopupProductDetails ||
        $(this.selectors.cartPopupProductDetails);
      var variantPropertiesHTML = '';

      if (!product_has_only_default_variant) {
        variantPropertiesHTML =
          variantPropertiesHTML + this._getVariantOptionList(options);
      }

      if (properties !== null && Object.keys(properties).length !== 0) {
        variantPropertiesHTML =
          variantPropertiesHTML + this._getPropertyList(properties);
      }

      if (variantPropertiesHTML.length === 0) {
        this.$cartPopupProductDetails.html('');
        this.$cartPopupProductDetails.attr('hidden', '');
      } else {
        this.$cartPopupProductDetails.html(variantPropertiesHTML);
        this.$cartPopupProductDetails.removeAttr('hidden');
      }
    },

    _getVariantOptionList: function(variantOptions) {
      var variantOptionListHTML = '';

      variantOptions.forEach(function(variantOption) {
        variantOptionListHTML =
          variantOptionListHTML +
          '<li class="product-details__item product-details__item--variant-option">' +
          variantOption.name +
          ': ' +
          variantOption.value +
          '</li>';
      });

      return variantOptionListHTML;
    },

    _getPropertyList: function(properties) {
      var propertyListHTML = '';
      var propertiesArray = Object.entries(properties);

      propertiesArray.forEach(function(property) {
        // Line item properties prefixed with an underscore are not to be displayed
        if (property[0].charAt(0) === '_') return;

        // if the property value has a length of 0 (empty), don't display it
        if (property[1].length === 0) return;

        propertyListHTML =
          propertyListHTML +
          '<li class="product-details__item product-details__item--property">' +
          '<span class="product-details__property-label">' +
          property[0] +
          ': </span>' +
          property[1];
        ': ' + '</li>';
      });

      return propertyListHTML;
    },

    _setCartQuantity: function(quantity) {
      this.$cartPopupCartQuantity =
        this.$cartPopupCartQuantity || $(this.selectors.cartPopupCartQuantity);
      var ariaLabel;

      if (quantity === 1) {
        ariaLabel = theme.strings.oneCartCount;
      } else if (quantity > 1) {
        ariaLabel = theme.strings.otherCartCount.replace('[count]', quantity);
      }

      this.$cartPopupCartQuantity.text(quantity).attr('aria-label', ariaLabel);
    },

    _setCartCountBubble: function(quantity) {
      this.$cartCountBubble =
        this.$cartCountBubble || $(this.selectors.cartCountBubble);
      this.$cartCount = this.$cartCount || $(this.selectors.cartCount);

      this.$cartCountBubble.removeClass(this.classes.hidden);
      this.$cartCount.text(quantity);
    },

    _showCartPopup: function() {
      this.$cartPopupWrapper
        .prepareTransition()
        .removeClass(this.classes.cartPopupWrapperHidden);
      this._handleButtonLoadingState(false);

      slate.a11y.trapFocus({
        $container: this.$cartPopupWrapper,
        $elementToFocus: this.$cartPopup,
        namespace: 'cartPopupFocus'
      });
    },

    _hideCartPopup: function(event) {
      var setFocus = event.detail === 0 ? true : false;
      this.$cartPopupWrapper
        .prepareTransition()
        .addClass(this.classes.cartPopupWrapperHidden);

      $(this.selectors.cartPopupImage).remove();
      this.$cartPopupImagePlaceholder.removeClass(this.classes.hidden);

      slate.a11y.removeTrapFocus({
        $container: this.$cartPopupWrapper,
        namespace: 'cartPopupFocus'
      });

      if (setFocus) this.$previouslyFocusedElement[0].focus();

      this.$cartPopupWrapper.off('keyup');
      this.$cartPopupClose.off('click');
      this.$cartPopupDismiss.off('click');
      $('body').off('click');
    },

    _onBodyClick: function(event) {
      var $target = $(event.target);

      if (
        $target[0] !== this.$cartPopupWrapper[0] &&
        !$target.parents(this.selectors.cartPopup).length
      ) {
        this._hideCartPopup(event);
      }
    },

    _setActiveThumbnail: function(imageId) {
      // If there is no element passed, find it by the current product image
      if (typeof imageId === 'undefined') {
        imageId = $(
          this.selectors.productImageWraps + ':not(.hide)',
          this.$container
        ).data('image-id');
      }

      var $thumbnailWrappers = $(
        this.selectors.productThumbListItem + ':not(.slick-cloned)',
        this.$container
      );

      var $activeThumbnail = $thumbnailWrappers.find(
        this.selectors.productThumbImages +
          "[data-thumbnail-id='" +
          imageId +
          "']"
      );

      $(this.selectors.productThumbImages)
        .removeClass(this.classes.activeClass)
        .removeAttr('aria-current');

      $activeThumbnail.addClass(this.classes.activeClass);
      $activeThumbnail.attr('aria-current', true);

      if (!$thumbnailWrappers.hasClass('slick-slide')) {
        return;
      }

      var slideIndex = $activeThumbnail.parent().data('slick-index');

      $(this.selectors.productThumbs).slick('slickGoTo', slideIndex, true);
    },

    _switchImage: function(imageId) {
      var $newImage = $(
        this.selectors.productImageWraps + "[data-image-id='" + imageId + "']",
        this.$container
      );
      var $otherImages = $(
        this.selectors.productImageWraps +
          ":not([data-image-id='" +
          imageId +
          "'])",
        this.$container
      );

      $newImage.removeClass(this.classes.hidden);
      $otherImages.addClass(this.classes.hidden);
    },

    _handleImageFocus: function(evt) {
      if (evt.keyCode !== slate.utils.keyboardKeys.ENTER) return;

      $(this.selectors.productFeaturedImage + ':visible').focus();
    },

    _initThumbnailSlider: function() {
      var options = {
        slidesToShow: 4,
        slidesToScroll: 3,
        infinite: false,
        prevArrow: '.thumbnails-slider__prev--' + this.settings.sectionId,
        nextArrow: '.thumbnails-slider__next--' + this.settings.sectionId,
        responsive: [
          {
            breakpoint: 321,
            settings: {
              slidesToShow: 3
            }
          }
        ]
      };

      $(this.selectors.productThumbs).slick(options);

      // Accessibility concerns not yet fixed in Slick Slider
      $(this.selectors.productThumbsWrapper, this.$container)
        .find('.slick-list')
        .removeAttr('aria-live');
      $(this.selectors.productThumbsWrapper, this.$container)
        .find('.slick-disabled')
        .removeAttr('aria-disabled');

      this.settings.sliderActive = true;
    },

    _destroyThumbnailSlider: function() {
      $(this.selectors.productThumbs).slick('unslick');
      this.settings.sliderActive = false;

      // Accessibility concerns not yet fixed in Slick Slider
      $(this.selectors.productThumbsWrapper, this.$container)
        .find('[tabindex="-1"]')
        .removeAttr('tabindex');
    },

    _liveRegionText: function(variant) {
      // Dummy content for live region
      var liveRegionText =
        '[Availability] [Regular] [$$] [Sale] [$]. [UnitPrice] [$$$]';

      if (!variant) {
        liveRegionText = theme.strings.unavailable;
        return liveRegionText;
      }

      // Update availability
      var availability = variant.available ? '' : theme.strings.soldOut + ',';
      liveRegionText = liveRegionText.replace('[Availability]', availability);

      // Update pricing information
      var regularLabel = '';
      var regularPrice = theme.Currency.formatMoney(
        variant.price,
        theme.moneyFormat
      );
      var saleLabel = '';
      var salePrice = '';
      var unitLabel = '';
      var unitPrice = '';

      if (variant.compare_at_price > variant.price) {
        regularLabel = theme.strings.regularPrice;
        regularPrice =
          theme.Currency.formatMoney(
            variant.compare_at_price,
            theme.moneyFormat
          ) + ',';
        saleLabel = theme.strings.sale;
        salePrice = theme.Currency.formatMoney(
          variant.price,
          theme.moneyFormat
        );
      }

      if (variant.unit_price) {
        unitLabel = theme.strings.unitPrice;
        unitPrice =
          theme.Currency.formatMoney(variant.unit_price, theme.moneyFormat) +
          ' ' +
          theme.strings.unitPriceSeparator +
          ' ' +
          this._getBaseUnit(variant);
      }

      liveRegionText = liveRegionText
        .replace('[Regular]', regularLabel)
        .replace('[$$]', regularPrice)
        .replace('[Sale]', saleLabel)
        .replace('[$]', salePrice)
        .replace('[UnitPrice]', unitLabel)
        .replace('[$$$]', unitPrice)
        .trim();

      return liveRegionText;
    },

    _updateLiveRegion: function(evt) {
      var variant = evt.variant;
      var liveRegion = this.container.querySelector(
        this.selectors.productStatus
      );
      liveRegion.innerHTML = this._liveRegionText(variant);
      liveRegion.setAttribute('aria-hidden', false);

      // hide content from accessibility tree after announcement
      setTimeout(function() {
        liveRegion.setAttribute('aria-hidden', true);
      }, 1000);
    },

    _updateAddToCart: function(evt) {
      var variant = evt.variant;

      if (variant) {
        if (variant.available) {
          this.$addToCart
            .removeAttr('aria-disabled')
            .attr('aria-label', theme.strings.addToCart);
          $(this.selectors.addToCartText, this.$container).text(
            theme.strings.addToCart
          );
          this.$shopifyPaymentButton.show();
        } else {
          // The variant doesn't exist, disable submit button and change the text.
          // This may be an error or notice that a specific variant is not available.
          this.$addToCart
            .attr('aria-disabled', true)
            .attr('aria-label', theme.strings.soldOut);
          $(this.selectors.addToCartText, this.$container).text(
            theme.strings.soldOut
          );
          this.$shopifyPaymentButton.hide();
        }
      } else {
        this.$addToCart
          .attr('aria-disabled', true)
          .attr('aria-label', theme.strings.unavailable);
        $(this.selectors.addToCartText, this.$container).text(
          theme.strings.unavailable
        );
        this.$shopifyPaymentButton.hide();
      }
    },

    _updateAvailability: function(evt) {
      // remove error message if one is showing
      this._hideErrorMessage();

      // update form submit
      this._updateAddToCart(evt);
      // update live region
      this._updateLiveRegion(evt);

      this._updatePrice(evt);
    },

    _updateImages: function(evt) {
      var variant = evt.variant;
      var imageId = variant.featured_image.id;

      this._switchImage(imageId);
      this._setActiveThumbnail(imageId);
    },

    _updatePrice: function(evt) {
      var variant = evt.variant;

      var $priceContainer = $(this.selectors.priceContainer, this.$container);
      var $regularPrice = $(this.selectors.regularPrice, $priceContainer);
      var $salePrice = $(this.selectors.salePrice, $priceContainer);
      var $unitPrice = $(this.selectors.unitPrice, $priceContainer);
      var $unitPriceBaseUnit = $(
        this.selectors.unitPriceBaseUnit,
        $priceContainer
      );

      // Reset product price state
      $priceContainer
        .removeClass(this.classes.productUnavailable)
        .removeClass(this.classes.productOnSale)
        .removeClass(this.classes.productUnitAvailable)
        .removeClass(this.classes.productSoldOut)
        .removeAttr('aria-hidden');

      this.$productPolicies.removeClass(this.classes.visibilityHidden);

      // Unavailable
      if (!variant) {
        $priceContainer
          .addClass(this.classes.productUnavailable)
          .attr('aria-hidden', true);

        this.$productPolicies.addClass(this.classes.visibilityHidden);
        return;
      }

      // Sold out
      if (!variant.available) {
        $priceContainer.addClass(this.classes.productSoldOut);
        return;
      }

      // On sale
      if (variant.compare_at_price > variant.price) {
        if($('.template_alt_pro').length){
          $regularPrice.html(
            theme.Currency.formatMoney(
              variant.compare_at_price,
              theme.moneyFormat
            ).replace('Rs. ', '₹')
          );
          $salePrice.html(
             theme.Currency.formatMoney(variant.price, theme.moneyFormat).replace('Rs. ', '₹')
          );
        }else{
          $regularPrice.html(
            theme.Currency.formatMoney(
              variant.compare_at_price,
              theme.moneyFormat
            )
          );
          $salePrice.html(
            theme.Currency.formatMoney(variant.price, theme.moneyFormat)
          );
        }
        
        $priceContainer.addClass(this.classes.productOnSale);
      } else {
        // Regular price
        if($('.template_alt_pro').length){
          $regularPrice.html(
            theme.Currency.formatMoney(variant.price, theme.moneyFormat).replace('Rs. ', '₹')
          );
        }else{
          $regularPrice.html(
            theme.Currency.formatMoney(variant.price, theme.moneyFormat)
          )
        }
      }

      // Unit price
      if (variant.unit_price) {
        if($('.template_alt_pro').length){
          $unitPrice.html(
            theme.Currency.formatMoney(variant.unit_price, theme.moneyFormat).replace('Rs. ', '₹')
          )
        }else{
          $unitPrice.html(
            theme.Currency.formatMoney(variant.unit_price, theme.moneyFormat)
          )
        }
        $unitPriceBaseUnit.html(this._getBaseUnit(variant));
        $priceContainer.addClass(this.classes.productUnitAvailable);
      }
    },

    _getBaseUnit: function(variant) {
      return variant.unit_price_measurement.reference_value === 1
        ? variant.unit_price_measurement.reference_unit
        : variant.unit_price_measurement.reference_value +
            variant.unit_price_measurement.reference_unit;
    },

    _updateSKU: function(evt) {
      var variant = evt.variant;

      // Update the sku
      $(this.selectors.SKU).html(variant.sku);
    },

    onUnload: function() {
      this.$container.off(this.settings.namespace);
    }
  });

  function _enableZoom(el) {
    var zoomUrl = $(el).data('zoom');
    $(el).zoom({
      url: zoomUrl
    });
  }

  function _destroyZoom(el) {
    $(el).trigger('zoom.destroy');
  }

  return Product;
})();

theme.ProductRecommendations = (function() {
  function ProductRecommendations(container) {
    this.$container = $(container);

    var baseUrl = this.$container.data('baseUrl');
    var productId = this.$container.data('productId');
    var recommendationsSectionUrl =
      baseUrl +
      '?section_id=product-recommendations&product_id=' +
      productId +
      '&limit=4';

    $.get(recommendationsSectionUrl).then(
      function(section) {
        var recommendationsMarkup = $(section).html();
        if (recommendationsMarkup.trim() !== '') {
          this.$container.html(recommendationsMarkup);
        }
      }.bind(this)
    );
  }

  return ProductRecommendations;
})();

theme.Quotes = (function() {
  var config = {
    mediaQuerySmall: 'screen and (max-width: 749px)',
    mediaQueryMediumUp: 'screen and (min-width: 750px)',
    slideCount: 0
  };
  var defaults = {
    accessibility: true,
    arrows: false,
    dots: false,
    autoplay: true,
    autoplaySpeed: 3000,
    touchThreshold: 20,
    slidesToShow: 1,
    slidesToScroll: 1
  };

  function Quotes(container) {
    var $container = (this.$container = $(container));
    var sectionId = $container.attr('data-section-id');
    var wrapper = (this.wrapper = '.quotes-wrapper');
    var slider = (this.slider = '#Quotes-' + sectionId);
    var $slider = $(slider, wrapper);

    var sliderActive = false;
    var mobileOptions = $.extend({}, defaults, {
      slidesToShow: 1,
      slidesToScroll: 1,
      adaptiveHeight: true
    });

    config.slideCount = $slider.data('count');

    // Override slidesToShow/Scroll if there are not enough blocks
    if (config.slideCount < defaults.slidesToShow) {
      defaults.slidesToShow = config.slideCount;
      defaults.slidesToScroll = config.slideCount;
    }

    $slider.on('init', this.a11y.bind(this));

    enquire.register(config.mediaQuerySmall, {
      match: function() {
        initSlider($slider, mobileOptions);
      }
    });

    enquire.register(config.mediaQueryMediumUp, {
      match: function() {
        initSlider($slider, defaults);
      }
    });

    function initSlider(sliderObj, args) {
      if (sliderActive) {
        sliderObj.slick('unslick');
        sliderActive = false;
      }

      sliderObj.slick(args);
      sliderActive = true;
    }
  }

  Quotes.prototype = _.assignIn({}, Quotes.prototype, {
    onUnload: function() {
      enquire.unregister(config.mediaQuerySmall);
      enquire.unregister(config.mediaQueryMediumUp);

      $(this.slider, this.wrapper).slick('unslick');
    },

    onBlockSelect: function(evt) {
      // Ignore the cloned version
      var $slide = $(
        '.quotes-slide--' + evt.detail.blockId + ':not(.slick-cloned)'
      );
      var slideIndex = $slide.data('slick-index');

      // Go to selected slide, pause autoplay
      $(this.slider, this.wrapper).slick('slickGoTo', slideIndex);
    },

    a11y: function(event, obj) {
      var $list = obj.$list;
      var $wrapper = $(this.wrapper, this.$container);

      // Remove default Slick aria-live attr until slider is focused
      $list.removeAttr('aria-live');

      // When an element in the slider is focused set aria-live
      $wrapper.on('focusin', function(evt) {
        if ($wrapper.has(evt.target).length) {
          $list.attr('aria-live', 'polite');
        }
      });

      // Remove aria-live
      $wrapper.on('focusout', function(evt) {
        if ($wrapper.has(evt.target).length) {
          $list.removeAttr('aria-live');
        }
      });
    }
  });

  return Quotes;
})();

theme.slideshows = {};

theme.SlideshowSection = (function() {
  function SlideshowSection(container) {
    var $container = (this.$container = $(container));
    var sectionId = $container.attr('data-section-id');
    var slideshow = (this.slideshow = '#Slideshow-' + sectionId);

    theme.slideshows[slideshow] = new theme.Slideshow(slideshow, sectionId);
  }

  return SlideshowSection;
})();

theme.SlideshowSection.prototype = _.assignIn(
  {},
  theme.SlideshowSection.prototype,
  {
    onUnload: function() {
      delete theme.slideshows[this.slideshow];
    },

    onBlockSelect: function(evt) {
      var $slideshow = $(this.slideshow);
      var adaptHeight = $slideshow.data('adapt-height');

      if (adaptHeight) {
        theme.slideshows[this.slideshow].setSlideshowHeight();
      }

      // Ignore the cloned version
      var $slide = $(
        '.slideshow__slide--' + evt.detail.blockId + ':not(.slick-cloned)'
      );
      var slideIndex = $slide.data('slick-index');

      // Go to selected slide, pause auto-rotate
      $slideshow.slick('slickGoTo', slideIndex).slick('slickPause');
    },

    onBlockDeselect: function() {
      // Resume auto-rotate
      $(this.slideshow).slick('slickPlay');
    }
  }
);

theme.slideshows = {};

theme.VideoSection = (function() {
  function VideoSection(container) {
    var $container = (this.$container = $(container));

    $('.video', $container).each(function() {
      var $el = $(this);
      theme.Video.init($el);
      theme.Video.editorLoadVideo($el.attr('id'));
    });
  }

  return VideoSection;
})();

theme.VideoSection.prototype = _.assignIn({}, theme.VideoSection.prototype, {
  onUnload: function() {
    theme.Video.removeEvents();
  }
});

theme.heros = {};

theme.HeroSection = (function() {
  function HeroSection(container) {
    var $container = (this.$container = $(container));
    var sectionId = $container.attr('data-section-id');
    var hero = '#Hero-' + sectionId;
    theme.heros[hero] = new theme.Hero(hero, sectionId);
  }

  return HeroSection;
})();


$(document).ready(function() {
  var sections = new theme.Sections();

  sections.register('cart-template', theme.Cart);
  sections.register('product', theme.Product);
  sections.register('collection-template', theme.Filters);
  sections.register('product-template', theme.Product);
  sections.register('header-section', theme.HeaderSection);
  sections.register('map', theme.Maps);
  sections.register('slideshow-section', theme.SlideshowSection);
  sections.register('video-section', theme.VideoSection);
  sections.register('quotes', theme.Quotes);
  sections.register('hero-section', theme.HeroSection);
  sections.register('product-recommendations', theme.ProductRecommendations);
});

theme.init = function() {
  theme.customerTemplates.init();

  // Theme-specific selectors to make tables scrollable
  var tableSelectors = '.rte table,' + '.custom__item-inner--html table';

  slate.rte.wrapTable({
    $tables: $(tableSelectors),
    tableWrapperClass: 'scrollable-wrapper'
  });

  // Theme-specific selectors to make iframes responsive
  var iframeSelectors =
    '.rte iframe[src*="youtube.com/embed"],' +
    '.rte iframe[src*="player.vimeo"],' +
    '.custom__item-inner--html iframe[src*="youtube.com/embed"],' +
    '.custom__item-inner--html iframe[src*="player.vimeo"]';

  slate.rte.wrapIframe({
    $iframes: $(iframeSelectors),
    iframeWrapperClass: 'video-wrapper'
  });

  // Common a11y fixes
  slate.a11y.pageLinkFocus($(window.location.hash));

  $('.in-page-link').on('click', function(evt) {
    slate.a11y.pageLinkFocus($(evt.currentTarget.hash));
  });

  $('a[href="#"]').on('click', function(evt) {
    evt.preventDefault();
  });

  slate.a11y.accessibleLinks({
    messages: {
      newWindow: theme.strings.newWindow,
      external: theme.strings.external,
      newWindowExternal: theme.strings.newWindowExternal
    },
    $links: $('a[href]:not([aria-describedby], .product-single__thumbnail)')
  });

  theme.FormStatus.init();

  var selectors = {
    image: '[data-image]',
    imagePlaceholder: '[data-image-placeholder]',
    imageWithPlaceholderWrapper: '[data-image-with-placeholder-wrapper]',
    lazyloaded: '.lazyloaded'
  };

  var classes = {
    hidden: 'hide'
  };

  $(document).on('lazyloaded', function(e) {
    var $target = $(e.target);

    if ($target.data('bgset')) {
      var $image = $target.find(selectors.lazyloaded);
      if ($image) {
        if ($target.data('bg')) {
          $image.attr('src', $target.data('bg'));
        }
        if ($target.data('alt')) {
          $image.attr('alt', $target.data('alt'));
        }
      }
    }

    if (!$target.is(selectors.image)) {
      return;
    }

    $target
      .closest(selectors.imageWithPlaceholderWrapper)
      .find(selectors.imagePlaceholder)
      .addClass(classes.hidden);
  });

  // When the theme loads, lazysizes might load images before the "lazyloaded"
  // event listener has been attached. When this happens, the following function
  // hides the loading placeholders.
  function onLoadHideLazysizesAnimation() {
    $(selectors.image + '.lazyloaded')
      .closest(selectors.imageWithPlaceholderWrapper)
      .find(selectors.imagePlaceholder)
      .addClass(classes.hidden);
  }

  onLoadHideLazysizesAnimation();
};

$(theme.init);

$('.tweets-slider').slick({
  accessibility: true,
  arrows: false,
  autoplay: true,
  autoplaySpeed: 3000,
  touchThreshold: 20,
  slidesToShow: 1,
  slidesToScroll: 1
});

/* Lazy load featured row */
if($('.animate:not(.animated)').length) {
  $(window).on('scroll', function(){
    if(!$('.animate:not(.animated)').length) return;
    var divider = ($(window).width() > 750)?2:1;
    var totalOffset = Math.round($(this).scrollTop()+($(window).height()/divider));
    if(totalOffset > Math.round($('.animate:not(.animated):eq(0)').offset().top)) {
      $('.animate:not(.animated):eq(0)').addClass('animated');
    }
  });
}

$('.nav-has-submenu').on('click', function(e){
  if($(window).width() > 749) {
    e.preventDefault();
    $(this).next('.nav-i-submenu').toggleClass('opened');
  } else {
    $(this).next('.nav-i-submenu').slideToggle();
  }
});

$('body').on('click', function(e){
  if(!$(e.target).is('.nav-has-submenu')) {
    $('.nav-i-submenu').removeClass('opened');
  }
});

$('.steps-options-item').on('click', function(){
  $(this).addClass('selected').siblings('.steps-options-item').removeClass('selected');
});

$('.steps-o-checked').on('click', function(){
  $(this).toggleClass('selected');
  if($('.steps-o-checked.selected').length >= 5) {
    $('.steps-o-checked:not(.selected)').addClass('disabled');
  }
  else {
    $('.steps-o-checked').removeClass('disabled');
  }
});

$('.product-sct-item').on('click',function(){
  $(this).addClass('selected').siblings('.product-sct-item').removeClass('selected');
});

$('#isGift').on('change', function(){
  if(this.checked) {
    $('.gift-info-form').show();
  }
  else {
    $('.gift-info-form').hide();
  }
});

$('.txtprint').on('keyup',function(){
  $('.swatch-image-txt').text($(this).val());
});

$('.steps-opt-item3').on('click', function(){
  $(this).addClass('selected').siblings('.steps-opt-item3').removeClass('selected');
  $('.forml-imgs [data="'+$(this).attr('formula')+'"]').addClass('showed').siblings().removeClass('showed');
  //$('[js_group="shampoo-color"] .swatch-i-item[js_val="'+$(this).attr('color_shampoo')+'"]').trigger('click');
 // $('[js_group="conditioner-color"] .swatch-i-item[js_val="'+$(this).attr('color_condn')+'"]').trigger('click');
});

$('.steps-o-checked2').on('click', function(){
  $(this).addClass('selected').siblings('.steps-o-checked2').removeClass('selected');
});

$('.swatch-i-list .swatch-i-item').on('click', function(){
  $(this).addClass('selected').siblings('.swatch-i-item').removeClass('selected');
  $(this).parents('.color-i-swatches').find('.swatch-image-box img[data="'+$(this).attr('js_val')+'"]').addClass('showed').siblings('img').removeClass('showed');
});

$(document).ready(function(){
  if($('.order-i-steps').length) {
    var cookie_data,grp_lbl,i;
    $('.order-i-steps').each(function(indx){
      i = indx+1;
      if(getCookie('rh_orderStep-'+i) != '') {
        cookie_data = JSON.parse(getCookie('rh_orderStep-'+i));
        $.each(cookie_data.items,function(index, order){
          if(typeof order.label !== 'undefined') {
            grp_lbl = order.label.toLowerCase().replace(/[^a-zA-Z0-9]/g,'-').replace(/[-]+/g,'-');
            grp_lbl = (grp_lbl[grp_lbl.length-1] == '-')?grp_lbl.substring(0,grp_lbl.length-1):grp_lbl;
            grp_lbl = (grp_lbl[0] == '-')?grp_lbl.substring(1,grp_lbl.length):grp_lbl;
            if($('#order-step-'+i+' [js_group="'+grp_lbl+'"]').find('[js_val]').is('.ordertxt')) {
              $('#order-step-'+i+' [js_group="'+grp_lbl+'"]').find('[js_val]').val(order.value);
              if($('#order-step-'+i+' [js_group="'+grp_lbl+'"]').find('[js_val]').is('.txtprint')) {
                $('#order-step-'+i+' .swatch-image-txt').text(order.value);
              }
            }
            else if($('#order-step-'+i+' [js_group="'+grp_lbl+'"]').find('[js_val]').is('input[type="checkbox"]')) {
              if(order.value == true) {
                $('#order-step-'+i+' [js_group="'+grp_lbl+'"]').find('[js_val]').prop('checked',true).trigger('change');
              }
              else {
                $('#order-step-'+i+' [js_group="'+grp_lbl+'"]').find('[js_val]').prop('checked',false).trigger('change');
              }
            }
            else {
              if($('#order-step-'+i+' [js_group="'+grp_lbl+'"]').find('[js_val="'+order.value+'"]').parents('[js_opt]').length) {
                $('#order-step-'+i+' [js_group="'+grp_lbl+'"]').find('[js_val="'+order.value+'"]').parents('[js_opt]').trigger('click');
              }
              else {
                $('#order-step-'+i+' [js_group="'+grp_lbl+'"]').find('[js_val="'+order.value+'"]').trigger('click');
              }
            }
          }
          else {
            $('#order-step-'+i).find('[js_val="'+order+'"]').trigger('click'); 
          }
        });
        if(i == 2) {
          if($('#order-step-'+i+' .selected[js_val]').length == 5) {
            $('#order-step-'+i+' [js_val]:not(.selected)').addClass('disabled');
          }
        }
      }
    });
  }
});

$('.step-o-btn').on('click', function(){
  window.scrollTo({top: 0, behavior: 'smooth'});
  if($(this).hasClass('step-next-btn')) {
    var opts = {},order_val;
    if($('#order-step-'+$(this).attr('curr-step')).find('[js_group_label]').length) {
      opts.title = $('#order-step-'+$(this).attr('curr-step')).find('[js_group_label]').attr('js_group_label');
    }
    opts.items = {}
    $('#order-step-'+$(this).attr('curr-step')).find('.selected,.ordertxt,#isGift').each(function(index){
      if(!$(this).is(':visible') || $(this).parents('[js_group]').hasClass('disabled')) {return;}
      if($(this).parents('[js_group]').find('[js_label]').length) {
        opts.items[index] = {};
        opts.items[index].label = ($(this).parents('[js_group]').find('[js_label]').attr('js_label') != '')?$(this).parents('[js_group]').find('[js_label]').attr('js_label'):$(this).parents('[js_group]').find('[js_label]').text();
        
        order_val = $(this).attr('js_val');
        if($(this).is('.ordertxt')) {
          order_val = $(this).val();
        }
        else if($(this).is('#isGift')) {
          order_val = $(this).prop('checked');
        }
        if(typeof order_val == 'undefined') {
          order_val = $(this).find('[js_val]').attr('js_val');
        }
        opts.items[index].value = order_val;
      }
      else {
        opts.items[index] = $(this).attr('js_val');
      }
    });
    if($(this).attr('curr-step') == '3') {
      if($(this).parents('.order-i-steps').find('.steps-o-checked.selected').length == 0) {
        $(this).parents('.order-i-steps').find('.step-errors').show();
        return;
      }
    }
    $('#order-step-'+$(this).attr('next-step')).addClass('showed').siblings('.order-i-steps').removeClass('showed');  
    
    setCookie('rh_orderStep-'+$(this).attr('curr-step'),JSON.stringify(opts),1);
    
    if($(this).attr('curr-step') == '5') {
      var properties = {},tmp_arr = [],cookie_data,variant_id;
      for(var i=1;i<=5;i++){
        cookie_data = JSON.parse(getCookie('rh_orderStep-'+i));
        if(typeof cookie_data.title !== 'undefined') {
          //properties[cookie_data.title] = [];
          tmp_arr = $.map(cookie_data.items, function(value, index){
            return [value];
          });
          properties[cookie_data.title] = tmp_arr.join(',');
        }
        else {
          $.each(cookie_data.items,function(index, order){
            if(order.label == 'SHAMPOO + CONDITIONER SET') { variant_id = order.value;return; }
            if(order.label == 'is this a gift?') {return;}
            properties[order.label] = [];
            properties[order.label] = order.value;
          });
        }
      }
      $.ajax({
        url: '/cart/add.js',
        type: 'post',
        dataType: 'json',
        data: {
          id: variant_id,
          quantity: 1,
          properties: properties
        },
        success: function(data) {
          location.href = '/cart';
        }
      })
    }
  }
  else {
    $('#order-step-'+$(this).attr('prev-step')).addClass('showed').siblings('.order-i-steps').removeClass('showed');
  }
});

function set_cookie(cname, cvalue, exdays) {
  var d = new Date();
  d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
  var expires = "expires="+d.toUTCString();
  document.cookie = cname + "=" + escape(cvalue) + ";" + expires + ";path=/";
}

function get_cookie(cname) {
  var name = cname + "=";
  var ca = document.cookie.split(';');
  for(var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return unescape(c.substring(name.length, c.length));
    }
  }
  return "";
}

// cd jaydip
if($('.template_alt_pro .prod-single-slider').length){
    $('.template_alt_pro .prod-single-slider').slick({
      dots: false,
      infinite: false,
      arrows: false,
      asNavFor: '.template_alt_pro .thumbnails-wrapper .product-single__thumbnails',
      slidesToShow: 1,
      slidesToScroll: 1,
      responsive: [
        {
          breakpoint: 749,
          settings: {
            dots: true
          }
        }
      ]
    });
    $('.template_alt_pro .thumbnails-wrapper .product-single__thumbnails').slick({
      dots: false,
      infinite: false,
      arrows: true,
      prevArrow: $(".thumbnails-slider__prev"),
      nextArrow: $(".thumbnails-slider__next"),
      asNavFor: '.template_alt_pro .prod-single-slider',
      focusOnSelect: true,
      vertical: true,
      verticalSwiping: true,
      slidesToShow: 5,
      slidesToScroll: 1
    });
  
    // if($('.current_slider_index').length){
    //   $(document).on("afterChange", ".template_alt_pro .prod-single-slider", function (event, slick, currentSlide, nextSlide){
    //     var current_color_index = currentSlide + 1;
    //     $('.current_slider_index').text(current_color_index); 
    //     $('.template_new-product .new_product_temp .thumbnails-wrapper .product-single__thumbnails-item a').removeClass('active-thumb');
    //     $('.template_new-product .new_product_temp .thumbnails-wrapper .product-single__thumbnails-item:nth-child('+ current_color_index +') a').addClass('active-thumb');
    //     if($('.custom_new_products').length){
    //       $('.custom_new_products .new_product_temp .thumbnails-wrapper .product-single__thumbnails-item a').removeClass('active-thumb');
    //       $('.custom_new_products .new_product_temp .thumbnails-wrapper .product-single__thumbnails-item:nth-child('+ current_color_index +') a').addClass('active-thumb');
    //     }
    //   });
    // }
}else{
  if($('.prod-single-slider').length) {
    $('.prod-single-slider').slick({
      dots: false,
      infinite: false,
      arrows: true,
      prevArrow: $(".arrow-prev"),
      nextArrow: $(".arrow-next"),
    });
  
    if($('.current_slider_index').length){
      $(document).on("afterChange", ".prod-single-slider", function (event, slick, currentSlide, nextSlide){
        var current_color_index = currentSlide + 1;
        $('.current_slider_index').text(current_color_index); 
        $('.template_new-product .new_product_temp .thumbnails-wrapper .product-single__thumbnails-item a').removeClass('active-thumb');
        $('.template_new-product .new_product_temp .thumbnails-wrapper .product-single__thumbnails-item:nth-child('+ current_color_index +') a').addClass('active-thumb');
        if($('.custom_new_products').length){
          $('.custom_new_products .new_product_temp .thumbnails-wrapper .product-single__thumbnails-item a').removeClass('active-thumb');
          $('.custom_new_products .new_product_temp .thumbnails-wrapper .product-single__thumbnails-item:nth-child('+ current_color_index +') a').addClass('active-thumb');
        }
      });
    }
  }
}
  
$('.faq-q-list > ul > li > h6').on('click', function(){
  $(this).toggleClass('active')
  $(this).next('div').slideToggle();
});

$('.menu_cls').on('click', function(){
  $('.nav-i-menu').slideToggle();
});

function bundleAdd(ids,properties,extra_id) {
  if(ids.length) {
    var id = ids.shift();
    $.ajax({
      url: '/cart/add.js',
      type: 'POST',
      dataType: 'json',
      data: {
        id: id,
        quantity: 1,
        properties: properties
      },
      success: function(){},
      complete: function() {
        bundleAdd(ids,properties,extra_id);
      }
    });
  } else {
    if(extra_id != null) {
      var props = {},value,$this,$tmp;
      $('.quiz-wrap .qz-step').each(function(){
        value = '';
        $this = $(this);
        if($(this).hasClass('finalStep')) {
          return;
        } else if($(this).find('.qz-body').hasClass('options')) {
          if($(this).find('.option.active').length) value = $(this).find('.option.active').text();
        } else if($(this).find('.qzName').length) {
          if($(this).find('.qzName').val().trim() != '') value = $(this).find('.qzName').val();
        } else if($(this).hasClass('color-step')) {
          $(this).find('.qzColor.checked').each(function(){
            $tmp = $this.find('.head[data-indx="'+$(this).parents('.qz-colors').attr('color-indx')+'"]');
            props[$tmp.text().trim()] = $(this).attr('data');
          });
        }
        if(value == '') return;
        props[$(this).find('.head').text()] = value;
      });
      if(!$.isEmptyObject(props)) {
        $.ajax({
          url: '/cart/add.js',
          type: 'POST',
          dataType: 'json',
          data: {
            id: extra_id,
            quantity: 1,
            properties: props
          },
          success: function(){},
          complete: function() {
            location.href = '/cart';
          }
        });
      }
    } else {
      location.href = '/cart';
    }
  }
}

if($('.custom_new_products').length){
  var cookie_page_name = $('.custom_new_products .new_product_temp').attr('data-section-id');
}else{
  var cookie_page_name = "rh_selection";
}
if($('body').attr('data-page-handle') != ''){
  cookie_page_name = $('body').attr('data-page-handle');
}

function prepareJSON($this) {
  var current_seletion = {},cookie_data = get_cookie(cookie_page_name),rh_selection = {},value = '',$parent;
  if($this.hasClass('jsRadio')) {
    value = $this.attr('data');
    $parent = $this.parents('.selection-choices');
  }else if($this.hasClass('custom_radio')) {
    if($this.parents('.slideChoices').find('.product_details_ms_input textarea').val() != '' && $this.parents('.custom_radio_list').find('.is_selected').attr('data-label') == 'Yes'){
      value = $this.parents('.custom_radio_list').find('.is_selected').attr('data-label') + ' - ' + $this.parents('.slideChoices').find('.product_details_ms_input textarea').val();  
    }else{
      value = $this.parents('.custom_radio_list').find('.is_selected').attr('data-label');  
    }
    $parent = $this.parents('.slideChoices').find('.product_details_ms_input textarea');
  } else if($this.hasClass('jsChkBx')) {
    value = [];
    $parent = $this.parents('.selection-choices');
    $parent.find('.active-choice').each(function(){
      value.push($(this).attr('data'));
    });
    value = value.join(',');
  } else if($this.hasClass('jsInput')) {
    $parent = $this;
    value = $this.val();
  }
  
  if(value == '') return;
  
  if(cookie_data != '') {
    cookie_data = JSON.parse(cookie_data);
    if(typeof cookie_data[$parent.attr('data-label')] !== 'undefined') {
      cookie_data[$parent.attr('data-label')] = value;
      rh_selection = cookie_data;
    } else {
      current_seletion[$parent.attr('data-label')] = value;
      rh_selection = Object.assign(cookie_data,current_seletion);
    }
  } else {
    rh_selection[$parent.attr('data-label')] = value;
  }
  rh_selection = JSON.stringify(rh_selection);
  set_cookie(cookie_page_name,rh_selection,1);
}

function setProductImage(color_code,product_handle) {
  if(typeof color_code != 'undefined' && product_handle != 'undefined') {
    var productImgs = $('#productImgJSON').text();
    color_code = color_code.replace(/#/g,'').toLowerCase();
    if(typeof productImgs != 'undefined') {
      productImgs = JSON.parse(productImgs);
      for(product in productImgs) {
        if(product == product_handle) {
          for(code in productImgs[product_handle]) {
            if(code == color_code) {
              if($('.jsSelectProduct[data="'+product_handle+'"]').length) $('.jsSelectProduct[data="'+product_handle+'"] .sel-pr-img img').attr('src',productImgs[product_handle][code]);
              break;
            }
          }
          break;
        }
      }
      
      //set combo
      if($('.selection-colors').length == $('.selection-colors .active-choice').length) {
        var combo_name = [],combo_color = [];
        $('.selection-colors').each(function(){
          combo_name.push($(this).attr('data'));
          combo_color.push($(this).find('.active-choice').attr('data').replace(/#/g,'').toLowerCase());
        });
        combo_name = combo_name.join('-');
        combo_color = combo_color.join('_');
        for(product in productImgs) {
          if(product == combo_name) {
            for(code in productImgs[combo_name]) {
              if(code == combo_color) {
                if($('.jsSelectProduct[data="'+combo_name+'"]').length) $('.jsSelectProduct[data="'+combo_name+'"] .sel-pr-img img').attr('src',productImgs[combo_name][code]);
                break;
              }
            }
            break;
          }
        }
      }
    }
  }
}

function setSelection() {
  var selection = get_cookie(cookie_page_name),$active,$active_parent,values,is_goal = false,size,$content,color_code,product_handle;
  if(selection != '') {
    selection = JSON.parse(selection);
    for(key in selection) {
      $active_parent = $('[data-label="'+key+'"]');
      if($active_parent.length) {
        if($active_parent.hasClass('radio-wrap')) {
          $active = $active_parent.find('[data="'+selection[key]+'"]').addClass('active-choice');
          if($active_parent.find('[data="'+selection[key]+'"]').hasClass('color-box')) {
            $('.selected-color-img img[data="'+selection[key]+'"]').addClass('active').siblings('img').removeClass('active');
          }
        } else if($active_parent.hasClass('checkbx-wrap')) {
          values = selection[key].split(',');
          if(key == '5 goals') is_goal = true;
          $(values).each(function(index,value){
            $active_parent.find('[data="'+value+'"]').addClass('active-choice');
            size = values.length-1;
            if(is_goal && size == index) {
              $content = $active_parent.parents('.selection-slide').find('.jsContent');
              $content.removeClass('hide');
              $content.find('.jsTitle').text(value);
              $content.find('.jsDesc').text($active_parent.find('[data="'+value+'"]').attr('data-desc'));
              $content.find('.jsKeys').text($active_parent.find('[data="'+value+'"]').attr('data-key'));
              is_goal = false;
            }
          });
        } else if($active_parent.parents('.slideChoices').hasClass('radio_with_textbox')) { 
          if(selection[key] == 'No'){
            $active_parent.parents('.slideChoices').find('.custom_radio_list .custom_radio[data-label="'+ selection[key] +'"]').addClass('is_selected');
          }else{
            var current_text = selection[key].split(' - ');
            $active_parent.val(current_text[1]);
            $active_parent.parents('.slideChoices').find('.custom_radio_list .custom_radio[data-label="'+ current_text[0] +'"]').addClass('is_selected');
            $active_parent.parents('.slideChoices').find('.product_details_ms_input').removeClass('hide');
          }
        }else if($active_parent.hasClass('jsInput')) {
          $active_parent.val(selection[key]);
          $('.slide-1 .bottle_name').text(selection[key]);
        }

        if($active_parent.parents('.selection-slide').hasClass('radio_Required')){
          var data_total_choices = parseInt($active_parent.parents('.selection-slide').attr('data-total-choices'));
          if($active_parent.parents('.selection-slide').find('.selection-choice.jsRadio.active-choice').length >= data_total_choices){
            $active_parent.parents('.selection-slide').addClass('slide_done');  
          }
        }else{
          $active_parent.parents('.selection-slide').addClass('slide_done');
        }
      }
      product_handle = key.toLowerCase();
      if(product_handle.indexOf('color') >= 0) {
        product_handle = product_handle.split(' ');
        product_handle.pop();
        product_handle = product_handle.join('-').toLowerCase();
        product_handle = product_handle.replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, '')
        setProductImage(selection[key],product_handle);
      }
    }

    // CD CODE
    setTimeout(function() {
      if($('.template-page.Makeorder .selection-slide.focus_goal.active-slide, .template-page.Quiz .selection-slide.focus_goal.active-slide').length && selection['Main Haircare']){
        if($('.template-page .selection-slide.focus_goal.active-slide .selection-choice[data="'+ selections['Main Haircare'] +'"]').length){
          $('.template-page .selection-slide.focus_goal.active-slide .selection-choice[data="'+ selection['Main Haircare'] +'"]').addClass('active-choice');
          $('.template-page .selection-slide.focus_goal.active-slide .selection-choice:not(.active-choice)').addClass('selection-disabled');
        }
      }
    },1000);
  }
}

function setKeys(goals, $this) {
  var key_html = '',values = [],ingName,counter = 0,img_url = 'https://cdn.shopify.com/s/files/1/0256/1071/5182/files/round_image.png?v=1594482058',desc = "Lowers hair porosity to fight humidity and reduce frizz.";
  $.getJSON("https://cdn.shopify.com/s/files/1/0256/1071/5182/files/ingredients.json?v=1611126042", function(result){
		key_html +=getGraphData();   		 
$('.key-ingredients').empty();
    var indexfin = 0;
    $(result).each(function(index, data){
      if(goals.indexOf(data.Goals) >= 0) {
        indexfin++;
        //key_html += '<h2>'+data['Goals']+'</h2>';
		key_html += '<div class="inner-wrapper-i">';
        key_html += '<h2>'+indexfin+' Goal: '+data['Goals']+'</h2>';
        key_html += '<p>'+data['Maincontent']+'</p>'; 
        for(var i = 1;i <= 3;i++) {
          ingName = 'Ingredient '+i;
          if(typeof data[ingName] != 'undefined' && values.indexOf(data[ingName]['title']) == -1) {
            values.push(data[ingName]['title']);
            if(data[ingName]['title'] != '') {
              if(counter >= 100) {
                key_html += '<div class="key-ingredient key-hide">';
              } else {
                key_html += '<div class="key-ingredient">';
              }
              if(data[ingName]['image'] != '') {
                img_url = data[ingName]['image'];
              }
              if(typeof data[ingName]['desc'] != 'undefined') {
                if(data[ingName]['desc'] != '') {
                  desc = data[ingName]['desc'];
                }
              }
              key_html += '<div class="key-img">';
              key_html += '<img src="'+img_url+'">';
              key_html += '</div>';
              key_html += '<div class="key-content">';
              key_html += '<h5>'+data[ingName]['title']+'</h5>';
              key_html += '<p>'+desc+'</p>';
              key_html += '</div>';
              key_html += '</div>';
              counter++;
				
            }
          }
        }
       key_html += '</div>';
		}
       
    });

    if(counter > 100) {
      $('.key-more').show();
    } else {
      $('.key-more').hide();
    }
    
    $('.key-ingredients').append(key_html);
    
  });

  if($('.custom_new_products').length){
    if($this != undefined && $this.parents('.selection-choices').attr('data-total-select-goals') != null){
      var current_goal = $this.parents('.selection-choices').attr('data-total-select-goals');
    }else{
      var current_goal = 3
    }
    var total_goal = current_goal;
  }else{
    if($('.custom_skincare_quiz').length){
      var total_goal = 3;
    }else{
      var total_goal = 5;
    }
    
  }
  
  if($('.jsGoal.active-choice').length >= total_goal) {
    $('.jsGoal:not(.active-choice)').addClass('selection-disabled');
  } else {
    $('.jsGoal').removeClass('selection-disabled');
  }
}

var timeoutId;
$('.jsBtnNav').on('click',function(e){
  var nextIndex,prevIndex,$activeSlide = $('.selection-slide.slide-'+$(this).attr('data-target')),currIndex,totalSlides,percent;

  if($(this).hasClass('klaviyo_action')) {
    var $curent_slide = $('.selection-slide.active-slide');
    if($curent_slide.hasClass('klaviyo_slide')) {
      if($curent_slide.find('form button')) $curent_slide.find('form button').trigger('click');
    }
  }
  
  if($(this).hasClass('btnNext')) {
    if($('.slideChoices.radio_Required.active-slide').length){
      var total_check_box = 0;
      var current_slide_index = parseInt($('.selection-slide.active-slide').attr('data-total-choices'));
      $('.slideChoices.radio_Required.active-slide .selection-choices').each(function(){
        if($(this).find('.selection-choice.active-choice').length){
          total_check_box = total_check_box + 1;
        }else{
          window.scroll({top: $(this).offset().top - 230, behavior: "smooth"});
          return false;
        }
      });

      if(total_check_box < current_slide_index){
        return false;
      }
    }

    // CD CODE
    if($('.template-page.Makeorder .selection-slide.slide-13.active-slide').length && $('.selection-slide.slide-13.inputRequired .selection-desc .selection-input').val() == ''){
       var curt_slide_top = $('.template-page.Makeorder .selection-slide.slide-13.active-slide').offset().top - 150;
      window.scrollTo({top: curt_slide_top, behavior: 'smooth'});
      $('.template-page.Makeorder .selection-slide.slide-13.active-slide .selection-desc .error_show').removeClass('hide');
      return false;
    }else{
      $('.template-page.Makeorder .selection-slide.slide-13.active-slide .selection-desc .error_show').addClass('hide');
    }
    
    if($(this).hasClass('btnBegin')) {
      if($(this).hasClass('allowToNext')) {
        $(this).addClass('hide');
        $('.btnNext:not(.btnBegin),.btnPrev').removeClass('hide');
      } else {
        set_cookie('rh_returnto_order',1,1);
        location.href = '/account/register';
        return;
      }
    }

    if($('.slideChoices.radio_with_textbox.active-slide').length){
      if($('.slideChoices.radio_with_textbox .product_details .custom_radio_list .custom_radio.is_selected').length){
        $('.btnNext:not(.btnBegin)').removeClass('btn-inactive')
      }else{
        $('.btnNext:not(.btnBegin)').addClass('btn-inactive')
      }
    }
    
    if($('.slideChoices.active-slide.selection-goals').length == 0){
      setTimeout(function(){
        if($('.slideChoices.active-slide:not(.slide_done)').length || $('.choice_color_pro_list.active-slide:not(.slide_done)').length){
          $('.btnNext').addClass('btn-inactive')
        }
      },50);
    }
  } else if($(this).hasClass('btnPrev')) {
    if($(this).attr('data-target') == '1') {
      $('.btnBegin').removeClass('hide');
      $('.btnNext:not(.btnBegin),.btnPrev').addClass('hide');
    } else {
      $('.btnBegin').addClass('hide');
      $('.btnNext:not(.btnBegin),.btnPrev').removeClass('hide');
    }

    // CD CODE
    if($('.selection-slide.slide-13.inputRequired .selection-desc .selection-input').length){
      $('.template-page.Makeorder .selection-slide.slide-13.active-slide .selection-desc .error_show').addClass('hide');
    }
  }
  
  $('.selection-footer,.selection_nav').removeClass('hide');
  $('.btnBuy').addClass('hide');

  if($activeSlide.hasClass('loaderSlide')) {
    if(typeof timeoutId != 'undefined') clearTimeout(timeoutId);
    $('.selection-footer,.selection_nav').addClass('hide');
    if($(this).hasClass('btnPrev')) {
      timeoutId = setTimeout(function(){
        $('.btnPrev:eq(0)').trigger('click');
      },1000);
    } else {
      timeoutId = setTimeout(function(){
        $('.btnNext:not(.btnBegin)').trigger('click');
      },1000);
    }
  } else if($activeSlide.hasClass('finalSlide')) {
    $('.jsBtnNav:not(.btnPrev)').addClass('hide');
    $('.btnBuy').removeClass('hide');
  } else if($activeSlide.hasClass('manualChange')) {
    if($activeSlide.find('.selection-choices').length) {
      if($activeSlide.find('.active-choice').length && $activeSlide.find('.active-choice').length == $activeSlide.find('.selection-choices').length) {
        if($activeSlide.hasClass('inputRequired')) {
          if($activeSlide.find('.jsInput').val().trim() != '') {
            $('.btnNext:not(.btnBegin)').addClass('btn-active').removeClass('btn-inactive');
            $activeSlide.addClass('slide_done');
          } else {
            $('.btnNext:not(.btnBegin)').addClass('btn-inactive').removeClass('btn-active');
            $activeSlide.removeClass('slide_done');
          }
        } else {
          $('.btnNext:not(.btnBegin)').addClass('btn-active').removeClass('btn-inactive');
          $activeSlide.addClass('slide_done');
        }
      } else {
        $('.btnNext:not(.btnBegin)').addClass('btn-inactive').removeClass('btn-active');
        $activeSlide.removeClass('slide_done');
      }
    } else {
      $('.btnNext:not(.btnBegin)').addClass('btn-active').removeClass('btn-inactive');
      $activeSlide.addClass('slide_done');

      // CD CODE
      if($('.custom_new_quiz').length){
        setTimeout(function() {
          $('.btnNext').removeClass('btn-inactive');
        }, 100);
      }
    }
  } else {
    if($activeSlide.hasClass('slideChoices')) {
      if($activeSlide.find('.active-choice').length) {
        $('.btnNext:not(.btnBegin)').addClass('btn-active').removeClass('btn-inactive');
      } else {
        $('.btnNext:not(.btnBegin)').addClass('btn-inactive').removeClass('btn-active');
      }
    } else {
      $('.btnNext:not(.btnBegin)').addClass('btn-inactive').removeClass('btn-active');
    }
  }

  $activeSlide.addClass('active-slide').siblings('.selection-slide').removeClass('active-slide');

  // CD CODE
  if($('.product_tab_quiz').length){
    $('.custom_new_quiz .pro_quiz_content').removeClass('is_tab_open').slideUp();
    $('.custom_new_quiz .selection-slide.active-slide .pro_quiz_content').addClass('is_tab_open').slideDown();
  }
  
  nextIndex = parseInt($(this).attr('data-target'))+1;
  prevIndex = parseInt($(this).attr('data-target'))-1;
  
  if($activeSlide.hasClass('klaviyo_slide')) { 
    $('.btnNext').addClass('klaviyo_action');
  } else {
    $('.btnNext').removeClass('klaviyo_action');
  }
  
  if($('.selection-slide.slide-'+nextIndex).length) {
    $('.btnNext').attr('data-target',nextIndex);
  }
  $('.btnPrev').attr('data-target',prevIndex);
  
  totalSlides = $('.selection-slide').length;
  currIndex = parseInt($activeSlide.attr('data-index'));
  percent = (currIndex*100)/totalSlides;
  percent = 100-percent;
  if(percent >= 0) {
    percent = percent+'%';
    $('.jsProgress').animate({right: percent});
  }
   var header_sticky = 0;
  if($('.head-wrap.head-fixed').length) header_sticky = $('.head-wrap.head-fixed').outerHeight();
  if($('.header_timer').length) header_sticky += ($('.header_timer').outerHeight() + 30);
  $('html,body').animate({scrollTop: $('.custom-selection').offset().top - header_sticky});
  location.hash = 'slide-'+currIndex;

  // CD CODE
  if($('.selection-slide.focus_goal.active-slide').length){
    $('.selection-slide.focus_goal .selection-choices').html('');
    var new_html = "";
    $('.selection-slide.selection-goals .selection-choice.label-only.active-choice').each(function(element){
      new_html += '<div class="selection-choice label-only jsChkBx" data="'+ $(this).find('.choice-label').text() +'"><div class="choice-label">'+ $(this).find('.choice-label').text() +'</div></div>';
    });
    $('.selection-slide.focus_goal .selection-choices').html(new_html);
    
    var selections = get_cookie(cookie_page_name)
    if(selections != ''){
      selections = JSON.parse(selections);
      if($('.template-page.Makeorder .selection-slide.focus_goal.active-slide, .template-page.Quiz .selection-slide.focus_goal.active-slide').length && selections['Main Haircare']){
        if($('.template-page .selection-slide.focus_goal.active-slide .selection-choice[data="'+ selections['Main Haircare'] +'"]').length){
          $('.template-page .selection-slide.focus_goal.active-slide .selection-choice[data="'+ selections['Main Haircare'] +'"]').addClass('active-choice');
          $('.template-page .selection-slide.focus_goal.active-slide .selection-choice:not(.active-choice)').addClass('selection-disabled');
        }
      }
    }

    setTimeout(function() {
      if($('.template-page.Quiz .selection-slide.focus_goal .selection-choice.active-choice').length == 0){
        $('.btnNext').addClass('btn-inactive');
        $('.btnNext').removeClass('btn-active');
      }
    }, 200);
    
    if($('.template-page.Makeorder .selection-slide.focus_goal .selection-choice.active-choice').length == 0){
      $('.btnNext').addClass('btn-inactive');
      $('.btnNext').removeClass('btn-active');
    }
  }

  // setTimeout(function() {
  //   console.log('cakllkllll')
  //   if($('.template-page.Makeorder .selection-slide.slide-13.active-slide').length){
  //     if($('.template-page.Makeorder .selection-slide.slide-13.active-slide .jsInputRequired').val() == ''){
  //       $('.template-page.Makeorder .selection-slide.slide-13.active-slide .selection-desc .error_show').addClass('hide');
  //       $('.template-page.Makeorder .selection-slide.slide-13.active-slide .selection-desc .error_show').removeClass('hide');
  //       $('.btnNext').addClass('btn-inactive');
  //     $('.btnNext').removeClass('btn-active');
  //     }
  //   }
  // },100);
});

// Chackbox tab event
$(document).on('click','.jsChackbox',function(){
  var $_chk_parent = $(this).parents('.selection-slide');
  if($(this).hasClass('is_selecte_pro') == false){
    $(this).addClass('is_selecte_pro');
  }else{
    $(this).removeClass('is_selecte_pro'); 
  }

  if($(this).parents('.multiple-check-box').find('.is_selecte_pro').length){
    $_chk_parent.addClass('slide_done');
    if($_chk_parent.find('.next_slide')){
      $_chk_parent.find('.next_slide').prop('disabled', false);
    }
    $('.btnNext:not(.btnBegin)').addClass('btn-active').removeClass('btn-inactive');
  }else{
    $_chk_parent.removeClass('slide_done');
    if($_chk_parent.find('.next_slide')){
      $_chk_parent.find('.next_slide').prop('disabled', true);
    }
    $('.btnNext:not(.btnBegin)').addClass('btn-active').addClass('btn-inactive');
  }

  prepareJSON($(this));
});

$(document).on('click','.jsRadio',function(){
  var $parent = $(this).parents('.selection-slide');
  if($parent.hasClass('init-slide')) {
    $('.btn-nav').removeClass('hide');
    $('.btnBegin').addClass('hide');
  } 
  $(this).addClass('active-choice').siblings('.jsRadio').removeClass('active-choice');
  if(!$(this).parents('.selection-slide').hasClass('manualChange')) {
    $('.btnNext:not(.btnBegin)').removeClass('btn-inactive');
    if($('.product_tab_quiz').length == 0){
      $parent.addClass('slide_done');
    }
    if(typeof timeoutId != 'undefined') clearTimeout(timeoutId);

    if($('.product_tab_quiz').length && $parent.hasClass('slideChoices')){
      var total_slideChoices = $parent.attr('data-total-choices'),
          current_slideChoices = $parent.find('.selection-choice.active-choice');
      if(current_slideChoices.length >= parseInt(total_slideChoices)){
        $parent.find('.next_slide').prop('disabled', false);
        $parent.addClass('slide_done');
      }else{
        timeoutId = setTimeout(function(){
          $('.btnNext:not(.btnBegin)').trigger('click');
        },100);
      }
    }else if($('.product_tab_quiz').length && $parent.hasClass('choice_color_pro_list')){
      var input_val = $parent.find('.selection-input').val();
      if(input_val.trim() == ''){
         var page_scroll = $parent.find('.selection-input').offset().top - 200;
         window.scrollTo({top: page_scroll, behavior: 'smooth'});
         $parent.find('.selection-input').css('border-color', 'red');
      }else{
        if($parent.find('.color-box.active-choice').length){
         $parent.find('.next_slide').prop('disabled', false);
         $parent.addClass('slide_done');
        }
      }
    }else{
      timeoutId = setTimeout(function(){
        $('.btnNext:not(.btnBegin)').trigger('click');
      },100);
    }
  } else {
    if($(this).hasClass('selection-color')){
      if($(this).parents('.selection-slide').find('.active-choice').length == $(this).parents('.selection-slide').find('.colors-wrap').length) {
        $('.btnNext:not(.btnBegin)').removeClass('btn-inactive');
        $parent.addClass('slide_done');
        if(typeof timeoutId != 'undefined') clearTimeout(timeoutId);
        timeoutId = setTimeout(function(){
          $('.btnNext:not(.btnBegin)').trigger('click');
        },100);  
      } else {
        $('.btnNext:not(.btnBegin)').addClass('btn-inactive').removeClass('btn-active');
        $parent.removeClass('slide_done');
      }
      setProductImage($(this).attr('data'),$(this).parents('.selection-colors').attr('data'));
    } else {
      if($parent.hasClass('inputRequired')) {
        if($parent.find('.jsInputRequired').val().trim() != '' && $parent.find('.active-choice').length && $parent.find('.selection-choices').length == $parent.find('.active-choice').length) {
          $('.btnNext:not(.btnBegin)').addClass('btn-active').removeClass('btn-inactive');
          $parent.addClass('slide_done');
        } else {
          // $('.btnNext:not(.btnBegin)').addClass('btn-inactive').removeClass('btn-active');
          $parent.removeClass('slide_done');
        }
      } else {
        $('.btnNext:not(.btnBegin)').addClass('btn-active').removeClass('btn-inactive');
        $parent.addClass('slide_done');
      }
    }
  }
  
  if($parent.hasClass('init-slide')) $('.btn_begin').removeClass('btn-inactive');
  if($(this).hasClass('body-care-color')){
    saveData($parent.find('.js_selections_add').attr('data-label'),$(this).attr('data'));
  }
  
  prepareJSON($(this));
});

$(document).on('click','.jsChkBx',function(){
  $(this).toggleClass('active-choice');
  if($(this).parents('.checkbx-wrap').find('.active-choice').length) {
    $('.btnNext:not(.btnBegin)').addClass('btn-active').removeClass('btn-inactive');
    $(this).parents('.selection-slide').addClass('slide_done');
    if($('.product_tab_quiz').length){
      $(this).parents('.selection-slide').find('.next_slide').prop('disabled', false);
    }
  } else {
    $('.btnNext:not(.btnBegin)').addClass('btn-inactive').removeClass('btn-active');
    $(this).parents('.selection-slide').removeClass('slide_done');
    if($('.product_tab_quiz').length){
      $(this).parents('.selection-slide').find('.next_slide').prop('disabled', true);
    }
  }

  
  if($('.selection-slide.focus_goal.active-slide').length){
    if($('.selection-slide.focus_goal.active-slide .active-choice').length >= 1) {
      $('.selection-slide.focus_goal.active-slide .selection-choice:not(.active-choice)').addClass('selection-disabled');
      $('.btnNext:not(.btnBegin)').trigger('click');
    } else {
      $('.selection-slide.focus_goal.active-slide .selection-choice').removeClass('selection-disabled');
    }
  }
  
  prepareJSON($(this));
});

$(document).on('click','.jsGoal',function(){
  var $content = $(this).parents('.slideChoices').find('.jsContent'),$parent = $(this).parents('.checkbx-wrap'),goals = [];
  if($(this).hasClass('active-choice')) {
    if(typeof $(this).attr('data-desc') != 'undefined' || typeof $(this).attr('data-key') != 'undefined') {
      $content.find('.jsTitle').text($(this).find('.choice-label').text());
      if(typeof $(this).attr('data-desc') != 'undefined') {
        $content.find('.jsDesc').html($(this).attr('data-desc'));
      }
      if(typeof $(this).attr('data-key') != 'undefined') {
        $content.find('.jsKeys').html($(this).attr('data-key'));
      }
      $content.removeClass('hide');
    } else {
      $content.addClass('hide');
    }
  } else {
   $content.addClass('hide');
  }

  $parent.find('.jsGoal.active-choice').each(function(){
    goals.push($(this).attr('data'));
  });
  setKeys(goals, $(this));
});
/*
$('.jsBtnAdd').on('click',function(){
 
  
  var ids = [];
  $(this).toggleClass('btn-added');
  
   $(this).parent('.sel-pr-btn').toggleClass('btn-added');
$(this).parent().parent().parent('.jsSelectProduct').toggleClass('pro-selected');
  $('.jsBtnAdd').each(function(){
    if($(this).hasClass('btn-added')) ids.push($(this).attr('data-id'));
  });
  
   ids = ids.join('|');
  $('.selected_ids').val(ids);
    
});
*/
$('.jsKeyMore').on('click',function(){
  $(this).parents('.key-more').hide();
  $('.key-ingredients').find('.key-ingredient').removeClass('key-hide');
});

$('.btnBuy').on('click',function(e){
  e.preventDefault();
  // location.href = '/cart';
  /* var properties = {},json_object;
  if($('.selected_ids').val() != '') {
    $(this).addClass('btnLoading');
    if(get_cookie('rh_selection') != '') {
      json_object = JSON.parse(get_cookie('rh_selection'));
      for (var prop in json_object) {
        if (Object.prototype.hasOwnProperty.call(json_object, prop)) {
          properties[prop] = [];
          properties[prop] = json_object[prop];
        }
      }
    }
    
    var extra_id = null; 
    if($('.quiz-wrap').length) {
      if($('.quiz-wrap').hasClass('quiz-added')) {
        extra_id = $('.quiz-wrap .btnQuiz').attr('data-id');
      }
    }
    
    bundleAdd($('.selected_ids').val().split('|'),properties,extra_id);
  }*/
});

$('.jsInput').on('change',function(){
  prepareJSON($(this));
});

// Hair-care
function jump_to(indx) {
  // CD Sanket
  
  indx = parseInt(indx);
  var $curr_slide = $('.selection-slide.slide-'+indx);
  var $footer_height = $('.selection-footer .footer-bar-set').outerHeight();
  var $quiz_height_ask = $('.quiz-height-ask').outerHeight();
  var $total_height = $footer_height + $quiz_height_ask;
  var windowSize = $(window).width();
  var color_image_url = $('.js_image_change_meta.active-choice').attr('img-color');
 
  if(color_image_url != ''){
    $('.js_product_img_add').attr('img-color',color_image_url);
  }else{
     $('.js_product_img_add').attr('img-color','');
  }

  // CD CODE
  if($curr_slide.hasClass("color-slide")) { // CD [add rule to make color & fragrance selection mandatory on slide - 13]
    if($curr_slide.find(".active-choice").length && $curr_slide.find('.jsInput').length > 0 && $curr_slide.find('.jsInput').val().trim() != '') {
      $('.btnNext').removeClass('btn-inactive').addClass("btn-active");
    } else {
      $('.btnNext').removeClass('btn-active').addClass("btn-inactive");
    }
  } else {
    if($('.inputRequired.selection-slide.active-slide').length){
      $('.btnNext').removeClass('btn-inactive');
    } 
  }

  if($('.custom_new_quiz').length){
    if($('.slide-1.active-slide .selection-input').val() == ''){
      $('.btnNext').addClass('btn-inactive');
      $('.slide-1 .error_show').removeClass('hide');
      if($('.custom_new_quiz .selection-slide.active-slide .Next-slide-btn').length){
        $('.custom_new_quiz .selection-slide.active-slide .Next-slide-btn').addClass('btn-inactive');
      }
    }else{
      if($('.selection-slide.selection-goals + .multiple-check-box.active-slide').length){
        if($('.selection-slide.multiple-check-box.active-slide .active-choice').length){
          $('.btnNext').removeClass('btn-inactive');
        }
      }else{
        $('.btnNext').removeClass('btn-inactive');
      }
      $('.slide-1 .error_show').addClass('hide');
      if($('.custom_new_quiz .selection-slide.active-slide .Next-slide-btn').length){
        $('.custom_new_quiz .selection-slide.active-slide .Next-slide-btn').removeClass('btn-inactive');
      }
    }

    setTimeout(function() {
      if($('.custom_new_quiz .slide-1.active-slide').length){
        $('.custom_new_quiz .selection-footer').addClass('hide');
      }else{
        $('.custom_new_quiz .selection-footer').removeClass('hide');
      }
    },1000);
  }

 // if($curr_slide.find('.selection-desc .selection-input').val() == ''){
 //    $curr_slide.find('.selection-desc .selection-input').parents('.selection-desc').find('.error_show').removeClass('hide');
 // }else{
 //    $curr_slide.find('.selection-desc .selection-input').parents('.selection-desc').find('.error_show').addClass('hide');
 // }

   setTimeout(function() {
   $('.js_product_img_add').each(function() {
    var product_img_add = $(this).attr('img-color');
    var default_img_url = $(this).attr('default-url');
    var product_img_url = $(this).attr(product_img_add);
    if(product_img_url != ''){
      $(this).attr('src',product_img_url);
    }else{
      $(this).attr('src',default_img_url);
    }
  })
},1000);
   
 if($curr_slide.hasClass('add_header')){
    // $('final_slide').css('display','block');
    $('#product-nav').css('display','block');
    $('.sale_top_bar.stckiy_baar').css('display','none');
   $(".custom-selection").get(0).style.setProperty("--spacing-top","20px");
    if($(window).width() > 749){
      $('.new_product_temp').css('padding-top', '50px');
    }
    $('.add_header').parents('.page-width').addClass('top-margin-set');
    result_slider();
  }else{
   // $('final_slide').css('display','none');
   if($('.sale_top_bar.stckiy_baar').length) {
     $('.sale_top_bar.stckiy_baar').css('display','block');
     $(".custom-selection").get(0).style.setProperty("--spacing-top",$('.sale_top_bar.stckiy_baar').outerHeight()+"px");
   }
     $('#product-nav').css('display','none');
     if($(window).width() > 749){
       $('.new_product_temp').css('padding-top', '0');
     }
     $('.add_header').parents('.page-width').removeClass('top-margin-set');
  }

  $('.quiz-drawer-ask').css('bottom',$footer_height + 'px');

  if($curr_slide.hasClass('quiz-drawer-none')){
    $('.selection-inner .quiz-drawer-ask').css('display','none');
    $('.footer-bar-set .footer-info').css('bottom','67px');
  }else{
     $('.selection-inner .quiz-drawer-ask').css('display','block');
     $('.footer-bar-set .footer-info').css('bottom','110px');
  }

  
  if($curr_slide.length) {
    $('.custom-selection .curr_page').text(indx);
    if($curr_slide.hasClass('active-slide')) return;
    if($curr_slide.hasClass('loaderSlide')) return;

    $curr_slide.addClass('active-slide').siblings('.selection-slide').removeClass('active-slide');
    // CD CODE
    if($('.product_tab_quiz').length){
      $('.custom_new_quiz .pro_quiz_content').removeClass('is_tab_open').slideUp();
      $('.custom_new_quiz .selection-slide.active-slide .pro_quiz_content').addClass('is_tab_open').slideDown();
    }
    
    $('.btnPrev').attr('data-target',indx-1);
    $('.btnNext').attr('data-target',indx+1);
    
    if($curr_slide.hasClass('init-slide')) {
      $('.btn-nav,.btnBuy').addClass('hide');
      $('.btnBegin').removeClass('hide');
    } else if ($curr_slide.hasClass('finalSlide')) {
      $('.btnBegin,.btn-nav.btnNext').addClass('hide');
      $('.btnBuy,.btn-nav.btnPrev').removeClass('hide');
    } else {
      $('.btn-nav').removeClass('hide');
      $('.btnBuy,.btnBegin').addClass('hide');
    }
    
    if(!$curr_slide.hasClass("color-slide")) { // CD [Add condition to except color slide]
      if($curr_slide.hasClass('slide_done') || $curr_slide.hasClass('info_slide') || $curr_slide.hasClass('klaviyo_slide')) {
        $('.btnNext').removeClass('btn-inactive');
      } else {
        $('.btnNext').addClass('btn-inactive');
      } 
    }
    
    if($curr_slide.hasClass('klaviyo_slide')) $('.btnNext').addClass('klaviyo_action');

    var totalSlides = $('.selection-slide').length;
    var percent = (indx*100)/totalSlides;
    percent = 100-percent;
    if(percent >= 0) {
      percent = percent+'%';
      $('.jsProgress').animate({right: percent});
    }
  }

  // if($('.selection-slide').length){
  //   var total_slide = $('.selection-slide').length - 3;
  //   if(total_slide < $('.selection-slide.slide_done').length){
  //     console.log(total_slide, $('.selection-slide.slide_done').length)
  //   }
  // }

  if($('.template_custom-skincare-quiz').length || $('.template_custom-bodycare-quiz').length || $('.template_custom_quiz').length){
    setTimeout(function(){
      if($('.selection-slide').length){
        var total_slide = $('.selection-slide').length - 4;
        console.log($('.selection-slide.slide_done').length, total_slide)
        if($('.selection-slide.slide_done').length < total_slide){
          var current_data_index = $($('.selection-slide:not(.slide_done)')[0]).attr('data-index');
          if (window.location.href.indexOf("#") > -1){
            var split_value = window.location.href.split('#');
            location.href = split_value[0] + '#slide-'+current_data_index;
          }
        }
      }
    }, 1000);
  }
}

window.addEventListener('hashchange', function(){
  if(location.hash.indexOf('slide-') >= 0 && $('.custom-selection').length) {
    var indx = location.hash.substr(1).split('-')[1];
    jump_to(indx);
  }
});

$(document).ready(function(){
  
  if($('.custom-selection').length) {
    var totalSlides = $('.selection-slide').length,percent,goals = [];
    if(location.search.indexOf('logged') > 0) {
      if (window.history.pushState) {       
        var newURL = new URL(window.location.href);       
        newURL.search = '';        
        window.history.pushState({path: newURL.href},'',newURL.href); 
        if(get_cookie('rh_returnto_order') != '') set_cookie('rh_returnto_order','',0);
        $('.slide-2').addClass('active-slide').siblings('.selection-slide').removeClass('active-slide');
        $('.btnBegin').addClass('hide');
        $('.jsBtnNav:not(.btnBegin)').removeClass('hide');
        $('.btnNext:not(.btnBegin)').addClass('btn-active');
        
        percent = 200/totalSlides;
        percent = 100-percent;
        if(percent >= 0) {
          percent = percent+'%';
          $('.jsProgress').animate({right: percent});
        }
      }
    } else {
      percent = 100/totalSlides;
      percent = 100-percent;
      if(percent >= 0) {
        percent = percent+'%';
        $('.jsProgress').animate({right: percent});
      }
    }
    $('.total_pages').text(totalSlides);
    //https://cdn.shopify.com/s/files/1/0256/1071/5182/files/ingredients.json?v=1611126042
    //https://cdn.shopify.com/s/files/1/0256/1071/5182/files/csvjson.json?v=1596014624
    if($('.custom_new_products').length){
      if($('.template_pro_skincare').length){
        var current_gols_json = 'https://cdn.shopify.com/s/files/1/0554/6108/5286/files/skincaregoals.json?v=1716361569';  
      }
      if($('.template_pro_bodycare').length){
        var current_gols_json = 'https://cdn.shopify.com/s/files/1/0554/6108/5286/files/bodycaregoals.json?v=1716979908';  
      }
    }else{
      if($('.template_custom-skincare-quiz').length){
        var current_gols_json = 'https://cdn.shopify.com/s/files/1/0554/6108/5286/files/Ingredients_CD__updated.json?v=1672229305';
        // var current_gols_json = 'https://cdn.shopify.com/s/files/1/0554/6108/5286/files/skincaregoals.json?v=1716361569';  
        // var current_gols_json = 'https://cdn.shopify.com/s/files/1/0554/6108/5286/files/skincare-quiz-goal.json?v=1731327158';  
      }else if($('.template_custom-bodycare-quiz').length){
        var current_gols_json = 'https://cdn.shopify.com/s/files/1/0554/6108/5286/files/bodycare_goals.json?v=1731590033';
        // var current_gols_json = 'https://cdn.shopify.com/s/files/1/0554/6108/5286/files/bodycaregoals.json?v=1716979908'; 
        // var current_gols_json = 'https://cdn.shopify.com/s/files/1/0554/6108/5286/files/bodycare-quiz-goal.json?v=1731327158';  
      }else{
        var current_gols_json = 'https://cdn.shopify.com/s/files/1/0554/6108/5286/files/haircare_goals.json?v=1754679026';  
      }
    }
    $.getJSON(current_gols_json, function(result){
      var goal_html='';
      $.each(result, function(i, field){
        var in_val=(typeof field['Ingredient 1'] != 'undefined' && field['Ingredient 1']['title'] !=''? field['Ingredient 1']['title']:"")+(typeof field['Ingredient 2'] != 'undefined' && field['Ingredient 2']['title'] !=''?"+" +field['Ingredient 2']['title']:"")+(typeof field['Ingredient 3'] != 'undefined' && field['Ingredient 3']['title'] !=''?"+" +field['Ingredient 3']['title']:"")
          goal_html +='<div class="selection-choice label-only jsChkBx jsGoal" data="'+field['Goals'].trim()+'" data-desc="'+field['Maincontent']+'" data-key="'+in_val+'">\n\
            <div class="choice-label">'+field['Goals'].trim()+'</div>\n\
          </div>';
      });
      $('.jsGoals').html(goal_html);
      setSelection();
      
      if(location.hash.indexOf('slide-') >= 0 && $('.custom-selection').length) {
        var indx = location.hash.substr(1).split('-')[1];
        jump_to(indx);
      } else {
        if($('.init-slide').hasClass('slide_done')) {
          $('.btn_begin').removeClass('btn-inactive');
        } else {
          $('.btn_begin').addClass('btn-inactive');
        }
      }

      if($('.manualChange.inputRequired.active-slide').length){
        if($('.manualChange.inputRequired.active-slide .selection-input.jsInputRequired').val() != ''){
          $('.manualChange.inputRequired.active-slide .Next-slide-btn').removeClass('btn-inactive');
        }
      }
      
      $('.jsGoals .jsGoal.active-choice').each(function(){
        goals.push($(this).attr('data'));
      });
      setKeys(goals);
    });
  }
  
  if($('body').hasClass('template-customers-login')) {
    if(get_cookie('rh_returnto_order') != '' && $('#customer_login').length) {
      $('#customer_login').append('<input type="hidden" name="return_to" value="/pages/make-order?logged" />');
    }
  } else if($('body').hasClass('template-customers-register')) {
    if(get_cookie('rh_returnto_order') != '' && $('#RegisterForm').length) {
      $('#RegisterForm').append('<input type="hidden" name="return_to" value="/pages/make-order?logged" />');
    }
  }
  
  if($('.shopify-challenge__container #g-recaptcha').length) {
    if(get_cookie('rh_returnto_order') == 1) {
      $('<input type="hidden" name="return_to" value="/pages/make-order?logged" />').insertAfter('.shopify-challenge__container #g-recaptcha');
    }
  }

  var color_image_url = $('.js_image_change_meta.active-choice').attr('img-color');
if(color_image_url != ''){
  $('.js_product_img_add').attr('img-color',color_image_url);
}else{
   $('.js_product_img_add').attr('img-color','');
}

 setTimeout(function() {
   $('.js_product_img_add').each(function() {
    var product_img_add = $(this).attr('img-color');
    var default_img_url = $(this).attr('default-url');
    var product_img_url = $(this).attr(product_img_add);
    if(product_img_url != ''){
      $(this).attr('src',product_img_url);
    }else{
      $(this).attr('src',default_img_url);
    }
  })
},1000);

  // CD CODE
   setTimeout(function() {
    if($('.selection-slide.focus_goal .selection-choices').length){
      $('.selection-slide.focus_goal .selection-choices').html('');
      var new_html = "";
      $('.selection-slide.selection-goals .selection-choice.label-only.active-choice').each(function(element){
        new_html += '<div class="selection-choice label-only jsChkBx" data="'+ $(this).find('.choice-label').text() +'"><div class="choice-label">'+ $(this).find('.choice-label').text() +'</div></div>';
      });
      $('.selection-slide.focus_goal .selection-choices').html(new_html);
      if($('.selection-slide.focus_goal.active-slide').length){
        if($('.selection-slide.focus_goal.active-slide .selection-choice.active-choice').length == 0){
          $('.btnNext').addClass('btn-inactive');
        }
      }
    }
   },1000);


   setTimeout(function() {
    if($('.custom_new_quiz .slide-1.active-slide').length){
      $('.custom_new_quiz .selection-footer').addClass('hide');
    }else{
      $('.custom_new_quiz .selection-footer').removeClass('hide');
    }

    if($('.product_tab_quiz').length){
      $('.selection-slide.slide_done').find('.next_slide').prop('disabled', false);
      if($('.selection-slide.slide_done + .selection-slide:not(.slide_done)').length){
        $('.custom_new_quiz .selection-slide').removeClass('active-slide');
        $('.custom_new_quiz .pro_quiz_content').removeClass('is_tab_open').slideUp();
        $('.custom_new_quiz .selection-slide.slide_done + .selection-slide:not(.slide_done) .pro_quiz_content').addClass('is_tab_open').slideDown();
        $('.custom_new_quiz .selection-slide.slide_done + .selection-slide:not(.slide_done)').addClass('active-slide');
        var current_data_index = parseInt($('.custom_new_quiz .selection-slide.slide_done + .selection-slide:not(.slide_done)').attr('data-index')) + 1;
        if(current_data_index > 5){
          current_data_index = 5;
        }
        $('.custom_new_quiz .btnNext').attr('data-target', current_data_index);
      }
    }
  },1000);

  if($('.header_timer').length && $('.template_custom_quiz').length == 0 && $('.template_custom-skincare-quiz').length == 0 && $('.template_custom-bodycare-quiz').length == 0){
    var current_height = $('#shopify-section-header .site-i-header').outerHeight() + 3;
    $('.main-content').css('padding-top', current_height+'px');
  }else{
    if(!$('body').hasClass('template-index')) $('.main-content').css('padding-top', '0px');
    // $('.main-content').css('padding-top', '0px');
  }
});


//CD
$('#RecoverPassword').on('click',function(){
  set_cookie('rh_returnto_order',0,1);
});

$('#HideRecoverPasswordLink').on('click',function(){
  set_cookie('rh_returnto_order',1,1);
});

$('.jsContactSubmit').on('click',function(){
  var $form = $(this).parents('form');
  var email = $form.find('#ContactForm-email').val().trim();
  var cemail = $form.find('#ContactForm-confirmemail').val().trim();
  if(email != cemail) {
    $form.find('#ContactForm-email').val('').focus();
    $form.find('#ContactForm-confirmemail').val('');
    $form.find('.custom_error').text("Email didn't match with Confirm Email").addClass('true');
    return false;
  } else {
    $form.find('.custom_error').text("").removeClass('true');
  }
});

$('.custom-input-wrap').find('input,select,textarea').on('focusin keyup',function(){
  if($(this).val().trim() != '') {
    $(this).parents('.custom-input-wrap').addClass('input-focused');
  } else {
    $(this).parents('.custom-input-wrap').removeClass('input-focused');
  }
});

$('.custom-input-wrap').find('input,select,textarea').on('focusout',function(){
  if($(this).val().trim() == '') {
    $(this).parents('.custom-input-wrap').removeClass('input-focused');
  }
});

$('.jsInputRequired').on('keyup',function(){

  if($('.selection-slide.slide-1.active-slide').length){
    if($(this).val() != ''){
      $('.slide-1 .bottle_name').html($(this).val());
    }else{
      $('.slide-1 .bottle_name').html('beauty');
    }
  }
  
   if($(this).val() == ''){
     $(this).parents('.selection-desc').find('.error_show').removeClass('hide');
  }else{
      $(this).parents('.selection-desc').find('.error_show').addClass('hide');
  }
  
  var $parent = $(this).parents('.selection-slide');
  if($(this).val().trim() != '' && $parent.find('.active-choice').length && $parent.find('.selection-choices').length == $parent.find('.active-choice').length) {
    $('.btnNext:not(.btnBegin)').addClass('btn-active').removeClass('btn-inactive');
    $parent.addClass('slide_done');
    if($('.custom_new_quiz .selection-slide.active-slide .Next-slide-btn').length){
      $('.custom_new_quiz .selection-slide.active-slide .Next-slide-btn').removeClass('btn-inactive');
    }
  } else {
    $('.btnNext:not(.btnBegin)').addClass('btn-inactive').removeClass('btn-active');
    $parent.removeClass('slide_done');
    if($('.custom_new_quiz .selection-slide.active-slide .Next-slide-btn').length){
      $('.custom_new_quiz .selection-slide.active-slide .Next-slide-btn').addClass('btn-inactive');
    }
  }

  // CD CODE
  if($('.inputRequired.selection-slide.active-slide').length && $('.inputRequired.selection-slide.active-slide .selection-input').val().length >= 1){
    $('.btnNext').removeClass('btn-inactive');
    if($('.custom_new_quiz .selection-slide.active-slide .Next-slide-btn').length){
      $('.custom_new_quiz .selection-slide.active-slide .Next-slide-btn').removeClass('btn-inactive');
    }
  }else{
    if($('.custom_new_quiz').length){
      $('.btnNext').addClass('btn-inactive');
      if($('.custom_new_quiz .selection-slide.active-slide .Next-slide-btn').length){
        $('.custom_new_quiz .selection-slide.active-slide .Next-slide-btn').addClass('btn-inactive');
      }
    }
  }
});

$('.jsBtnRegister').on('click',function(){
  var $form = $(this).parents('form');
  var $fname = $form.find('[name="customer[first_name]"]');
  var $lname = $form.find('[name="customer[last_name]"]');
  var $phone = $form.find('[name="customer[note][phone]"]');
  var $email = $form.find('[name="customer[email]"]');
  var $pwd = $form.find('[name="customer[password]"]');
  var email_regx = /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/;

  $form.find('.form-error').addClass('hide');
  
  if($fname.val().trim() == '') {
    $form.find('.form-error').text('First name required').removeClass('hide');
    $fname.focus();
    return false;
  }
  if($lname.val().trim() == '') {
    $form.find('.form-error').text('Last name required').removeClass('hide');
    $lname.focus();
    return false;
  }
  if($phone.val().trim() == '') {
    $form.find('.form-error').text('Phone number required').removeClass('hide');
    $phone.focus();
    return false;
  }
  if($email.val().trim() == '') {
    $form.find('.form-error').text('Email required').removeClass('hide');
    $email.focus();
    return false;
  }
  if(!email_regx.test($email.val())) {
    $form.find('.form-error').text('Valid email required').removeClass('hide');
    $email.focus();
    return false;
  }
  if($pwd.val().trim() == '') {
    $form.find('.form-error').text('Password required').removeClass('hide');
    $pwd.focus();
    return false;
  }
});

$('.jsBtnLogin').on('click',function(){
  var $form = $(this).parents('form');
  var $email = $form.find('[name="customer[email]"]');
  var $pwd = $form.find('[name="customer[password]"]');
  var email_regx = /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/;

  $form.find('.form-error').addClass('hide');
  
  if($email.val().trim() == '') {
    $form.find('.form-error').text('Email required').removeClass('hide');
    $email.focus();
    return false;
  }
  if(!email_regx.test($email.val())) {
    $form.find('.form-error').text('Valid email required').removeClass('hide');
    $email.focus();
    return false;
  }
  if($pwd.val().trim() == '') {
    $form.find('.form-error').text('Password required').removeClass('hide');
    $pwd.focus();
    return false;
  }
});

function getGraphData(){
  var scalp_type = $('.slide-4 .active-choice .choice-label').html();
  var scalp_visible = $('.slide-5 .active-choice .choice-label').html();
  var strands = $('.slide-6 .active-choice .choice-label').html();
  var scalp_feel = $('.slide-7 .active-choice .choice-label').html();
  var graying = $('.slide-11 .active-choice .choice-label').html();
  var stress = $('.slide-13 .active-choice .choice-label').html();

  var Damage_Goal = 0;
  var Sebum_Goal = 0;
  var Dryness_Goal = 0;
  $( ".slide-15 .active-choice .choice-label" ).each(function( index ) {
    var datatitle = $( this ).html();
    if(datatitle=='Damage repair'){
      var Damage_Goal = 20;
    }
    if(datatitle=='Oil Control'){
      var Sebum_Goal = 15;
    }
    if(datatitle=='Deep Condition'){
      var Dryness_Goal = 10;
    }else if(datatitle=='Nourish roots'){
      var Dryness_Goal = 5;
    }else if(datatitle=='Hydrate'){
      var Dryness_Goal = 10;
    }else if(datatitle=='Shine'){
      var Dryness_Goal = 5;
    }
  });
  
  var Sensitivity = 0;
  var Damage = 0;
  var Sebum = 0;
  var Dryness = 0;
  
  
  if(scalp_type=='Dry'){
    var Sensitivity_scalp_type = 15;
    var Sebum_scalp_type = 20;
    var Dryness_scalp_type = 40;
  }else if(scalp_type=='Normal'){
    var Sensitivity_scalp_type = 10;
    var Sebum_scalp_type = 35;
    var Dryness_scalp_type = 20;
  }else if(scalp_type=='Oily'){
    var Sensitivity_scalp_type = 6;
    var Sebum_scalp_type = 55;
    var Dryness_scalp_type = 10;
  }
  
  if(scalp_feel=='Itchy &amp; painful'){
    var Sensitivity_scalp_feel = 58;
    var Damage_scalp_feel = 20;
    var Sebum_scalp_feel = 10;
  }else if(scalp_feel=='Very tight &amp; itchy'){
    var Sensitivity_scalp_feel = 40;
    var Damage_scalp_feel = 15;
    var Sebum_scalp_feel = 5;
  }else if(scalp_feel=='A little bit tight'){
    var Sensitivity_scalp_feel = 26;
    var Damage_scalp_feel = 10;
    var Sebum_scalp_feel = 3;
  }else if(scalp_feel=='Normal, not sensitive'){
    var Sensitivity_scalp_feel = 5;
    var Damage_scalp_feel = 5;
    var Sebum_scalp_feel = 0;
  }
  
  
  if(stress=='Everyday'){
    var Sensitivity_stress = 8;
  }else if(stress=='Multiple times a week'){
    var Sensitivity_stress = 3; 
  }else if(stress=='A few instances'){
    var Sensitivity_stress = 0; 
  }else if(stress=='Rarely'){
    var Sensitivity_stress = 0; 
  }

  if(scalp_visible=='A lot of scalp'){
    var Damage_scalp_visible = 10;
  }else if(scalp_visible=='Fine line'){
    var Damage_scalp_visible = 7; 
  }else if(scalp_visible=='No scalp'){
    var Damage_scalp_visible = 5;   
  }

  if(strands=='None'){
    var Damage_strands = 5;
  }else if(strands=='A few'){
    var Damage_strands = 10; 
  }else if(strands=='A handful'){
    var Damage_strands = 15; 
  }else if(strands=='A lot of strands'){
    var Damage_strands = 20; 
  }

  if(graying=='No white strands'){
    var Damage_graying = 0;
  }else if(graying=='Few white strands'){
    var Damage_graying = 5; 
  }else if(graying=='A lot of white strands'){
    var Damage_graying = 10; 
  }
  
  var Sensitivity = parseInt(Sensitivity_scalp_type) + parseInt(Sensitivity_scalp_feel) + parseInt(Sensitivity_stress);
  var Damage = parseInt(Damage_scalp_visible) + parseInt(Damage_strands) + parseInt(Damage_graying) + parseInt(Damage_scalp_feel) + parseInt(Damage_Goal);
  
  var Sebum = parseInt(Sebum_scalp_type) + parseInt(Sebum_scalp_feel) + parseInt(Sebum_Goal);
  var Dryness = parseInt(Dryness_scalp_type) + parseInt(Dryness_Goal);
  
  
  $('.cname').html($('.cnamevalue').val());
  
  
  var htmlData = '';
  htmlData += '<div class="hair-health"><h2 class="gh-title">Sensitivity</h2>' + '<p class="gh-p">This determines how sensitive your scalp is. Your formulas are designed keeping a note of current sensitivity.</p>' + '<span class="triangle-svg" style="left:calc('+Sensitivity+'% + 4px);"></span>' + '<div class="spcingbd"><div class="spcingbd-inner Sensitivityclr" style="width:'+Sensitivity+'%"></div></div></div>';
  htmlData += '<div class="hair-health"><h2 class="gh-title">Damage</h2>' + '<p class="gh-p">This determines how damaged your strands could be. We’ll work on appropriate conditioning and nourishment.</p>' + '<span class="triangle-svg" style="left:calc('+Damage+'% + 4px)"></span>' + '<div class="spcingbd"><div class="spcingbd-inner Damageclr" style="width:'+Damage+'%"></div></div></div>';
  htmlData += '<div class="hair-health"><h2 class="gh-title">Sebum</h2>' + '<p class="gh-p">This is what makes hair oily. We’ll work to rebalance that.</p>' +  '<span class="triangle-svg" style="left:calc('+Sebum+'% + 4px);"></span>' +'<div class="spcingbd"><div class="spcingbd-inner Sebumclr" style="width:'+Sebum+'%"></div></div></div>';
  htmlData += '<div class="hair-health"><h2 class="gh-title">Dryness</h2>' + '<p class="gh-p">Your strands should be hydrated and moisturized in the right combo. We’ll work on balancing that</p>' +  '<span class="triangle-svg" style="left:calc('+Dryness+'% + 4px);"></span>' +'<div class="spcingbd"><div class="spcingbd-inner Drynessclr" style="width:'+Dryness+'%"></div></div></div>';
  htmlData += '<div class="selection-content reduc-padd"> <h3>Your Key Ingredients</h3> <p>Based on your analysis, these are some of the natural active ingredients we’ve selected to match your precise needs. These will be the star players in your haircare lineup.</p> </div>';
  htmlData += '<style>.spcingbd{float:left; width:100%;         margin: 0 10px 10px; height:4px;background:#ccc; }.spcingbd-inner{float:left;  height:5px;background:#780101;}</style>';
  return htmlData;
}


function checkProductAdd(){
   var check = 0;
 	if($( '.jsBtnAdd' ).hasClass('btn-added')){
      var check = 1;
    }
  
  return check;
}
window.prodids = [];

$(document).on('click','.jsBtnAdd',function(){

  if($(this).hasClass('body-quiz')){
    var $this = $(this);
    var $parent = $this.parents('.selection_prdct');
    var savedData = get_cookie('rh_wash_lotion');
    var properties = {};
    var data = {};
      data['id'] = $this.attr('data-id');
      data['quantity'] = 1;
  
    if(savedData != '') {
      json_object = JSON.parse(savedData);
      for (var prop in json_object) {
        if (Object.prototype.hasOwnProperty.call(json_object, prop)) {
          properties[prop] = [];
          properties[prop] = json_object[prop];
        }
      }
      data['properties'] = properties;
    }
    
  $(this).find('.txt-add').text('Adding..');
    
    $.ajax({
      url: '/cart/add.js',
      type: 'POST',
      dataType: 'json',
      data: data,
      success: function() {
      cart_drawer();
      },
      complete: function() {
        $parent.removeClass('not-allowed');
        $parent.addClass('_added');
        $this.find('.txt-add').text('Add to cart');
        $this.find(".txt-add-js").text("Added to Cart");
        // $this.addClass('jsBtnUpdate');
        $this.find('.add-remove').addClass('jsUpdate');
        $this.find('.txt-right').css('display','block');
        $this.find('.txt-add-js').addClass('txt-add-width');
        $this.parents('.sel-pr-row3').addClass('bg-change-js');
        $('.cart_drawer').addClass('drawer_is_open');
        $('html body').addClass("stop_page_scroll");
      }
    });
  }else if($(this).hasClass('skin-care')){
      var $this = $(this);
      var $parent = $this.parents('.selection_prdct');
      var savedData = get_cookie('ne_selection');
      var properties = {};
      var data = {};
        data['id'] = $this.attr('data-id');
        data['quantity'] = 1;
    
      if(savedData != '') {
        json_object = JSON.parse(savedData);
        for (var prop in json_object) {
          if (Object.prototype.hasOwnProperty.call(json_object, prop)) {
            properties[prop] = [];
            properties[prop] = json_object[prop];
          }
        }
        data['properties'] = properties;
      }
      
     $(this).find('.txt-add-js').text('Adding..');
    
      $.ajax({
        url: '/cart/add.js',
        type: 'POST',
        dataType: 'json',
        data: data,
        success: function() {
        cart_drawer();
        },
        complete: function() {
          $parent.removeClass('not-allowed');
          $parent.addClass('_added');
          $this.find('.txt-add').text('Add to cart');
          $this.find(".txt-add-js").text("Add to cart");
          // $this.addClass('jsBtnUpdate');
          $this.addClass('jsBtnSkin');
          $this.find('.add-remove').addClass('jsUpdate');
          $this.find('.txt-right').css('display','block');
          $this.find('.txt-add-js').addClass('txt-add-width');
          $this.parents('.sel-pr-row3').addClass('bg-change-js');
          $('.cart_drawer').addClass('drawer_is_open');
          $('html body').addClass("stop_page_scroll");
        }
      });
  }else{
    var $this = $(this);
    var $parent = $this.parents('.selection_prdct');
    var url = '/cart/add.js',properties = {},json_object;
    var data = {};
    data['id'] = $this.attr('data-id');
    data['quantity'] = 1;
    
    $parent.addClass('not-allowed');
    $this.find('.txt-add').text('Adding..');
    
    if(get_cookie(cookie_page_name) != '') {
      json_object = JSON.parse(get_cookie(cookie_page_name));
      for (var prop in json_object) {
        if (Object.prototype.hasOwnProperty.call(json_object, prop)) {
          properties[prop] = [];
          properties[prop] = json_object[prop];
        }
      }
      data['properties'] = properties;
    }
    
    /*if(!$parent.hasClass('_added')) { 
      url = '/cart/add.js';
      data['quantity'] = 1;
      if(get_cookie('rh_selection') != '') {
        json_object = JSON.parse(get_cookie('rh_selection'));
        for (var prop in json_object) {
          if (Object.prototype.hasOwnProperty.call(json_object, prop)) {
            properties[prop] = [];
            properties[prop] = json_object[prop];
          }
        }
      }
      data['properties'] = properties;
    }*/
    
    $.ajax({
      url: url,
      dataType: 'json',
      type: 'POST',
      data: data,
      success: function(){
        //$parent.toggleClass('_added');
        cart_drawer();
      },
      complete: function() {
        $parent.removeClass('not-allowed');
        $parent.addClass('_added');
        $this.find('.txt-add').text('Add to cart');
        $this.find(".txt-add-js").text("Added to Cart");
        // $this.addClass('jsBtnUpdate');
        $this.find('.add-remove').addClass('jsUpdate');
        $this.find('.txt-right').css('display','block');
        $this.find('.txt-add-js').addClass('txt-add-width');
        $this.parents('.sel-pr-row3').addClass('bg-change-js');
        $('.cart_drawer').addClass('drawer_is_open');
        $('html body').addClass("stop_page_scroll");

        // CD CODE
        if($('.product_tab_quiz').length){
          $this.parents('.selection-slide').addClass('slide_done');
          $this.parents('.selection-slide').find('.open_cart_drawer').prop('disabled', false);
        }
      }
    })
  }
});

/*$(document).on('click','.txt-add',function(){
  
  //$('.txt-added').css('display','none');
  //$('.txt-add').css('display','block');
  $(this).parent().parent().parent().parent('.jsSelectProduct').toggleClass('pro-selected').find('sel-pr-btn').removeClass('btn-added');
  $(this).parent().parent().parent().parent().parent('.selection-products').addClass('main-product-sele');
   $(this).parent().parent().parent().parent('.jsSelectProduct').siblings().find('.sel-pr-btn').removeClass('btn-added');
 $(this).parent().parent('.sel-pr-btn').toggleClass('btn-added');
  //$('.jsBtnAdd').removeClass('btn-added');
  
  //var check = checkProductAdd();
  //if(check=='1'){ 
    //alert('already added!'); return false; 
  //}else{
    var seladd = $(this).attr('data');
    
    $('.jsBtnAdd[data-id="'+seladd+'"]').addClass('btn-added');
    $('.txt-add[data="'+seladd+'"]').css('display','none');
    $('.txt-added[data="'+seladd+'"]').css('display','block');
  
    //$('.sel'+seladd).addClass('btn-added');
    //$('.add'+seladd).css('display','none');
    //$('.remove'+seladd).css('display','block');
    
    //$('.selected_ids').val(seladd);
    //getProIds();
  //}
  
  if (window.prodids.length == 0) {
      	
    	window.prodids.push(seladd);
  }else{
     
      var found = jQuery.inArray(seladd, window.prodids);
      if (found >= 0) {
      }else{


          window.prodids.push(seladd);

      }
  }
  getProIds();
  
});*/


$(document).on('click','.btn-nav',function(){
  $('.cname').html($('.cnamevalue').val());
});

/* $(document).on('click','.txt-added',function(){
  $(this).parent().parent().parent().parent('.jsSelectProduct').toggleClass('pro-selected');
  $(this).parent().parent('.sel-pr-btn').toggleClass('btn-added');
   $(this).parent('.jsBtnAdd').removeClass('btn-added');
}); 
$(document).on('click','.txt-remove',function(){
   //$('.txt-added').css('display','none');
	
  $(this).parent().parent('.sel-pr-btn').toggleClass('btn-added');
  //getProIds();
   
  //$('.txt-add').css('display','block');
    var seladd = $(this).attr('data');
  
  $('.txt-add[data="'+seladd+'"]').css('display','block');
  $('.txt-added[data="'+seladd+'"]').css('display','none');
  $('.jsBtnAdd[data-id="'+seladd+'"]').removeClass('btn-added');
  
  //$('.add'+seladd).css('display','block');
  //$('.remove'+seladd).css('display','none');
  //$('.sel'+seladd).removeClass('btn-added');
    //$('.selected_ids').val('');
  $(window.prodids).each(function( index1, value1 ) {
    if( value1 === seladd){
      var removeItem = seladd;

      window.prodids = jQuery.grep(window.prodids, function(value1) {
        return value1 != removeItem;
      });
    }
    
  });
  getProIds();
  
  
});
*/

function getProIds(){
  var dataf = '';
  $(window.prodids).each(function(index,value){
    dataf += value+'|'; 
  });  
  var totalLength = dataf.length;
  var finalVal = dataf.substr(0, parseInt(dataf.length) - 1);
  $('.selected_ids').val(finalVal);
 

}

//CD 
$('.btnQuiz').on('click',function(){
  var $quizbtn = $(this);
  var $box = $(this).parents('.quiz-wrap');
  var header_sticky = 0;
  $('.quiz-change').addClass('quiz-change-text');
  if($('.head-wrap.head-fixed').length) header_sticky = $('.head-wrap.head-fixed').outerHeight();
  if($box.hasClass('quiz-active')) {
    if(!$box.hasClass('quiz-added')) {
      var $remainStep = $box.find('.qz-step:not(.done)');
      if($remainStep.length) {
        $('html,body').animate({scrollTop: $remainStep.offset().top - header_sticky});
        if($remainStep.find('input[type="text"]').length) $remainStep.find('input[type="text"]').focus();
        return;
      }
    }
    $box.addClass('not-allowed');
    $quizbtn.find('.cap-add').text('Adding..');
    var props = {},value,$this,$tmp;
    $('.quiz-wrap .qz-step').each(function(){
      value = '';
      $this = $(this);
      if($(this).hasClass('finalStep')) {
        return;
      } else if($(this).find('.qz-body').hasClass('options')) {
        if($(this).find('.option.active').length) value = $(this).find('.option.active').text();
      } else if($(this).find('.qzName').length) {
        if($(this).find('.qzName').val().trim() != '') value = $(this).find('.qzName').val();
      } else if($(this).hasClass('color-step')) {
        $(this).find('.qzColor.checked').each(function(){
          $tmp = $this.find('.head[data-indx="'+$(this).parents('.qz-colors').attr('color-indx')+'"]');
          props[$tmp.text().trim()] = $(this).attr('data');
        });
      }
      if(value == '') return;
      props[$(this).find('.head').text()] = value;
    });
    $.ajax({
      url: '/cart/add.js',
      type: 'POST',
      dataType: 'json',
      data: {
        id: $quizbtn.attr('data-id'),
        quantity: 1,
        properties: props
      },
      success: function(){},
      complete: function(){
        $quizbtn.find('.cap-add').text('Choose this set');
        $box.removeClass('not-allowed');
        cart_drawer();
        // alert('Product has been successfully added!');
        $('.cart_drawer').addClass('drawer_is_open');
        $('html body').addClass("stop_page_scroll");
      }
    });
    //$box.toggleClass('quiz-added');
  } else {
    $box.addClass('quiz-active');
    $('html,body').animate({scrollTop: $('.qz-steps').offset().top - header_sticky});
    if($box.parents('.subQuiz').length) {
      $('.quizSteps').css('height',$('.quiz-step.active').outerHeight());
    }
  }
});

function moveToNext($obj) {
  var $parent = $obj.parents('.qz-step');
  var indx = $obj.parents('.qz-body').attr('data-indx');
  indx++;
  var $nextStep = $('.quiz-box .qz-step-'+indx);
  $parent.removeClass('active');
  var header_sticky = 0;
  if($('.head-wrap.head-fixed').length) header_sticky = $('.head-wrap.head-fixed').outerHeight();
  
  $parent.addClass('done');
  if($nextStep.length) {
    $nextStep.addClass('active').siblings('.qz-step').removeClass('active');
    $('html,body').animate({scrollTop: $nextStep.offset().top - header_sticky});
    if($nextStep.hasClass('finalStep')) $nextStep.addClass('done');
  }
}

$('.qzOpt').on('click',function(){
  $(this).addClass('active').siblings('.qzOpt').removeClass('active');
  moveToNext($(this));
});

$('.qzName').on('change',function(){
  if($(this).val().trim() != '') {
    moveToNext($(this));
  } else {
    $(this).parents('.qz-step').removeClass('done');
    if($(this).parents('.quiz-wrap').hasClass('quiz-added')) $(this).parents('.quiz-wrap').removeClass('quiz-added');
  }
});

$('.qzColor').on('click',function(){
  var $parent = $(this).parents('.color-step');
  $(this).addClass('checked');
  $(this).parents('.qz-color').siblings('.qz-color').find('.qzColor').removeClass('checked');
  $(this).parents('.qz-body').find('.color-img img[data="'+$(this).attr('data')+'"]').addClass('active').siblings('img').removeClass('active');
  if($parent.find('.qz-colors').length == $parent.find('.qzColor.checked').length) {
    moveToNext($(this));
    $('.final-image').addClass('img-seleted');
    $('.final-image .sec-img:first').attr('src',$parent.find('.qz-body:eq(0) .color-img img.active').attr('src'));
    $('.final-image .sec-img:last').attr('src',$parent.find('.qz-body:eq(1) .color-img img.active').attr('src')); 
  }
});

//CD
var timeId;

function saveData(label,value) {
  var storedData = {},str;
  if(get_cookie('rh_wash_lotion') != '') {
    storedData = JSON.parse(get_cookie('rh_wash_lotion'));
  }
  storedData[label] = value;
  str = JSON.stringify(storedData);
  set_cookie('rh_wash_lotion',str,1);
} 

function setData() {
  var savedData = get_cookie('rh_wash_lotion'),_key;
  var $act,$parent,$parentSlide;
  if(savedData != '') {
    savedData = JSON.parse(savedData);
    for(key in savedData) {
      $parentSlide = $('.selection-head[data="'+key+'"]').parents('.selection-slide');
      if($parentSlide.length) {
        _key = key.toLowerCase();
        if(_key == 'gender' || _key == 'skin moisture level' || _key == 'how strong body odour?' || _key == 'age' || _key == 'fragrance') {
          $act = $parentSlide.find('.jsOpt[data="'+savedData[key]+'"]');
          if($act.length) {
            $act.addClass('active');
            if($act.parents('.selection-group').length) {
              $parent = $act.parents('.selection-group');
              $parent.addClass('done');
              if($parentSlide.find('.selection-group').length == $parentSlide.find('.selection-group.done').length) {
                $parentSlide.addClass('done');
              }
            } else {
              $parentSlide.addClass('done');
            }
          }
        } else if(_key == 'anything else?' || _key == 'name') {
          $parent = $('.selection-head[data="'+key+'"]').parents('.selection-group');
          if($parent.length) {
            $parent.find('.inputField').val(savedData[key]);
            $parent.addClass('done');
            if($parentSlide.find('.selection-group').length == $parentSlide.find('.selection-group.done').length) {
              $parentSlide.addClass('done');
            }
          } else {
            $parentSlide.find('.inputField').val(savedData[key]);
            $parentSlide.addClass('done');
          }
        } else if(_key == 'body wash color' || _key == 'body lotion color') {
          if($parentSlide.find('.selection-group').length) {
            $parent = $('.selection-head[data="'+key+'"]').parents('.selection-group');
            $parent.find('.swatchLabel[data="'+savedData[key]+'"]').addClass('active');
            $parent.find('.selection-image img[data="'+savedData[key]+'"]').addClass('active').siblings('img').removeClass('active');
            $parent.addClass('done');
            if($parentSlide.find('.selection-group').length == $parentSlide.find('.selection-group.done').length) {
              $parentSlide.addClass('done');
              $('.final-image').addClass('img-seleted');
              $('.final-image .sec-img:first').attr('src',$parentSlide.find('.selection-group:eq(0) .selection-image img.active').attr('src'));
              $('.final-image .sec-img:last').attr('src',$parentSlide.find('.selection-group:eq(1) .selection-image img.active').attr('src')); 
            }
          } else {
            $parentSlide.find('.swatchLabel[data="'+savedData[key]+'"]').addClass('active');
            $parentSlide.addClass('done');
          }
        }

        // CD Sanket
          
         if(key == 'Goals'){
           var split_data = savedData[key].split('||');
           if(split_data.length >= 3){
             $('.check-goals').addClass('goals-disable');
           }
             $.each(split_data,function(i,value){
              var $act_goals = $parentSlide.find('.check-goals[value="'+value+'"]');
              $parent = $act_goals.parents('.selection-slide');
              if($act_goals.length) {
                $act_goals.addClass('active');
                $act_goals.removeClass('goals-disable');
                $parentSlide.addClass('done');
                $parent.find('.desc').removeClass('visibly-hidden');
                $parent.find('.desc .show_head').text($act_goals.find('.opt-label').text());
                $parent.find('.desc p').text($act_goals.attr('desc'));
              }
            })
         }
        
      }
    }
  }
}
// Body-care
function naviGatetoSlide(index) {
  var $activeSlide = $('.selection-slide[data-index="'+index+'"]');
  var totalSlides = parseInt($('.selection-slides').attr('data-total'));
  var header_sticky = 0;
  var percent;

  // CD Sanket
  if($activeSlide.hasClass('js_done')){
    $activeSlide.addClass('done');
  }
    
  $('#product-nav .menu-item-container[data-menu-id="nav_video_section"]').css('display','none');

  // if($activeSlide.hasClass('hight_unset')){
  //   $('.selection-inner').css('height','unset');
  // }else{
  //    $('.selection-inner').css('height',$activeSlide.height() + 'px');
  // }
  
 if($activeSlide.hasClass('add_header')){
    $('#product-nav').css('display','block');
    $('.add_header').parents('.page-width').addClass('top-margin-set');
    result_slider();
    $('.selection-inner').css('height','unset');
  }else{
     $('#product-nav').css('display','none');
     $('.add_header').parents('.page-width').removeClass('top-margin-set');
    $('.selection-inner').css('height',$activeSlide.height()+'px');
  }

  if($activeSlide.hasClass('fix-width')){
    $('.selection-slide').removeClass('padding-body-care');
  }else{
    $('.selection-slide').addClass('padding-body-care');
  }

  // if($activeSlide.find('.selection-desc .selection-field').val() == ''){
  //   $activeSlide.find('.selection-desc .selection-field').parents('.selection-desc').find('.error_show').removeClass('hide');
  // }else{
  //   $activeSlide.find('.selection-desc .selection-field').parents('.selection-desc').find('.error_show').addClass('hide');
  // }
  
  if(typeof timeId != 'undefined') clearTimeout(timeId);
  if($('.head-wrap.head-fixed').length) header_sticky = $('.head-wrap.head-fixed').outerHeight();
  timeId = setTimeout(function(){
    if($activeSlide.length) {
      $activeSlide.addClass('active').siblings('.selection-slide').removeClass('active');
      if($activeSlide.hasClass('done')) {
        $('.btnRight').removeClass('btn-disabled');
      } else {
        $('.btnRight').addClass('btn-disabled');
      }
      if($activeSlide.hasClass('padding-add-js')){
         $('.selection-slides').addClass('padding-change');
      } else {
        $('.selection-slides').removeClass('padding-change');
      }
      
      if($activeSlide.hasClass('last-slide')) {
        $('.btnInit').addClass('hide');
        $('.btnLeft').removeClass('hide');
        $('.btnRight').addClass('hide');
        $('.btnRight').addClass('last-slide-btn-show');
        $('.quiz-drawer-ask').addClass('hide');
      } else if(index > 1) {
        $('.btnInit').addClass('hide');
        $('.btnLeft').removeClass('hide');
        $('.btnRight').removeClass('hide');
        $('.quiz-drawer-ask').removeClass('hide');
        $('.btnRight').removeClass('last-slide-btn-show');
      } else {
        $('.btnInit').removeClass('hide');
        $('.btnLeft').addClass('hide');
        $('.btnRight').addClass('hide');
      }
      $('.selection-slides').attr('data-slide',index);
      percent = (index*100)/totalSlides;
      percent = Math.min(percent,100);
      $('.selection-wrap .progress').animate({width: percent+'%'});
      $('html,body').animate({scrollTop: $('.selection-wrap').offset().top - header_sticky});
    }
  },100);

 var color_image_url = $('.js_image_change_metas.active-choice').attr('img-color');

  if(color_image_url != ''){
    $('.js_product_img_adds').attr('img-color',color_image_url);
  }else{
     $('.js_product_img_adds').attr('img-color','');
  }

 
   $('.js_product_img_adds').each(function() {
    var product_img_add = $(this).attr('img-color');
    var default_img_url = $(this).attr('default-url');
    var product_img_url = $(this).attr(product_img_add);
    if(product_img_url != ''){
      $(this).attr('src',product_img_url);
    }else{
      $(this).attr('src',default_img_url);
    }
  })
}

$('.btnInit').on('click',function(){
  var index = parseInt($('.selection-slides').attr('data-slide'));
  index++;
  naviGatetoSlide(index);
});

$('.jsOpt').on('click',function(){
  
  var index = parseInt($('.selection-slides').attr('data-slide'));
  var $parentSlide = $(this).parents('.selection-slide');
  var $parent = $(this).parents('.selection-group');
  
  $(this).addClass('active').siblings('.jsOpt').removeClass('active');

  if($parent.length) {
    $parent.addClass('done');
    if($parentSlide.find('.selection-group').length == $parentSlide.find('.selection-group.done').length) {
      $(this).parents('.selection-slide').addClass('done');	
      index++;
      naviGatetoSlide(index);
    }
    saveData($parent.find('.selection-head').attr('data'),$(this).attr('data'));
  } else {
    $parentSlide.addClass('done');	
    index++;
    naviGatetoSlide(index);
    saveData($parentSlide.find('.selection-head').attr('data'),$(this).attr('data'));
  }
});

$('.btnLeft').on('click', function(){
  var index = parseInt($('.selection-slides').attr('data-slide'));
  index--;
  naviGatetoSlide(index);
});

$('.btnRight').on('click', function(){
  var index = parseInt($('.selection-slides').attr('data-slide'));
  index++;
  naviGatetoSlide(index);
});

$('.inputField').on('keyup', function(){
  var val = $(this).val().trim();
  var $parentSlide = $(this).parents('.selection-slide');
  var $parent = $(this).parents('.selection-group');
  if($parent.length) {
    if(val != '') {
      $parent.addClass('done');
      if($parentSlide.find('.selection-group').length == $parentSlide.find('.selection-group.done').length) {
        $(this).parents('.selection-slide').addClass('done');	
        $('.btnRight').removeClass('btn-disabled');
      } else {
        $(this).parents('.selection-slide').removeClass('done');	
        $('.btnRight').addClass('btn-disabled');
      }
      saveData($parent.find('.selection-head').attr('data'),val);
    } else {
      $parent.removeClass('done');
      $(this).parents('.selection-slide').removeClass('done');	
      $('.btnRight').addClass('btn-disabled');
    }
  } else {
    if(val != '') {
      $parentSlide.addClass('done');	
      $('.btnRight').removeClass('btn-disabled');
      saveData($parentSlide.find('.selection-head').attr('data'),val);
    } else {
      $parentSlide.removeClass('done');	
      $('.btnRight').addClass('btn-disabled');
    }
  }

  // CD Sanket
  if($parentSlide.hasClass('js_done')){
    $parentSlide.addClass('done');
    $('.btnRight').removeClass('btn-disabled');
  }
});

$('.swatchLabel').on('click',function(){
  var $parentSlide = $(this).parents('.selection-slide');
  var $parent = $(this).parents('.selection-group');
  var index = parseInt($('.selection-slides').attr('data-slide'));
  $(this).addClass('active');
  $(this).parents('.selection-swatch').siblings('.selection-swatch').find('.swatchLabel').removeClass('active');
  $parent.addClass('done');
  $parent.find('.selection-image img[data="'+$(this).attr('data')+'"]').addClass('active').siblings('img').removeClass('active');
  saveData($parent.find('.selection-head').attr('data'),$(this).attr('data'));
  if($parentSlide.find('.selection-group').length == $parentSlide.find('.selection-group.done').length) {
    $parentSlide.addClass('done');
    $('.btnRight').removeClass('btn-disabled');
    $('.final-image').addClass('img-seleted');
    $('.final-image .sec-img:first').attr('src',$parentSlide.find('.selection-group:eq(0) .selection-image img.active').attr('src'));
    $('.final-image .sec-img:last').attr('src',$parentSlide.find('.selection-group:eq(1) .selection-image img.active').attr('src'));
    /*index++;
    naviGatetoSlide(index);*/
  } 
});


$('.btnItemAdd').on('click',function(){
  var $this = $(this);
  var savedData = get_cookie('rh_wash_lotion');
  var properties = {};
  if(savedData != '') {
    savedData = JSON.parse(savedData);
    for(key in savedData) {
      properties[key] = savedData[key];
    }
  }
  $this.addClass('adding');
  $.ajax({
    url: '/cart/add.js',
    type: 'POST',
    dataType: 'json',
    data: {
      id: $this.attr('data'),
      quantity: 1,
      properties: properties
    },
    success: function() {
      location.href = '/cart';
    },
    complete: function() {
      $this.removeClass('adding');
    }
  });
});

$(window).on('resize',function(){
  if($('.head-fixed').length) {
    $('.head-back').css('height',$('.head-wrap').outerHeight());
  }
});

$(document).ready(function(){
  if($('.selection-wrap').length) {
    setData();
  }
  
  if($('.head-fixed').length) {
    $('.head-back').css('height',$('.head-wrap').outerHeight());
  }
  
  $('.color-box').on('click',function(){
    $('.template-page.Makeorder .selected-color-img img').removeClass('active');
    $('.selected-color-img img[data="'+$(this).attr('data')+'"]').addClass('active').siblings('img').removeClass('active');
  });
});

// cd jaydip
$(document).ready(function(){
   /*var swipwr_slider = new Swiper('.swiper_slider_content .container', {
    loop: true,
//     freeMode: true,
    spaceBetween: 0,
    grabCursor: true,
    slidesPerView: 3,
    loop: true,
    autoplay: {
      delay: 1,
      disableOnInteraction: true
    },
    freeMode: true,
    speed: 5000,
    freeModeMomentum: false
  });
  $(".swiper_slider_content .container").mouseenter(function(){
    swipwr_slider.autoplay.stop();
  });
  $(".swiper_slider_content .container").mouseleave(function(){
    swipwr_slider.autoplay.start();
  });*/
});


var TxtRotate = function(el, toRotate, period) {
  this.init = false; //CD
  this.toRotate = toRotate;
  this.el = el;
  this.loopNum = 0;
  this.period = parseInt(period, 10) || 2000;
  this.txt = '';
  this.tick();
  this.isDeleting = false;
};

TxtRotate.prototype.tick = function() {
  var i = this.loopNum % this.toRotate.length;
  var fullTxt = this.toRotate[i];
  if(this.init == false) { //CD
    var _this = this;
    this.el.innerHTML = '<span class="wrap">'+fullTxt+'</span>';
    this.init = true;
    this.txt = fullTxt;
    this.isDeleting = true;
    setTimeout(function(){
      _this.tick();
    },500);
  } else {
    if (this.isDeleting) {
      this.txt = fullTxt.substring(0, this.txt.length - 1);
    } else {
      this.txt = fullTxt.substring(0, this.txt.length + 1);
    }

    this.el.innerHTML = '<span class="wrap">'+this.txt+'</span>';

    var that = this;
    var delta = 300 - Math.random() * 100;

    if (this.isDeleting) { delta /= 2; }

    if (!this.isDeleting && this.txt === fullTxt) {
      delta = this.period;
      this.isDeleting = true;
    } else if (this.isDeleting && this.txt === '') {
      this.isDeleting = false;
      this.loopNum++;
      delta = 500;
    }

    setTimeout(function() {
      that.tick();
    }, delta);
  }
};


window.onload = function() {
  var elements = document.getElementsByClassName('txt-rotate');
  for (var i=0; i<elements.length; i++) {
    var toRotate = elements[i].getAttribute('data-rotate');
    var period = elements[i].getAttribute('data-period');
    if (toRotate) {
      new TxtRotate(elements[i], JSON.parse(toRotate), period);
    }
  }
  // INJECT CSS
  var css = document.createElement("style");
  css.type = "text/css";
  css.innerHTML = ".txt-rotate > .wrap { border-right: 0.08em solid #000 }";
  document.body.appendChild(css);

};

$('.var_opt').on('click',function(){
  var $parent = $(this).parents('.var_picker');
  var $product = $(this).parents('.jsSelectProduct');
  $(this).addClass('active').siblings('.var_opt').removeClass('active');
  $parent.find('.var_name').text($(this).find('.var-title').text());
  $parent.removeClass('active');
  $product.find('._data_id').attr('data-id',$(this).attr('data'));
  $product.find('._data').attr('data',$(this).attr('data'));
  $product.find('.prod_price').html(theme.Currency.formatMoney(parseInt($(this).find('[data-price]').attr('data-price')),theme.moneyFormat).replace('.00', '') + '/-');
  
  // CD Sanket
  $product.find('.prod_price').text($product.find('.prod_price').text().replace('Rs.', ''));
  
  if($(this).find('[data-compare-price]').length) {
    $product.find('.prod_c_price').html(theme.Currency.formatMoney(parseInt($(this).find('[data-compare-price]').attr('data-compare-price')),theme.moneyFormat).replace('.00', '') + '/-').removeClass('hide');
     $product.find('.prod_c_price').text($product.find('.prod_price').text().replace('Rs.', ''));
    $product.find('.prod_save_percent .money_sale_percent').html('Save '+parseFloat(($(this).find('[data-compare-price]').attr('data-compare-price')-$(this).find('[data-price]').attr('data-price'))/100).toFixed()+'/-');
    $product.find('.prod_save_percent').removeClass('hide');
  } else {
    $product.find('.prod_c_price').addClass('hide');
    $product.find('.prod_save_percent').addClass('hide');
  }
});

$('.var_toggle').on('click',function(){
  $(this).parents('.var_picker').toggleClass('active');
});

$('.btn_close_var').on('click',function(){
  $(this).parents('.var_picker').removeClass('active');
});



$(window).scroll(function() {    
    var scroll = $(window).scrollTop();
    if (scroll >= 300) {
      $(".only_mobile_show").addClass("darkHeader");
    }else{
      $(".only_mobile_show").removeClass("darkHeader");
    }
});




// CD Sanket
var timeId;
var root = document.querySelector(':root');

function setCookie(cname, cvalue, exdays) {
  const d = new Date();
  d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
  let expires = "expires="+d.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

function getCookie(cname) {
  let name = cname + "=";
  let ca = document.cookie.split(';');
  for(let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}

function setupData() {
  var cookie_data,$current,values,indx,$tmp;
  if(getCookie('ne_selection') != '') {
    cookie_data = JSON.parse(decodeURIComponent(getCookie('ne_selection')));
    for (var key in cookie_data) {
      $current = $('.quiz-step[key="'+key+'"]');
      if($current.hasClass('_choiceStep')) {
        values = cookie_data[key].split(',');
        values.forEach(function(value){
          $current.find('.optChoice[value="'+value+'"]').addClass('active');
         
          if($current.hasClass('goalStep') && !$current.hasClass('_goalStep2')) {
            indx = $current.find('.optChoice[value="'+value+'"]').attr('data-index');
            $tmp = $('._goalStep2').find('.optGoal[data-index="'+indx+'"]');
            $tmp.addClass('opt-selected').removeClass('opt-disabled active');
          }
        });
        
        if($current.hasClass('goalStep')) {
          $current.find('.desc').removeClass('visibly-hidden');
          $current.find('.desc .slctedOpt').text($current.find('.optChoice.active').attr('value'));
          $current.find('.desc p').text($current.find('.optChoice.active').attr('desc'));
        }
        
        if($current.hasClass('_goalStep2')) {
          if($current.find('.optChoice.active').length >= 4) {
            $current.find('.optChoice:not(.active):not(.opt-selected)').addClass('opt-disabled');
          }
          
//           if($('.optGoal.active').length) {
//             get_products(action = 'goal');
//           }
        }
        
        if($current.find('._show_desc').length) {
          $current.find('.desc').removeClass('visibly-hidden');
          $current.find('.desc .slctedOpt').text($current.find('._show_desc.active').attr('value'));
          $current.find('.desc p').text($current.find('._show_desc.active').attr('desc'));
        }
        
        if($current.hasClass('_eyeQue')) {
//           if($('._eyeOpt.active').length) {
//             get_products();
//           }
        }
      } else {
        $current.find('.inputVal').val(cookie_data[key]);
        if(cookie_data[key] != '') $current.find('.btnSubmit').removeClass('btn-disabled');
        if($current.find('.inputVal').hasClass('inputUserName')) $('.userName').text(cookie_data[key]);
      }
      $current.addClass('inputFilled');
      $('._summary_val[data-key="'+key+'"]').text(cookie_data[key]);
    }
  }
}

function storeData($active) {
  var store_data = {},selected = [],cookie_data,_val = '';
  if($active.hasClass('_choiceStep')) {
    
    $active.find('.optChoice.active').each(function(){
      // CD Sanket
      if($(this).parents('.quiz-step').hasClass('yes_no_val') && $(this).attr('value') == "Yes"){
        var text_box = $(this).parents('.quiz-step').find('.text_box').val();
        selected.push($(this).attr('value') + '-' +text_box);
        console.log(text_box, selected);
      }else{
        selected.push($(this).attr('value'));
      }
    });

    if($active.hasClass('formula_section')){
      selected.push($active.find('.input_formula').val());
    }
    
    if(selected.length) {
      store_data[$active.attr('key')] = selected.join(',');
      _val = selected.join(',');
    }
  } else {
    store_data[$active.attr('key')] = $active.find('.inputVal').val();
    _val = $active.find('.inputVal').val();
  }
  
  if(getCookie('ne_selection') != '') {
    cookie_data = JSON.parse(decodeURIComponent(getCookie('ne_selection')));
    if(_val != '') cookie_data[$active.attr('key')] = _val;
    setCookie('ne_selection',encodeURIComponent(JSON.stringify(cookie_data)),365);
  } else {
    setCookie('ne_selection',encodeURIComponent(JSON.stringify(store_data)),365);
  }
}

// Skin-care quiz

function goToSlide(slide_no) {
  var $new = $('.quiz-step[data="'+slide_no+'"]');
  if(!$new.length) return;
  var totalSlide = parseInt($('.quizPage').attr('total-slides'));
  $('.quizPage').attr('data',slide_no);
  $('.quizSteps').addClass('ease-animate');
  root.style.setProperty('--gift-index', slide_no-1);
  setTimeout(function(){
    $('.quizSteps').removeClass('ease-animate');
  },500);
  $('.quiz-step').removeClass('active');
  $new.addClass('active');
  var $footer_height = $('.container-fluid .quiz-footer').height();
  var $quiz_drawer_ask = $('.quiz-step[data="'+slide_no+'"] .quiz-drawer-ask').height();

  // var quiz_height = $footer_height + $quiz_drawer_ask;
  var quiz_height = $footer_height;

 
  if($new.hasClass('slide-auto')) {
    $('.quizPage').addClass('flashing');
    if(typeof timeId != 'undefined') clearTimeout(timeId);
    timeId = setTimeout(function(){
      goToSlide($new.next('.quiz-step').attr('data'));
    },3000);
  } else {
    $('.quizPage').removeClass('flashing');
  }
  if($new.hasClass('inputFilled')) {
    $('.btnNextButton').removeClass('btn-disabled');
  } else {
    $('.btnNextButton').addClass('btn-disabled');
  }
  if(typeof $new.attr('index') != 'undefined') {
    $('.currentPage').text($new.attr('index'));
    location.hash = 'giftSlide-'+$new.attr('index');
    
    if(parseInt($new.attr('index')) >= totalSlide) {
      $('.btnNextButton').addClass('btn-disabled');
      $('.quiz-drawer-ask').addClass('hide-elem');
      $('.toggleBag').removeClass('hide-elem');
    } else {
       $('.quiz-drawer-ask').removeClass('hide-elem');
      $('.toggleBag').addClass('hide-elem');
    }
  } else {
    $('.btnNextButton').removeClass('hide-elem');
    $('.toggleBag').addClass('hide-elem');
  }
  $('html,body').animate({scrollTop: 0}); 
  
  if($('.quiz-pages')){
    var currentpage = parseInt($new.attr('index'));
    var totalPages = parseInt($(".quiz-pages .totalPages").text());
    var bg_width = (currentpage*100)/totalPages;
    if(!$('.quiz-step[data="1"]').hasClass('active')){
      if($('.quiz-step[data="2"]').hasClass('active') && $(window).width()  < 768){
        $('.quiz-pages').css('width',(bg_width + 3) + '%');
      }else{
        $('.quiz-pages').css('width',bg_width + '%');
      }
    }else{
       $('.quiz-pages').css('width', '13%');
    }
  }
  if($('.quiz-step.active.btn_unable').length){
     $('.btnNextButton').removeClass('btn-disabled');
  }

   if($('.quiz-step.active.add_header').length){
      $('#product-nav').css('display','block');
       result_slider();
    }else{
       $('#product-nav').css('display','none');
    }
  
  if($('.quiz-step').length) root.style.setProperty('--gift-slide', '-'+$('.quiz-content').width()+'px');

  if($('.quiz-step.active').hasClass('fix-width')){
    $('.quiz-wrap .quiz-step').css('padding', '0');
    $('.quiz-wrap').css('margin', '0');
  }else{
    $('.quiz-wrap .quiz-step').css('padding', '10px 16px');
    $('.quiz-wrap').css('margin', '0');
  }

  if($('.quiz-step[data="'+slide_no+'"] .optRad.active').hasClass('novalue')){
    $('.quiz-step[data="'+slide_no+'"] .provide_details').css("display", "none");
  }
  if($('.quiz-step[data="'+slide_no+'"] .optRad.active').hasClass('yesvalue')){
    $('.quiz-step[data="'+slide_no+'"] .provide_details').css("display", "block");
  }

  // var first_val = $('.first-name-value').val();
  //  if(first_val != ''){
  //    $('.add-name').text(first_val + ' PRODUCTS INCLUDE:');
  //  }
  
  var first_val = $('.kalviyo_name_input').attr('name');
   if(first_val != ''){
     $('.add-name').text(first_val + ' PRODUCTS INCLUDE:');
   }

   // selected goals next slide.
  if(!$('.quiz-step[data="'+slide_no+'"]').hasClass('data_change')){
    var goals_slide = $('.quiz-body .optGoals .optRad');
    if($('.optGoals_value').hasClass('active')){
      var goals_slide_html ='';
      $.each(goals_slide,function(i, field){
        if($(this).hasClass('active')){
          goals_slide_html += `<div class="opt optRad toNextOpt optChoice" data-index="${i + 1}" value="${$(this).attr('value')}">
                                 <div class="opt-icon">
                                  <span class="icon-plus"><img src="https://cdn.shopify.com/s/files/1/0599/7844/9071/files/plus.png?v=1632825262"></span>
                                  <span class="icon-check"><img src="https://cdn.shopify.com/s/files/1/0599/7844/9071/files/tick.png?v=1632824026"></span>
                                </div>
                                <div class="opt-text">${$(this).attr('value')}</div>
                              </div>`;
        }
      });
      $('.optGoals_value_body').html(goals_slide_html);
    }
  }
  $('.quiz-step[data="'+slide_no+'"]').removeClass('data_change');

  
  if($('.quiz-step[data="'+slide_no+'"] .quiz-b-input .input_formula').val() == ''){
     $('.btnNextButton').addClass('new-btn-disabled');
  }else{
     $('.btnNextButton').removeClass('new-btn-disabled');
  }

    
  $('.quiz-content').css('padding-bottom',quiz_height + 'px');
   $('.quiz-drawer-ask').attr('bottomoffset',$footer_height);
  $('.quiz-drawer-ask').css('bottom',$footer_height + 'px');
   var $quiz_17 = $('.quiz-step.hight_unset.active');
  if($quiz_17.hasClass('active')){
     $('.quizSteps').css('height','unset');
    $('.quiz-pages').css('display','none');
  }else{
   $('.quizSteps').css('height',$new.outerHeight()+'px');
   $('.quiz-pages').css('display','block');
  }

  if($('.quiz-step[data="'+ (slide_no - 1) +'"]').hasClass('auto_form_submit')){
    if($('.auto_form_submit form [type="submit"]').length){
      $('.auto_form_submit form [type="submit"]').click();
    }
  }

 var name_cal = $('.custom_klaviyoFrom [autocomplete="given-name"]').val();
  if(name_cal != undefined && name_cal != ''){
    $('.kalviyo_name_input').attr('name', name_cal);
  }
  if($new.hasClass('next_btn_show') && name_cal == undefined){
     $('.btnNextButton').removeClass('btn-disabled');
  }
  
}

// $('.quiz-step .text_box').on('keyup',function(){
//  var current_seletion = {},cookie_data = get_cookie('ne_selection'),ne_selection = {},value = '',$parent;
//   $parent = $this.parents('.quiz-step')
//   if(cookie_data != '') {
//       cookie_data = JSON.parse(cookie_data);
//       if(typeof cookie_data[$parent.attr('data-label')] !== 'undefined') {
//         cookie_data[$parent.attr('data-label')] = value;
//         ne_selection = cookie_data;
//       } else {
//         current_seletion[$parent.attr('data-label')] = value;
//         ne_selection = Object.assign(cookie_data,current_seletion);
//       }
//     } else {
//       ne_selection[$parent.attr('data-label')] = value;
//     }
//     ne_selection = JSON.stringify(ne_selection);
//     set_cookie('ne_selection',ne_selection,1);
// });

$('.quiz-b-input .input_formula').on('keyup',function(){
   if($(this).val() == ''){
     $(this).parents('.quiz-b-input').find('.formula_box_error').removeClass('hide');
    $('.btnNextButton').addClass('new-btn-disabled');
  }else{
      $(this).parents('.quiz-b-input').find('.formula_box_error').addClass('hide');
     $('.btnNextButton').removeClass('new-btn-disabled');
  }
});


$(document).on('keyup', '.quiz-body [name="firstName"]',function(){

  var emailReg = /^([\w-\.]+@([\w-]+\.)+[\w-]{2,4})?$/;
  var emailaddressVal = $('.quiz-body [name="emailField"]').val();
  
  if($(this).val() == ''){
     $(this).parents('.quiz-b-input').find('.formula_box_error').removeClass('hide');
    $('.btnNextButton').addClass('btn-disabled');
  }else if($('.quiz-body [name="emailField"]').val() == ''){
      $(this).parents('.quiz-body').find('.email_box_error').removeClass('hide');
     $('.btnNextButton').addClass('btn-disabled');
  }else if(!emailReg.test(emailaddressVal)) {
       $(this).parents('.quiz-body').find('.email_box_error').removeClass('hide');
     $('.btnNextButton').addClass('btn-disabled');
  }else{
      $(this).parents('.quiz-body').find('.email_box_error').addClass('hide');
     $('.btnNextButton').removeClass('btn-disabled');
  }
});

$(document).on('keyup', '.quiz-body [name="emailField"]', function(){
  var emailReg = /^([\w-\.]+@([\w-]+\.)+[\w-]{2,4})?$/;
  var emailaddressVal = $('.quiz-body [name="emailField"]').val();
  
  if($(this).val() == ''){
     $(this).parents('.quiz-b-input').find('.formula_box_error').removeClass('hide');
    $('.btnNextButton').addClass('btn-disabled');
  }else if($('.quiz-body [name="emailField"]').val() == ''){
      $(this).parents('.quiz-body').find('.email_box_error').removeClass('hide');
     $('.btnNextButton').addClass('btn-disabled');
  }else if(!emailReg.test(emailaddressVal)) {
       $(this).parents('.quiz-body').find('.email_box_error').removeClass('hide');
     $('.btnNextButton').addClass('btn-disabled');
  }else{
      $(this).parents('.quiz-body').find('.email_box_error').addClass('hide');
     $('.btnNextButton').removeClass('btn-disabled');
  }
});

$('.quiz-body .js_input_error').on('keyup',function(){
  var emailReg = /^([\w-\.]+@([\w-]+\.)+[\w-]{2,4})?$/;
  var emailaddressVal = $(".email-name-value").val();
  
   if($('.first-name-value').val() == ''){
     $(this).parents('.quiz-body').find('.email_box_error').removeClass('hide');
     $('.btnNextButton').addClass('new-btn-disabled');
  }else if($('.email-name-value').val() == ''){
      $(this).parents('.quiz-body').find('.email_box_error').removeClass('hide');
     $('.btnNextButton').addClass('new-btn-disabled');
  }else if(!emailReg.test(emailaddressVal)) {
       $(this).parents('.quiz-body').find('.email_box_error').removeClass('hide');
     $('.btnNextButton').addClass('new-btn-disabled');
  }else{
      $(this).parents('.quiz-body').find('.email_box_error').addClass('hide');
     $('.btnNextButton').removeClass('new-btn-disabled');
  }
});

$('.provide_details .text_box').on('keyup',function(){
   if($(this).val() == ''){
     $(this).parents('.provide_details').find('.text_box_error').removeClass('hide');
     $('.btnNextButton').addClass('new-btn-disabled');
  }else{
      $(this).parents('.provide_details').find('.text_box_error').addClass('hide');
     $('.btnNextButton').removeClass('new-btn-disabled');
  }
});

function setIngrdnts(goals) {
  let ingrdnts_html = '',ing_name, ingrdnts_arr = [];
  $('.incl_ingredients').empty();
  if(goals.length == 0)  return;
  $.getJSON("https://cdn.shopify.com/s/files/1/0554/6108/5286/files/Ingredients_CD__updated.json?v=1672229305", function(result){
    $.each(result,function(index,data){
      if(goals.indexOf(data['Goals']) >= 0) {
        for(let i=1;i<=3;i++) {
          ing_name = 'Ingredient '+i;
          if(typeof data[ing_name] != 'undefined') {
            if(data[ing_name]['title'] != '' && ingrdnts_arr.indexOf(data[ing_name]['title']) == -1) {
              ingrdnts_html += `<div class="p_box">
                ${typeof data[ing_name]['image'] == 'undefined' || data[ing_name]['image'] == '' 
                  ? ``
                  : `<div class="p_img">
                      <img src="${data[ing_name]['image']}">
                    </div>`
                }
                <div class='p_label_content'>
                  <h2 class="p_label f-weight">${data[ing_name]['title']}</h2>
                  <div class="p_content">
                      <h5>CONDITIONING AGENT</h5>
                      <p>${data[ing_name]['desc']}</p>
                </div>
                </div>
              </div>`;
              ingrdnts_arr.push(data[ing_name]['title']);
            }
          }
        }
      }
    });
    $('.incl_ingredients').html(ingrdnts_html);

    if($('.ingrdnts_slide').hasClass('active')) {
      goToSlide($('.ingrdnts_slide').attr('data'));
    }
  });
}

  $(document).on('click', '#product-nav .menu-item-container', function(){
      if($('#product-nav').length){
        var id = $(this).attr('data-menu-id');
        if($('.menu-item-container').length){

          // cd code (review load)
          if(id == 'nav_reviews_section' && $('.menu-items-container.active.no_review_loaded').length){
            $(this).removeClass('no_review_loaded');
            $('.jdgm-all-reviews__footer .jdgm-all-reviews-page__load-more').click();
          }
          
           $('.menu-item-container.active').removeClass('active');
          $('.menu-item-container[data-menu-id='+ id +']').addClass('active');
        }
        var header_height = $('#shopify-section-header .head-wrap').height();
        var product_nav =  $('#product-nav').height();
        var current_section = $('#'+ id).offset().top - (header_height + product_nav);
        $('html, body').animate({ scrollTop: current_section }, "slow");
      }
    });

//slider
function result_slider(){
  $('.js_section_image_slide').slick('refresh');
}

   if($('.js_section_image_slide').length){
      $('.js_section_image_slide').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: false, 
        prevArrow: ".pro_image-with_text2 .prev_arrow",
        nextArrow: ".pro_image-with_text2 .next_arrow",
        dots: true,
        responsive: [
          {
            breakpoint: 749,
            settings: {
              arrows: false
            }
          }
        ]
      }) 
    }




$(function(){
  
  if($(".product_section_name").length){
        var menuItems = $(".product_section_name"),
            scrollItems = menuItems.map(function(){
              var item = $(this);
              if (item.length) { return item; }
            });
    
        $(window).scroll(function(){
          var fromTop = $(this).scrollTop() + ($(window).height() / 2) ;
          var cur = scrollItems.map(function(){
            if ($(this).offset().top < fromTop)
              return this;
          });
          cur = cur[cur.length-1];
          var id = cur && cur.length ? cur[0].id : "";

          if(cur != undefined){
            var current_element = cur[0].id;
            var $active = $(".menu-item-container[data-menu-id='"+current_element+"']");
            var $menuContainer = $('.menu-items-container'),scroll_pos;
            if($active.length){

              // cd code (review load)
              if($active == 'nav_reviews_section' && $('.menu-items-container.active.no_review_loaded').length){
                $menuContainer.removeClass('no_review_loaded');
                $('.jdgm-all-reviews__footer .jdgm-all-reviews-page__load-more').click();
              }
              
              $active.addClass('active').siblings('.menu-item-container').removeClass('active');
              
              scroll_pos = $active.offset().left + $active.outerWidth(true)/2 + $menuContainer.scrollLeft() - $menuContainer.width()/2;
              $menuContainer.scrollLeft(scroll_pos);
              $('.menu-items-line').css({"left": parseInt(parseInt($active.offset().left-$menuContainer.offset().left)+$menuContainer.scrollLeft()) + 'px', "width": $active.width() + 'px'});
           }else{
              if($('.template_new-product').length || $('.custom_new_products').length){
                scroll_pos = $('.menu-items-container .menu-item-container.active').offset().left + $('.menu-items-container .menu-item-container.active').outerWidth(true)/2 + $menuContainer.scrollLeft() - $menuContainer.width()/2;
                $menuContainer.scrollLeft(scroll_pos);
                $('.menu-items-line').css({"left": parseInt(parseInt($('.menu-items-container .menu-item-container.active').offset().left-$menuContainer.offset().left)+$menuContainer.scrollLeft()) + 'px', "width": $('.menu-items-container .menu-item-container.active').width() + 'px'});
              }
           }
          }                 
        });
      }
  
  
  var $active_init = $('.quiz-step.active.slide-auto'),slide_index,$sel_slide;
  
  if($('.quiz-step').length) {
    let goal_arr = [];
    $.getJSON("https://cdn.shopify.com/s/files/1/0554/6108/5286/files/Ingredients_CD__updated.json?v=1672229305", function(result){
      let goal_html='', in_val;
      $.each(result, function(i, field){
        //CD CODE add condition only
        if(field['Ingredient 1'] != undefined && field['Ingredient 2'] != undefined && field['Ingredient 3'] != undefined){
          in_val = (field['Ingredient 1']['title'] !=''? field['Ingredient 1']['title']:"")+(field['Ingredient 2']['title'] !=''?"+" +field['Ingredient 2']['title']:"")+(field['Ingredient 3']['title'] !=''?"+" +field['Ingredient 3']['title']:"")
        }else if(field['Ingredient 1'] != undefined && field['Ingredient 2'] != undefined){
          in_val = (field['Ingredient 1']['title'] !=''? field['Ingredient 1']['title']:"")+(field['Ingredient 2']['title'] !=''?"+" +field['Ingredient 2']['title']:"")
        }else if(field['Ingredient 1']['title'] != undefined){
          in_val = (field['Ingredient 1'] !=''? field['Ingredient 1']:"")
        }
        goal_html += `<div class="opt optRad optChk optChoice optG" data-index="${i + 1}" value="${field['Goals'].trim()}" desc="${field['Maincontent']}" key="${in_val}" >
                <div class="opt-icon">
                  <span class="icon-plus"><img src="https://cdn.shopify.com/s/files/1/0599/7844/9071/files/plus.png?v=1632825262"></span>
                  <span class="icon-check"><img src="https://cdn.shopify.com/s/files/1/0599/7844/9071/files/tick.png?v=1632824026"></span>
                </div>
                <div class="opt-text">${field['Goals'].trim()}</div>
              </div>`;
      });
      
      $('.optGoals').html(goal_html);
 
      setupData();  

      if(location.hash.indexOf('giftSlide') >= 0) {
        $('.quizPage').addClass('initializing');
        slide_index = location.hash.split('-')[1];
        $sel_slide = $('.quiz-step[index="'+slide_index+'"]');
        if(!$sel_slide.length) return;
        goToSlide($sel_slide.attr('data'));
        setTimeout(function(){
          $('.quizPage').addClass('init');
        },601);
      } else {
        if($active_init.length) {
          $('.quizPage').addClass('init');
          $('.quizPage').addClass('flashing');
          if(typeof timeId != 'undefined') clearTimeout(timeId);
          $('.quizPage').addClass('init');
          timeId = setTimeout(function(){
            goToSlide($active_init.next('.quiz-step').attr('data'));
          },3000);
        }
      }

      root.style.setProperty('--gift-slide', '-'+$('.quiz-content').width()+'px');

      $('.optGoals .optG.active').each(function(){
        goal_arr.push($(this).attr('value'));
      });
      
      setIngrdnts(goal_arr);
    });
  }
  
  $('.btnNextButton').on('click',function(){
    var $active = $('.quiz-step.active');

    // cd code (trigger klaviyo submit)
    if($active.hasClass('custom_klaviyoFrom') && $('.quiz-body .klaviyo-form button').length){
      $('.quiz-body .klaviyo-form button').click();
    }
    
    goToSlide($active.next('.quiz-step').attr('data'));
    storeData($active);
  });

    $('.js_skip_btn').on('click',function(){
    var $active = $('.quiz-step.active');
    goToSlide($active.next('.quiz-step').attr('data'));
    storeData($active);
  });
  
  $(document).on('keyup', '.inputField', function(){

     if($(this).val() == ''){
         $(this).parents('.selection-desc').find('.error_show').removeClass('hide');
      }else{
          $(this).parents('.selection-desc').find('.error_show').addClass('hide');
      }
    
    var $parent = $(this).parents('.inputStep');
    var val = $(this).val().trim();
    if(val != '') {
      $parent.addClass('inputFilled');
      $('.btnNextButton').removeClass('btn-disabled');
      $parent.find('.btnSubmit').removeClass('btn-disabled');
    } else {
      $parent.removeClass('inputFilled');
      $('.btnNextButton').addClass('btn-disabled');
      $parent.find('.btnSubmit').addClass('btn-disabled');
    }
    if($(this).hasClass('inputUserName')) $('.userName').text(val);
  });
  
  $('.btnSubmit').on('click',function(){
    goToSlide($(this).parents('.quiz-step').next('.quiz-step').attr('data'));
    storeData($(this).parents('.quiz-step'));
  });
  
  $('.btnBack').on('click',function(e){
    e.preventDefault();
    var $actv = $('.quiz-step.active')
    var $prev = $actv.prevAll(".quiz-step").not(".slide-auto").first();
    if($prev.attr('data') == '3'){
      $prev.addClass('data_change');
    }
    goToSlide($prev.attr('data'));
  });

  $('.j_contain .optRad').on('click',function(e){
    var parents = $(this).parents('.quiz-step');
    var value = $(this).attr('value');
    var provide_details = $(this).find('.provide_details .text_box').val();
    if(value == 'Yes'){
      parents.find('.provide_details').css("display", "block");
      if(provide_details == '' || provide_details == undefined){
         $('.btnNextButton').addClass('new-btn-disabled');
      }
    }else{
      parents.find('.provide_details').css("display", "none");
    }
  })

   var $new = $('.quiz-step[data="1"]');
  

  if($new.hasClass('inputFilled')) {
    $('.btnNextButton').removeClass('btn-disabled');
  } else {
    $('.btnNextButton').addClass('btn-disabled');
  }
  
   var $quiz_height = $('.quiz-step.active').height();
  var $footer_height = $('.container-fluid .quiz-footer').outerHeight();
      var total_height = $footer_height + $quiz_height;

  if($('.quiz-step.active[data="1"]').length){
    $('.quizSteps').css('height',$new.outerHeight() +'px');
  }

  
   $('.quiz-drawer-ask').attr('bottomoffset',$footer_height);
  $('.quiz-drawer-ask').css('bottom',$footer_height + 'px');

  $('.quiz-drawer-ask .quiz-ask').on('click',function(){
     var $header_height = $('.site-i-header').height();
    var $footer_height = $('.quiz-footer').height();
    var $footer_height_new = $('.footer-action').height();
    // var $quiz_close = $('.quiz-drawer-close').outerHeight();
    
    var $total = $header_height + 66 + 56 + $footer_height_new;
    
      if( $('.quiz-drawer-ask').hasClass('quiz-height-ask')){
        $('.quiz-drawer-ask').removeClass('quiz-height-ask');
        $('.quiz-drawer-content').css("height", "calc(100vh - 90px - " + $total + "px)");
        $('.quiz-drawer-ask .quiz-ask span img').css('transform','rotate(0deg)');
      }else{
         $('.quiz-drawer-ask').addClass('quiz-height-ask');
        $('.quiz-drawer-content').css("height", "0px");
        $('.quiz-drawer-ask .quiz-ask span img').css('transform','rotate(180deg)');
      }
  })

  $('.quiz-drawer-close').on('click',function(){
    $('.quiz-drawer-ask').addClass('quiz-height-ask');
    $('.quiz-drawer-content').css("height", "0px");
    $('.quiz-drawer-ask .quiz-ask span img').css('transform','rotate(180deg)');
  })

  
  $(document).on('click','.optRad',function(e){
    var $parent,$other,limit = 0;
    if($(this).hasClass('optChk')) {
      if($(this).hasClass('optChk')) limit = 4;
      $parent = $(this).parents('.quiz-step');
      $(this).toggleClass('active');
      if(limit > 0) {
        if($parent.find('.optChk.active').length >= limit) {
          $parent.find('.optChk:not(.active):not(.opt-selected)').addClass('opt-disabled');
        } else {
          $parent.find('.optChk').removeClass('opt-disabled');
        }
      }
      if($parent.find('.optChk.active').length > 0) {
        $('.btnNextButton').removeClass('btn-disabled');
        $(this).parents('.inputStep').addClass('inputFilled');
      } else {
        $('.btnNextButton').addClass('btn-disabled');
        $(this).parents('.inputStep').removeClass('inputFilled');
      }
    } else {
      if(!$(e.target).is('.lnkInfo') && $('.lnkInfo').has(e.target).length === 0) {
        $('.btnNextButton').removeClass('btn-disabled');
        $(this).addClass('active').siblings('.optRad').removeClass('active');
        $(this).parents('.inputStep').addClass('inputFilled');

        if($(this).hasClass('toNextOpt')) {
          setTimeout(function(){
            $('.btnNextButton').trigger('click');
          },300);
        }
      }
    }
    if($(this).hasClass('optChk')) {
      $parent = $(this).parents('.goalStep');
      
      if($(this).hasClass('active')) {
        $parent.find('.desc').removeClass('visibly-hidden');
        $parent.find('.desc .slctedOpt').text($(this).text());
        $parent.find('.desc p').text($(this).attr('desc'));
      } else {
        $parent.find('.desc').addClass('visibly-hidden');
      }
      $('.quizSteps').css('height',$parent.outerHeight()+'px');
    }
    
    if($(this).hasClass('_show_desc')) {
      $parent = $(this).parents('.quiz-step');
      if($(this).hasClass('active')) {
        $parent.find('.desc').removeClass('visibly-hidden');
        $parent.find('.desc .slctedOpt').text($(this).text());
        $parent.find('.desc p').text($(this).attr('desc'));
      } else {
        $parent.find('.desc').addClass('visibly-hidden');
      }
      $('.quizSteps').css('height',$parent.outerHeight()+'px');
    }
    
    var key = $(this).parents('.quiz-step').attr('key'), _value = '',_values = [];
    if($(this).hasClass('optChk')) {
      $(this).parents('.quiz-step').find('.opt.active').each(function(){
        _values.push($(this).attr('value'));
      });
      if(_values.length) _value = _values.join(',');
    }
    else {
      if($(this).hasClass('active')) _value = $(this).attr('value');
    }
    $('._summary_val[data-key="'+key+'"]').text(_value);


    if($(this).hasClass('optG')) {
      goal_arr = [];
      $(this).parents('.optGoals').find('.optG.active').each(function(){
        goal_arr.push($(this).attr('value'));
      });
      setIngrdnts(goal_arr);  
    }
  });
  
  $('.lnkInfo').on('click',function(e){
    e.preventDefault();
    $('body').addClass('quiz-modal-active');
    $('.modal-body[data="'+$(this).attr('data')+'"]').addClass('active').siblings('.modal-body').removeClass('active');
  });
  
  $('.modalClose').on('click',function(e){
    e.preventDefault();
    $('body').removeClass('quiz-modal-active');
  });
  
  $('.quiz-modal').on('click',function(e){
    if(!$(e.target).is('.modal') && $('.modal').has(e.target).length === 0) {
      $('body').removeClass('quiz-modal-active');
    }
  });
  
  $('.btnSkip').on('click',function(e){
    e.preventDefault();
    goToSlide($(this).parents('.quiz-step').next('.quiz-step').attr('data'));
  });
  
  $('.summryToggle').on('click',function(e){
    e.preventDefault();
    $(this).toggleClass('active');
    $('.summaryContent').slideToggle();
    setTimeout(function(){
      $('.quizSteps').css('height',$('.quiz-step.active').outerHeight()+'px');
    },450);
  });
  
  $(document).on('click','.btnAdd',function(){
    add_to_box($(this),false);
  });
  
  $(document).on('click','.btnQty',function(){
    var $qty = $(this).parents('.qtyParent').find('.qtyInput');
    var qty = parseInt($qty.val());
    qty = (isNaN(qty))?1:qty;
    
    if($(this).attr('data-action') == 'plus') {
      qty++;
    } else {
      if(qty > 0) qty--;
    }
        
    update_qty($(this),qty);
  });
  
  $(document).on('click','.faqQue',function(){
    var $parent = $(this).parents('.faq');
    var $ans = $parent.find('.faq-ans');
    $parent.toggleClass('active').siblings('.faq').removeClass('active');
    $('.faq-ans').not($ans).slideUp();
    $ans.slideToggle();
    setTimeout(function(){
      $('.quizSteps').css('height',$('.quiz-step.active').outerHeight()+'px');
    },450);
  });
  
  $(document).on('click','.itemRemove',function(e){
    e.preventDefault();
    update_qty($(this),0);
  });
  
  $(document).on('click','.btnAddAllItems',function(){
    $('.drawerEmpty').addClass('hidden');
    $('.drawerItems').removeClass('hidden');
	add_to_box($(this));
  });
  
  $(document).on('click','.btnAddItems',function(e){
    e.preventDefault();
    var cookie_data, properties = {}, products = [];
    $(this).addClass('disabled');
    if(getCookie('ne_selection') != '') {
      cookie_data = JSON.parse(decodeURIComponent(getCookie('ne_selection')));
      for (var key in cookie_data) {
        properties[key] = cookie_data[key];
      }
      
      $('.drawerItem').each(function(index){
        products[index] = [];
        products[index]['id'] = $(this).attr('data');
        products[index]['quantity'] = $(this).find('.qtyInput').val();
        if(index == 0) {
          products[index]['properties'] = properties;
        }
      });
      
      if(products.length) add_products(products);
    }
  });
  
  window.onhashchange = function() {
    if(location.hash.indexOf('giftSlide') >= 0) {
      var slide_no = location.hash.split('-')[1];
      if(!$('.quiz-step[index="'+slide_no+'"]').hasClass('active')) {
        goToSlide($('.quiz-step[index="'+slide_no+'"]').attr('data'));
      }
    }
  }
  
  $('.toggleBag').on('click',function(e){
    e.preventDefault();
    $('body').addClass('quiz-drawer-active');
  });
  
  $('.quiz-drawer').on('click',function(e){
    if(!$(e.target).is('.drawer') && $('.drawer').has(e.target).length === 0) {
      $('body').removeClass('quiz-drawer-active');
    }
  });
  $('.drawerClose').on('click',function(e){
    e.preventDefault();
    $('body').removeClass('quiz-drawer-active');
  });
});



  // Ingredients-Popup


$(".txt-popup-open").on('click', function(e) {
  e.preventDefault();
  var data_id = $(this).attr('data-id');
  $('.product-ingredients-id').each(function( index ) {
    var ingredients_id = $(this).attr('id');
    if(data_id == ingredients_id){
      $(this).find('.ingredients-popup-model').addClass('add-display-p');
      $(this).find('.ingredients-popup-model-container.entered').css('transform','translateY(0%)')
      $('body').addClass('add-overflow-p');
    }
  });
  
  // $('.ingredients-popup-model').addClass('add-display-p');
  // $('.ingredients-popup-model-container.entered').css('transform','translateY(0%)')
  // $('body').addClass('add-overflow-p');
});

$(".ingredients-p-content-a-i-c").on('click', function() {
    var first_aria = $(this).find('.ingredients-p-content-a-i-c-f-i-svg');
    var second_aria = $(this).find('.class-second-add');
  
    if(first_aria.hasClass('icon-style')){
      first_aria.addClass('iconStyles').removeClass('icon-style');
        second_aria.slideToggle();   
    }else{
      first_aria.addClass('icon-style').removeClass('iconStyles');
       second_aria.slideToggle();
    }
});

$(".ingredients-popup-close").on('click',function(){
  $('.ingredients-popup-model-container.entered').css('transform','translateY(100%)')
    $('.ingredients-popup-model').removeClass('add-display-p');
  $('body').removeClass('add-overflow-p');
})

$(".ingredients-p-content-b-c-btn").on('click',function(){
  $('.ingredients-popup-model-container.entered').css('transform','translateY(100%)')
    $('.ingredients-popup-model').removeClass('add-display-p');
     $('body').removeClass('add-overflow-p');
});


  // Body-care

  $(document).on('click','.check-goals',function(e){
    e.preventDefault();
    var $parent,limit = 0;
    var arr = [];
    var $parentSlide = $(this).parents('.selection-slide');
    if($(this).hasClass('optGoal')) {
      if($(this).hasClass('optGoal')) limit = 3;
      $parent = $(this).parents('.selection-slide');
      $(this).toggleClass('active');
      if(limit > 0) {
        if($parent.find('.optGoal.active').length >= limit) {
          $parent.find('.optGoal:not(.active):not(.opt-selected)').addClass('goals-disable');
        } else {
          $parent.find('.optGoal').removeClass('goals-disable');
        }
      }
    }
    
      $('.check-goals').each(function(){
        if($(this).hasClass('active')){
          var value= $(this).attr('value'); 
          arr.push(value);
        }
      })
   var data_arr = arr.join('||')
   saveData($parent.find('.selection-head').attr('data'),data_arr);
    
    if($('.check-goals').hasClass('active')){
      $parentSlide.addClass('done');
       $('.btnRight').removeClass('btn-disabled');
    }else{
      $parentSlide.removeClass('done');
       $('.btnRight').addClass('btn-disabled');
    }
    
   if($(this).hasClass('optGoal')) {
      $parent = $(this).parents('.selection-slide');
    if($(this).hasClass('active')) {
        $parent.find('.desc').removeClass('visibly-hidden');
        $parent.find('.desc .show_head').text($(this).text());
        $parent.find('.desc p').text($(this).attr('desc'));
      } else {
        $parent.find('.desc').addClass('visibly-hidden');
      }
    }
  });


// CD CODE
$(document).on('click', '.hero_Topic_list .Topics', function(){
  if($(this).hasClass('active')){
    $(this).removeClass('active')
  }else{
    $(this).addClass('active')
  }
});

if($(window).width() < 768 && $('.custom_list_result_section .list_results_image').length){
  $('.custom_list_result_section .list_results_image').slick({
    slidesToShow: 2,
    slidesToScroll: 2,
    dots: true,
    infinite: false,
    arrows: false,
    responsive: [
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
  ]
  });
}

if($(window).width() < 992 && $('.custom_review_section .review_list').length){
  $('.custom_review_section .review_list').slick({
    slidesToShow: 2,
    slidesToScroll: 2,
    dots: true,
    infinite: false,
    arrows: false,
    responsive: [
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
  ]
  });
}

// CD CODE Cart Drawer
$(document).on('click', '.nav-i-link[href="/cart"], .js_cart_drwer_show, .template-page.Makeorder .footer-action .btnBuy,  .template-page.Quiz .footer-action .btnBuy', function(event){
  event.preventDefault();
  $('.cart_drawer').addClass("drawer_is_open");
  $('html body').addClass("stop_page_scroll");
});
$(document).on('click', '.cart_drawer .close_drawer, .cart_overlay', function(event){
  event.preventDefault();
  $('.cart_drawer').removeClass("drawer_is_open");
  $('html body').removeClass("stop_page_scroll");
});

$(document).ready(function(){
  cart_drawer();
})

function cart_drawer(){
  if($('.cart_drawer .checkout_btn').length){
    $('.cart_drawer .checkout_btn').prop( "disabled", true );
  }
  $.ajax({
    url: '/cart?view=drawer',
    type: 'GET',
    dataType: 'html',
    success:function(data) {
      $('.cart_drawer .cart_content').html(data)
    },
    complete: function(){
      setTimeout(function(){
        if($('.cart_drawer .checkout_btn').length){
          $('.cart_drawer .checkout_btn').prop( "disabled", false );
        }
      }, 2000);
    }
  });
}

$(document).on('click', '.cart_drawer .qtybox .btnqty', function(){
  var qty = parseInt($(this).parent('.qtybox').find('.quantity-input').val());
  if($(this).hasClass('qtyplus')) {
    qty++;
  }else {
    if(qty > 0) {
      qty--;
    }
  }
  qty = (isNaN(qty))?0:qty;
  $(this).parent('.qtybox').find('.quantity-input').val(qty);
  if($('.cart_drawer .checkout_btn').length){
    $('.cart_drawer .checkout_btn').prop( "disabled", true );
  }
  var item_id = $(this).parent('.qtybox').attr('data-item-id');
  $.ajax({
    url: '/cart/change.js',
    type: 'POST',
    dataType: 'json',
    data: {
      id: item_id,
      quantity: qty
    },
    success:function(items) {
      cart_drawer();
    }
  });
  
}); 

$(document).on('click','.grid-add-to-cart-btn',function(event){
  event.preventDefault();
  var serialize = $(this).parents("form").serialize();
  var textadd = $(this).val("Adding...");
  if($('.cart_drawer .checkout_btn').length){
    $('.cart_drawer .checkout_btn').prop( "disabled", true );
  }
    $.ajax({
      url: '/cart/add.js',
      type: 'POST',
      dataType: 'json',
      data: serialize,
      success:function(data) {
        $(textadd).val("Add to cart");
        cart_drawer();
        $('.cart_drawer').addClass('drawer_is_open');
        $('html body').addClass("stop_page_scroll");
      },error:function(e){
        console.log(e);
        $(textadd).val("Add to cart");
      }
    });
});

$(document).on('change','.cart_drawer .item_switches [type="radio"]',function(){
  var pro_id = $(this).attr('data-id');
  var current_id = $(this).parents('.cart_product_item').attr('data-cart-item-id');
  var current_properties = $(this).parents('.cart_product_item').find('.list_item_properties li');
  var updates = {};
  var properties = {};
  
  updates[current_id] = 0;

  current_properties.each(function () {
    var first_pro = $(this).find('span:first-child').text().replace(': ', '');
    properties[first_pro] = $(this).find('span:last-child').text();
  });
  if($('.cart_drawer .checkout_btn').length){
    $('.cart_drawer .checkout_btn').prop( "disabled", true );
  }
    $.ajax({
      url: '/cart/update.js',
      dataType: 'json',
      type: 'post',
      data: {
        updates: updates
      },
      success: function(){
        $.ajax({
          url: '/cart/add.js',
          type: 'POST',
          dataType: 'json',
          data: {
            items: [
              {
                quantity: 1,
                id: pro_id,
                properties: properties
              }
            ]
          },
          success:function(data) {
            cart_drawer();
          },error:function(e){
            console.log(e);
          }
        });
      }
    });

    
});

$(document).on('click', '.cart_drawer .view_details', function(){
  if($(this).hasClass('show_item_property')){
    $('.cart_drawer .view_details').removeClass('show_item_property');
    $('.cart_drawer .item_properties').slideUp();
  }else{
    $(this).addClass('show_item_property');
    $(this).parents('.cart_product_item').find('.item_properties').slideDown();
  }
});

$(document).on('click', '.free_gift_label .note_feild', function(){
  $('#free_gift_pro_label').trigger('click');
  // if($(this).parent('.free_gift_label').hasClass('open_cart_note')){
  //   $('.free-gift_pro .free_gift_label').removeClass('open_cart_note');
  //   $('.free-gift_pro .free-gift-form').hide();
  //   $('.cart_drawer .cart-item-with-upsell').removeClass('reduce-height');
  // }else{
  //   $(this).parent('.free_gift_label').addClass('open_cart_note');
  //   $(this).parents('.free-gift_pro').find('.free-gift-form').show();
  //   $('.cart_drawer .cart-item-with-upsell').addClass('reduce-height');
  // }
});

$(document).on('change', '#free_gift_pro_label', function(){
  var free_pro_id = $('.cart_drawer .free-gift_pro').attr('data-gift-id');
  
  if($(this).is(':checked') == true){
    if(!$('.cart_product_item[data-cart-item-id="'+ free_pro_id +'"]').length){
       $.ajax({
        url: '/cart/add.js',
        type: 'POST',
        dataType: 'json',
        data: {
          items: [
            {
             id: free_pro_id,
             quantity: 1
            }
          ]
        },
        success:function(data) {
          cart_drawer();
        }
      });
    }
  }else{
    if($('.cart_product_item[data-cart-item-id="'+ free_pro_id +'"]').length){
      $.ajax({
        url: '/cart/change.js',
        type: 'POST',
        dataType: 'json',
        data: {
          id: free_pro_id,
          quantity: 0
        },
        success:function(items) {
          if($('.cartdrawer_att_to').val() != '' && $('.cartdrawer_att_from').val() != '' &&  $('#free-gift-note').val() != ''){
            $('.cartdrawer_att_to').val('');
            $('.cartdrawer_att_from').val('');
            $('#free-gift-note').val('');
            $('.add_free_gift').trigger('click');
          }
          cart_drawer();
        }
      });
    }
  }
});

// $(document).on('click', '.cart_drawer .add_free_gift', function(){
//   var to_feild = $('.cartdrawer_att_to').val();
//   var from_feild = $('.cartdrawer_att_from').val();
//   var note = $('#free-gift-note').val();
//   var product_remove = false;
//   var product_added = false;
//   var cart_refresh = true;

//   $('.cartdrawer_att_to').css('border-color', '#949494');
//   $('.cartdrawer_att_from').css('border-color', '#949494');
//   $('#free-gift-note').css('border-color', '#949494');

//   if(to_feild == '' && from_feild == '' && note == ''){
//     product_remove = true;
//   }else if(to_feild != '' && from_feild != '' && note != ''){
//     product_added = true;
//   }else{
//     if(to_feild == ''){
//       $('.cartdrawer_att_to').css('border-color', 'red');
//     }
//     if(from_feild == ''){
//       $('.cartdrawer_att_from').css('border-color', 'red');
//     }
//     if(note == ''){
//       $('#free-gift-note').css('border-color', 'red');
//     }
    
//     return false;
//   } 
  
//   $(this).text('Adding...');
//   $.ajax({
//     url: '/cart/update.js',
//     type: 'POST',
//     dataType: 'json',
//     data: {
//       attributes: {
//         'To': to_feild,
//         'From': from_feild
//       },
//       note: note
//     },
//     success:function(items) {
//       $('.cart_drawer .add_free_gift').text('Add Gift');
//       if(product_added == true && $('#free_gift_pro_label').is(':checked') == false){
//         // $('#free_gift_pro_label').trigger('click');
//         var free_pro_id = $('.cart_drawer .free-gift_pro').attr('data-gift-id');
//         if(!$('.cart_product_item[data-cart-item-id="'+ free_pro_id +'"]').length){
//          $.ajax({
//           url: '/cart/add.js',
//           type: 'POST',
//           dataType: 'json',
//           data: {
//             items: [
//               {
//                id: free_pro_id,
//                quantity: 1
//               }
//             ]
//           },
//           success:function(data) {
//             cart_drawer();
//           }
//         });
//       }
//       }else if(product_remove == true && $('#free_gift_pro_label').is(':checked') == true){
//         // $('#free_gift_pro_label').trigger('click');
//         var free_pro_id = $('.cart_drawer .free-gift_pro').attr('data-gift-id');
//         if($('.cart_product_item[data-cart-item-id="'+ free_pro_id +'"]').length){
//           $.ajax({
//             url: '/cart/change.js',
//             type: 'POST',
//             dataType: 'json',
//             data: {
//               id: free_pro_id,
//               quantity: 0
//             },
//             success:function(items) {
//               if($('.cartdrawer_att_to').val() != '' && $('.cartdrawer_att_from').val() != '' &&  $('#free-gift-note').val() != ''){
//                 $('.cartdrawer_att_to').val('');
//                 $('.cartdrawer_att_from').val('');
//                 $('#free-gift-note').val('');
//                 $('.add_free_gift').trigger('click');
//               }
//               cart_drawer();
//             }
//           });
//         }
//       }else{
//         cart_drawer(); 
//       }
//     }
//   });
  
// });

$(document).on('click', '.cart_drawer  .drawer_added_product:not(.item_soldout)', function(){
  var data_id = $(this).attr('data-related-pro-id');
  $(this).addClass('active_spiner');
  $.ajax({
    url: '/cart/add.js',
    type: 'POST',
    dataType: 'json',
    data: {
      items: [
        {
         id: data_id,
         quantity: 1
        }
      ]
    },
    success:function(data) {
      $('.drawer_added_product').removeClass('active_spiner');
      cart_drawer();
    }
  });
});

// cd code klaviyo change event
var klaviyo_interval = setInterval(klaviyo_form_find, 1000);
function klaviyo_form_find(){
  var klaviyo_form = $('.quiz-body .klaviyo-form');
  if(klaviyo_form.length){
    $('.quiz-body .klaviyo-form input[type="text"], .quiz-body .klaviyo-form input[type="email"]').on('change',function(){
      var emailReg = /^([\w-\.]+@([\w-]+\.)+[\w-]{2,4})?$/;
      var kl_email_fieldVal = $('.quiz-body .klaviyo-form input[type="email"]').val();
      
      if($('.quiz-body .klaviyo-form input[type="text"]').val() == ''){
        $(this).parents('.quiz-body').find('.email_box_error').removeClass('hide');
        $('.btnNextButton').addClass('new-btn-disabled');
      }else if($('.quiz-body .klaviyo-form input[type="email"]').val() == ''){
        $(this).parents('.quiz-body').find('.email_box_error').removeClass('hide');
        $('.btnNextButton').addClass('new-btn-disabled');
      }else if(!emailReg.test(kl_email_fieldVal)) {
        $(this).parents('.quiz-body').find('.email_box_error').removeClass('hide');
        $('.btnNextButton').addClass('new-btn-disabled');
      }else{
        $(this).parents('.quiz-body').find('.email_box_error').addClass('hide');
        $('.btnNextButton').removeClass('new-btn-disabled btn-disabled');
      }
    });
    clearInterval(klaviyo_interval);
  }
}

// CD CODE
$(document).on('click', '.custom_radio_list .custom_radio', function(){
  $(this).parents('.custom_radio_list').find('.custom_radio').removeClass('is_selected');
  $(this).addClass('is_selected');
  if($(this).parents('.custom_radio_list').find('.custom_radio.is_selected')){
    var selected_label = $(this).parents('.custom_radio_list').find('.custom_radio.is_selected').attr('data-label');
    if(selected_label == 'Yes'){
      $(this).parents('.product_details').find('.product_details_ms_input').removeClass('hide');
      if($(this).parents('.product_details').find('.product_details_ms_input textarea').val() != ''){
        $('.selection-footer .btn-nav.btnNext.jsBtnNav').removeClass('btn-inactive');  
        $(this).parents('.product_details').find('.product_details_ms_input [type="button"]').prop('disabled', false);
      }else{
        $('.selection-footer .btn-nav.btnNext.jsBtnNav').addClass('btn-inactive');  
        $(this).parents('.product_details').find('.product_details_ms_input [type="button"]').prop('disabled', true);
      }

      var scroll_height = 0,
          total_header_height = 0;
      
      if($('.header_timer').length){
        total_header_height += $('.header_timer').outerHeight();
      }
      if($('#shopify-section-header header').length){
        total_header_height += $('#shopify-section-header header').outerHeight();
      }

      scroll_height = $('.radio_with_textbox.active-slide').offset().top + total_header_height;

      $('html, body').animate({ scrollTop: scroll_height }, "slow");
      
    }else{
      $(this).parents('.product_details').find('.product_details_ms_input').addClass('hide');
      $('.selection-footer .btn-nav.btnNext.jsBtnNav').removeClass('btn-inactive');
      $(this).parents('.product_details').find('.product_details_ms_input [type="button"]').prop('disabled', false);
      $('.btnNext.jsBtnNav:not(.btnBegin)').trigger('click');
    }
  }

  prepareJSON($(this));
})

$(document).on('keyup', '.slideChoices.radio_with_textbox textarea', function(){
  if($(this).parents('.slideChoices').find('.custom_radio_list .custom_radio[data-label="Yes"]').length){
    $(this).parents('.slideChoices').find('.custom_radio_list .custom_radio[data-label="Yes"]').trigger('click');
  }
  if($(this).val() == ''){
    $('.selection-footer .btn-nav.btnNext.jsBtnNav').addClass('btn-inactive');
    $(this).parents('.product_details_ms_input').find('[type="button"]').prop('disabled', true);
  }else{
    $('.selection-footer .btn-nav.btnNext.jsBtnNav').removeClass('btn-inactive');
    $(this).parents('.product_details_ms_input').find('[type="button"]').prop('disabled', false);
  }
});

$(document).on('click', '.back_button', function(){
  if($('.footer-action .btnPrev').length){
    $('.footer-action .btnPrev').trigger('click');
  }
});

$(document).on('click', '.custom_form_submit', function(e){
  e.preventDefault();
  var email = $(this).parents('form').find('[name="3"]').val();
  var name = $(this).parents('form').find('[name="1"]').val();

   $.ajax({
  	type: 'POST',
  	url: "https://codifyinfotech.com/ravel/call.php", 
  	data: {action:'get_data',email:email,name:name},
  	dataType: 'json', 
  	success: function (data) { 
  		if(data['st'] == 'false'){ 
  			console.log("Sorry! something wrong");
  		}
  	}
  });
});

$(document).on('click', '.Next-slide-btn', function(){
  if($(this).parents('.selection-slide').hasClass('slide-1')){
    $('.custom_new_quiz.custom-selection .btnBegin').trigger('click');
  }else{
    $('.custom_new_quiz.custom-selection .btn-nav.btnNext').trigger('click');
  }
});


$(window).on('load', function(){
  if($('.custom_new_quiz #nav_reviews_section').length){
    $('.custom_new_quiz #nav_reviews_section').css('visibility', 'visible');
  }
})

// cd jaydip

$(document).on('click', '.new_product_temp .new_product_variant .variant', function(){
  var option_val = $(this).attr("value");
  $(this).parents(".selector-wrapper").find(".variant").removeClass("selected");
  // $('.new_product_temp .new_product_variant .variant').removeClass("selected");
  $(this).addClass("selected");  
  $(this).parents(".product-form__item").find('.single-option-selector').val(option_val).trigger('change');
});

$(document).ready(function(){
  $('.new_product_variant.color_variant .variant.selected').trigger('click');
});            


// CD CODE Product Tab Quiz
if($('.product_tab_quiz').length){
  $(document).on('click', '.pro_quiz_content .custom_tooltip', function(){
    if($(this).next('p').hasClass('tooltip_is_open')){
      $(this).next('p').removeClass('tooltip_is_open');
    }else{
      $(this).next('p').addClass('tooltip_is_open');
    }
  });
  
  $(document).on('click', function(e){
    if($(e.target).hasClass('custom_tooltip') == false && $(e.target).hasClass('custom_tooltip_text') == false ){
      if($('.custom_tooltip_text.tooltip_is_open').length){
        $('.custom_tooltip_text.tooltip_is_open').removeClass('tooltip_is_open');
      }
    }
  });

  $(document).on('click', '.pro_quiz_content .next_slide', function(){
    $(this).parents('.selection-inner').find('.btn-nav.btnNext').trigger('click');
    
    var color_image_url = $('.js_image_change_meta.active-choice').attr('img-color');
    if(color_image_url != ''){
      $('.js_product_img_add').attr('img-color',color_image_url);
    }else{
       $('.js_product_img_add').attr('img-color','');
    }

    $('.js_product_img_add').each(function() {
      var product_img_add = $(this).attr('img-color');
      var default_img_url = $(this).attr('default-url');
      var product_img_url = $(this).attr(product_img_add);
      if(product_img_url != ''){
        $(this).attr('src',product_img_url);
      }else{
        $(this).attr('src',default_img_url);
      }
    })
    
  });

  $(document).on('click', '.product_tab_quiz .custom_check_input', function(){
    var input_val = $(this).parents('.selection-desc').find('.selection-input').val();
    if(input_val.trim() == ''){
      $(this).parents('.selection-desc').find('.selection-input').css('border-color', 'red');
    }else{
      if($(this).parents('.pro_quiz_content').find('.color-box.active-choice').length){
        $(this).parents('.pro_quiz_content').find('.next_slide').prop('disabled', false);
      }
      var page_scroll = $(this).parents('.pro_quiz_content').find('.selection-choices').offset().top - 200;
      window.scrollTo({top: page_scroll, behavior: 'smooth'});
    }
  });

  $(document).on('keyup', '.product_tab_quiz .selection-desc .selection-input', function(){
    var input_val = $(this).val();
    if(input_val.trim() == '' && input_val == ''){
      $(this).css('border-color', 'red');
      $(this).parents('.pro_quiz_content').find('.next_slide').prop('disabled', true);
      if($(this).parents('.selection-slide').hasClass('choice_color_pro_list') == false && $(this).parents('.selection-slide').hasClass('inputRequired') == true){
        $(this).parents('.selection-slide').addClass('slide_done');
      }
    }else{
      $(this).css('border-color', '#e3e4e4');
      if($(this).parents('.selection-slide').hasClass('choice_color_pro_list') == false && $(this).parents('.selection-slide').hasClass('inputRequired') == true){
        $(this).parents('.pro_quiz_content').find('.next_slide').prop('disabled', false);
        $(this).parents('.selection-slide').addClass('slide_done');
      }
    }
  });

  $(document).on('click', '.custom_new_quiz .finalSlide .open_cart_drawer', function(){
    $('.cart_drawer').addClass('drawer_is_open');
    $('html body').addClass("stop_page_scroll");
  });

  $(document).on('click', '.custom_new_quiz .finalSlide .open_cart_drawer', function(){
    $('.cart_drawer').addClass('drawer_is_open');
    $('html body').addClass("stop_page_scroll");
  });

  $(document).on('click', '.custom_new_quiz .pro_quiz_panel', function(){
    if($(this).parents('.selection-slide').hasClass('slide_done')){
      if($(this).parents('.selection-slide').find('.pro_quiz_content').hasClass('is_tab_open')){
        $(this).parents('.selection-slide').find('.pro_quiz_content').removeClass('is_tab_open');
        $(this).parents('.selection-slide').find('.pro_quiz_content').slideUp();
        $(this).parents('.selection-slide').removeClass('active-slide');
        if($('.custom_new_quiz .selection-slide.slide_done + .selection-slide:not(.slide_done)').length){
          $('.custom_new_quiz .selection-slide.slide_done + .selection-slide:not(.slide_done) .pro_quiz_content').addClass('is_tab_open').slideDown();
          $('.custom_new_quiz .selection-slide.slide_done + .selection-slide:not(.slide_done)').addClass('active-slide');
        }
      }else{
        $('.custom_new_quiz .selection-slide').removeClass('active-slide');
        $('.custom_new_quiz .pro_quiz_content').slideUp();
        $('.custom_new_quiz .pro_quiz_content.is_tab_open').removeClass('is_tab_open');
        if($('.custom_new_quiz .selection-slide.slide_done + .selection-slide:not(.slide_done)').length){
          $('.template_new-product .selection-footer .btn-nav.btnNext.jsBtnNav').attr('data-target', $('.custom_new_quiz .selection-slide.slide_done + .selection-slide:not(.slide_done)').attr('data-index'));
          if($('.custom_new_products').length){
            $('.custom_new_products .selection-footer .btn-nav.btnNext.jsBtnNav').attr('data-target', $('.custom_new_quiz .selection-slide.slide_done + .selection-slide:not(.slide_done)').attr('data-index'));
          }
        }
        $(this).parents('.selection-slide').find('.pro_quiz_content').addClass('is_tab_open');
        $(this).parents('.selection-slide').find('.pro_quiz_content').slideDown();
        $(this).parents('.selection-slide').addClass('active-slide');
      }
    }
  });

  $(document).on('click', '.template_new-product .new_product_temp .thumbnails-wrapper .product-single__thumbnails .grid__item a, .custom_new_products .new_product_temp .thumbnails-wrapper .product-single__thumbnails .grid__item a', function(e){
    e.preventDefault();
    var current_thumb_id = $(this).attr('data-thumbnail-id');
    if($('.custom_new_products').length){
      var current_main_index = $('.product-single__photo[data-image-id="'+ current_thumb_id +'"]').parents('.product-single__photo-wrapper').attr('data-slick-index');
    }else{
      var current_main_index = $('#FeaturedImageZoom-new-product-template-'+ current_thumb_id +'-wrapper').attr('data-slick-index');
    }
    $('.new_product_temp .prod-single-slider').slick('slickGoTo', current_main_index);
  })

  $(document).on('click', '.template_new-product .take_quiz_button a, .custom_new_products .take_quiz_button a', function(){
    if($(window).width() < 749){
      var current_height = $('.left_content .title.medium-up--hide').offset().top - 155;
    }else{
      var current_height = $('.product_tab_quiz').offset().top - 140;
    }
    window.scroll({top: current_height, behavior: "smooth"});
  });
}

$(document).ready(function(){
  if($(window).width() < 749 && $('.round_image_text .section_content').length){
    $('.round_image_text .section_content').slick({
      slidesToShow: 1.4,
      slidesToScroll: 1,
      dots: false,
      infinite: false,
      arrows: false
    });
  }
});

// marquee
var r = document.querySelector(':root');
if(document.querySelectorAll('.marquee_list').length) r.style.setProperty('--marquee-width', '-'+document.querySelector('.marquee_list .marque_list:first-child').clientWidth+'px');

if($(".our-product .collection_product_slider .slider_content").length){ 
  $(".our-product .collection_product_slider .slider_content").each(function( index ){
    var ele = $(this);
    ele.slick({
      slidesToShow: 5.5,
      slidesToScroll: 1,
      infinite: false,
      arrows: true,
      dots: false,
      responsive: [
        {
          breakpoint: 749,
          settings: {
            slidesToShow: 2,
            arrows: false,
            dots: true
          }
        }
      ]
    });
  });
}

if($(".review_slider .review_list").length){ 
  $(".review_slider .review_list").each(function( index ){
    var ele = $(this);
    ele.slick({
      slidesToShow: 2,
      slidesToScroll: 1,
      infinite: true,
      arrows: false,
      autoplay: true,
      autoplaySpeed: 2000,
      dots: true,
      responsive: [
        {
          breakpoint: 749,
          settings: {
            slidesToShow: 1
          }
        }
      ]
    });
  });
}

if($(window).width() < 749 && $('.slider_image_with_text .slider_block_content').length){
  $('.slider_image_with_text .slider_block_content').slick({
    slidesToShow: 1.3,
    slidesToScroll: 1,
    dots: false,
    infinite: false,
    arrows: false
  });
}

$(document).on('click', '.our-product .tab_list button', function(){
  $(this).parents('.tab_list').find('button').removeClass('is_tab_active');
  $(this).addClass('is_tab_active');
  $(this).parents('.our-product').find('.collection_product .collection_product_slider').addClass('hide');
  $(this).parents('.our-product').find('.collection_product #'+$(this).attr('data-id')).removeClass('hide');
  $(this).parents('.our-product').find('.collection_product #'+$(this).attr('data-id') + ' .slider_content').get(0).slick.setPosition();
});

// CD Dev
// if($('.multipal_collection_product .slider_content').length){
//    $('.multipal_collection_product .slider_content').slick({
//       dots: false,
//       infinite: false,
//       slidesToShow: 5,
//       slidesToScroll: 1,
//       prevArrow: false,
//       nextArrow: false
//   });
// }

if($(".header_timer").length){
  var timer_height = $('.header_timer').height();
  $(".site-i-header.head-fixed").css("top", timer_height);
}

// if($(".text-banner-section").length) {
//   var banner_height = $('.text-banner-section').outerHeight();
//   $(".site-i-header.head-fixed").css("top", banner_height);
// }

// CD Sanket
$(document).on('click','.faq-question',function(){
  if($(this).parent(".block-item").hasClass('is_open')){
    $(this).parent(".block-item").removeClass('is_open')
   $(this).next().slideUp(); 
  }else{
    $(this).parent(".block-item").addClass('is_open')
    $(this).next().slideDown(); 
  }
})

$(document).on('click', '.custom_skincare_quiz .radio_with_textbox .product_details_ms_input .btn', function(){
  $('.custom_skincare_quiz .selection-footer .footer-action .btn-nav.btnNext.jsBtnNav').trigger('click');
});

// CD CODE..
$(document).on('change', '.custom-selection .selection-products .price_with_action_btn .pro_variant_list', function(){
  var current_option = $(this).parents('.price_with_action_btn').find('.pro_variant_list option[value="'+ $(this).val() +'"]'),
      current_id = $(this).val(),
      current_price = current_option.attr('data-price').split('||'),
      current_comp_price = current_option.attr('data-comp-price').split('||'),
      current_discount = (((current_comp_price[0] - current_price[0]) * 100) / current_comp_price[0]),
      current_order_price = current_option.attr('data-order');
  $(this).parents('.price_with_action_btn').find('.pricing-row .prod_price .pro_price').html(current_price[1]);
  if(current_comp_price[0] > current_price[0]){
    $(this).parents('.price_with_action_btn').find('.pricing-row .pro_com_price').html(current_comp_price[1]);
    $(this).parents('.price_with_action_btn').find('.pricing-row .price_off .off_price').html(Math.floor(current_discount) + '%');
    $(this).parents('.price_with_action_btn').find('.pricing-row .sel-pr-c-price').removeClass('hide');
    $(this).parents('.price_with_action_btn').find('.pricing-row .price_off').removeClass('hide');
  }else{
    $(this).parents('.price_with_action_btn').find('.pricing-row .sel-pr-c-price').addClass('hide');
    $(this).parents('.price_with_action_btn').find('.pricing-row .price_off').addClass('hide');
  }

  $(this).parents('.price_with_action_btn').find('.jsBtnAdd').attr('data-id', current_id);
  $(this).parents('.price_with_action_btn').find('.jsBtnAdd [data]').attr('data', current_id);

  
  $(this).parents('.price_with_action_btn').find('.sel-pr-prices .cust_text b').html(current_order_price);
});

$('.qtybox .btnqty').on('click', function(){
  var qty = parseInt($(this).parents('.qtybox').find('.quantity-input').val());
  if($(this).hasClass('qtyplus')) {
    qty++;
  }else {
    if(qty > 1) {
      qty--;
    }
  }
  qty = (isNaN(qty))?1:qty;
  $(this).parents('.qtybox').find('.quantity-input').val(qty);
});

$(document).on('change', '.custom_variant-swatch input', function(){
  var current_title = $(this).attr('data-variant-title');
  $('.pro_variant .selector-wrapper select').val(current_title).trigger('change');
});

// CD CODE...
if($('.meta_after_before_img_text .image_list').length){
  $('.meta_after_before_img_text .image_list').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: true,
    infinite: false,
    arrows: true,
    prevArrow: ".slider_left_icons",
    nextArrow: ".slider_right_icons",
    appendDots: $('.slider_action_dote')
  });
  $('.meta_after_before_img_text .image_list').on('afterChange', function(event, slick, currentSlide, nextSlide){
    $('.template_alt_pro .meta_after_before_img_text .section_wrapper .right_content .content_list [data-index]').addClass('hide');
    $('.template_alt_pro .meta_after_before_img_text .section_wrapper .right_content .content_list [data-index="'+ currentSlide +'"]').removeClass('hide');
  });
}

if($('.pro_result .section_wrapper .right_content .info_slider .slider_list_info').length){
  $('.pro_result .section_wrapper .right_content .info_slider .slider_list_info').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: false,
    infinite: false,
    arrows: false,
    draggable: false
  });
  $(document).on('mouseover', '.pro_result .slider_btn button', function(){
    $(this).parents('.slider_btn').find('button.is_active').removeClass('is_active');
    $(this).addClass('is_active');
    var current_slide_index = $(this).parents('.info_slider').find('.slider_item[data-index="'+ $(this).attr('data-index') +'"]').attr('data-slick-index');
    $('.pro_result .section_wrapper .right_content .info_slider .slider_list_info').slick('slickGoTo', parseInt(current_slide_index));
  });
}

$(document).on('click', '.pro_use button', function(){
  if($(this).hasClass('is_active')){
    $(this).removeClass('is_active');
    $(this).parents('.tab_btn_content').find('.tab_content').slideUp();
  }else{
    $(this).addClass('is_active');
    $(this).parents('.tab_btn_content').find('.tab_content').slideDown();
  }
});

$(document).on('click', '.meta_faqs .faq_list button', function(){
  if($(this).hasClass('is_active')){
    $(this).removeClass('is_active');
    $(this).parents('.faq_item').find('.faq_content').slideUp();
  }else{
    $(this).addClass('is_active');
    $(this).parents('.faq_item').find('.faq_content').slideDown();
  }
});

$(document).on('click', '.image_with_tab .meta_tab_item button', function(){
  if($(window).width() > 749){
    if($(this).hasClass('is_active')){
      $(this).removeClass('is_active');
      $(this).parents('.meta_tab_item').find('.tab_content').slideUp();
    }else{
      $(this).parents('.meta_tab_list').find('.meta_tab_item button').removeClass('is_active');
      $(this).parents('.meta_tab_list').find('.tab_content').slideUp();
      $(this).addClass('is_active');
      $(this).parents('.meta_tab_item').find('.tab_content').slideDown();
    }
  }else{
    var current_data_index = $(this).attr('data-index');
    $(this).parents('.meta_btn_list').find('button.is_active').removeClass('is_active');
    $(this).parents('.meta_tab_item').find('.meta_content_list .tab_content').css('display', 'none');
    $(this).addClass('is_active');
    $(this).parents('.meta_tab_item').find('.meta_content_list .tab_content[data-index="'+ current_data_index +'"]').css('display', 'block');
  }
});

$(document).on('click', '.sty_action_btn', function(){
  if($('.product-form__cart-submit').length){
    $('.product-form__cart-submit').trigger('click');
  }
});

$(document).on('click', '.scroll_top', function(){
  $("html, body").animate({ scrollTop: 0 }, "slow");
});

if($('.template_alt_pro').length){
  $(window).scroll(function(){
    if($('.sticky_action_bar')){
      var aTop = $('.product-form__item--submit').offset().top;
      if($(this).scrollTop() > aTop){
        $('.sticky_action_bar').addClass('is_scroll');
      }else{
        $('.sticky_action_bar').removeClass('is_scroll');
      }
    }
    if($('.pro_main_header')){
      $('.main-content .shopify-section').each(function(inx, ele){
        var this_outer = $(this).outerHeight() - 90;
        if($(window).scrollTop() > $(this).offset().top - this_outer){
          $('.pro_main_header .section_wrapper ul li').removeClass('is_active');
          $('.pro_main_header ul li a[href="#'+ $(this).attr('id') +'"]').parents('li').addClass('is_active');
        }
      })
    }
  });
}

$(document).on('click', '.pro_main_header .section_wrapper ul li a', function(e){
  e.preventDefault();
  if($($(this).attr('href')).length){
    var offset_height = $($(this).attr('href')).offset().top - 60;
    $("html, body").animate({ scrollTop: offset_height }, "slow");
    // $('.pro_main_header .section_wrapper ul li').removeClass('is_active');
    // $(this).parents('li').addClass('is_active');
  }
});

if($('.template_alt_pro') && $('.pro_main_header')){
  $(window).on('scroll', function(){
    if($(window).scrollTop() > 0){
      $('.pro_main_header').css('display', 'block');
    }else{
      $('.pro_main_header').css('display', 'none');
    }
  });
}

 var k = document.querySelector(':root');
if(document.querySelectorAll('.st_marquee_list').length) k.style.setProperty('--st-marquee-width', '-'+document.querySelector('.st_marquee_list .st_marque_list:first-child').clientWidth+'px');


if($(".image_slide_with_text .image_inner").length){
  $('.image_slide_with_text .image_inner').each(function(slider___slider) {
      $(this).slick({
        dots:true,
      infinite: false,
      slidesToShow: 1,
      slidesToScroll: 1,
    });
  });
}

$(document).ready(() => {
  const $tabButtons = $(".btn_inner");
  const $slider = $('.tab_text_content .image_slider');

  if ($slider.length) {
    $slider.slick({
      dots: true,
      infinite: false,
      slidesToShow: 1,
      slidesToScroll: 1,
    });

    $tabButtons.each(function (index) {
      $(this).on("click", function () {
        $tabButtons.removeClass("active");
        $(this).addClass("active");
        $slider.slick('slickGoTo', index);
      });
    });
  }
});

$('.btn').on('click', function () {
  const index = $(this).data('slide');
  $('.btn').removeClass('active');
  $(this).addClass('active');
  $('.tab_text_content .slider').slick('slickGoTo', index);
});



    $(document).on('click', '.cart_item_list .cart_product_item .remove_item', function(e){
      e.preventDefault();
      var remove_item_array = {};
      var remove_item_variant = parseInt($(this).attr('data-pro-id'));
      remove_item_array[remove_item_variant] = 0;
      
      if(jQuery.isEmptyObject(remove_item_array) == false){
        $.ajax({
          url: '/cart/update.js',
          type: 'POST',
          dataType: 'json',
          data:{ 
            updates: remove_item_array 
          },
          success:function(items) {
              cart_drawer();
          }
        });
      }
    })

$(document).ready(function(){
  if($('.custom_variant-swatch [data-variant-title="Pack of 2"]').length){
    $('.custom_variant-swatch [data-label-variant-title="Pack of 2"]').trigger('click')
  }

  if($('.template_custom-skincare-quiz').length || $('.template_custom-bodycare-quiz').length || $('.template_custom_quiz').length){
   if($('.selection-slide').length){
      //  window.navigation.addEventListener("navigate", (event) => {
      //    setTimeout(function(){
      //      var total_slide = $('.selection-slide').length - 3;
      //       if($('.selection-slide.slide_done').length < total_slide){
      //         var current_data_index = $($('.selection-slide:not(.slide_done)')[0]).attr('data-index');
      //         if (window.location.href.indexOf("#") > -1){
      //           var split_value = window.location.href.split('#');
      //           window.location.href = split_value[0] + '#slide-'+current_data_index;
      //         }
      //       }
      //    }, 1000);
      // });
      setTimeout(function(){
        var total_slide = $('.selection-slide').length - 4;
        if($('.selection-slide.slide_done').length < total_slide){
          var current_data_index = $($('.selection-slide:not(.slide_done)')[0]).attr('data-index');
          if (window.location.href.indexOf("#") > -1){
            var split_value = window.location.href.split('#');
            location.href = split_value[0] + '#slide-'+current_data_index;
          }
        }
      }, 1000);
    }
  }
})